/* Note: This is an autogenerated file. Please DO NOT modify anything manually here. */
// `@graphql-codegen/typescript` v6 stopped emitting the `Exact` helper, but
// `near-operation-file-preset` (pinned at v5) still emits `Types.Exact`
// references into every *.generated.ts operations file, which breaks the
// build. Re-add it here until the preset catches up.
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: string; output: string; }
  JSON: { input: unknown; output: unknown; }
  JSONObject: { input: unknown; output: unknown; }
  PageRange: { input: unknown; output: unknown; }
  PositiveInt: { input: number; output: number; }
};

export type GQLAddCommentInput = {
  checklistItemId: Scalars['ID']['input'];
  comment: Scalars['String']['input'];
  documentId?: InputMaybe<Scalars['ID']['input']>;
  documentVersionId?: InputMaybe<Scalars['ID']['input']>;
};

export type GQLAddDocumentInputInput = {
  documentId: Scalars['ID']['input'];
  input: GQLInputInput;
  pageId: Scalars['ID']['input'];
};

export type GQLAddDocumentsForUploadToInteractionInput = {
  documents: Array<GQLDocumentForUpload>;
};

export type GQLAddDocumentsForUploadToInteractionPayload = GQLMutationPayload & {
  __typename?: 'AddDocumentsForUploadToInteractionPayload';
  documents: Maybe<Array<GQLInteractionDocumentUploadDetails>>;
  errors: Maybe<Array<GQLMutationProblem>>;
  query: Maybe<GQLQuery>;
  status: GQLMutationStatus;
};

export type GQLAddDocumentsToInteractionInput = {
  /**
   * A list of Document Template IDs to add.
   * Optional if the `propertyOptionGroups` parameter is included.
   */
  documents?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * A list of Property Option Group IDs to add.
   * Optional if the `documents` parameter is included.
   */
  propertyOptionGroups?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** An optional list of User Template IDs to add. */
  userTemplates?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type GQLAddDocumentsToInteractionPayload = GQLMutationPayload & {
  __typename?: 'AddDocumentsToInteractionPayload';
  errors: Maybe<Array<GQLMutationProblem>>;
  query: Maybe<GQLQuery>;
  record: Maybe<GQLInteraction>;
  status: Maybe<GQLMutationStatus>;
};

export type GQLAddIdentityTeamMemberContactInput = {
  cellPhone?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street1?: InputMaybe<Scalars['String']['input']>;
  street2?: InputMaybe<Scalars['String']['input']>;
  titleNumber?: InputMaybe<Scalars['String']['input']>;
  type: GQLIdentityTeamMemberContactType;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type GQLAddInputPayload = GQLMutationPayload & {
  __typename?: 'AddInputPayload';
  errors: Maybe<Array<GQLMutationProblem>>;
  query: Maybe<GQLQuery>;
  record: Maybe<GQLInteractionDocumentInput>;
  status: Maybe<GQLMutationStatus>;
};

export type GQLAddNoteInput = {
  content: Scalars['String']['input'];
  documentId?: InputMaybe<Scalars['ID']['input']>;
  documentVersionId?: InputMaybe<Scalars['ID']['input']>;
  itemId?: InputMaybe<Scalars['ID']['input']>;
};

export type GQLAddress = {
  __typename?: 'Address';
  city: Maybe<Scalars['String']['output']>;
  county: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  street1: Maybe<Scalars['String']['output']>;
  street2: Maybe<Scalars['String']['output']>;
  zip: Maybe<Scalars['String']['output']>;
};

export type GQLAdjustment = GQLNode & {
  __typename?: 'Adjustment';
  id: Scalars['ID']['output'];
};

export type GQLAdjustmentMutationPayload = GQLMutationPayload & {
  __typename?: 'AdjustmentMutationPayload';
  errors: Maybe<Array<GQLMutationProblem>>;
  query: GQLQuery;
  record: Maybe<GQLAdjustment>;
  status: GQLMutationStatus;
};

export type GQLAdminTransaction = GQLNode & {
  __typename?: 'AdminTransaction';
  address: GQLTransactionAddress;
  closeDate: Maybe<Scalars['String']['output']>;
  colistCommissions: Array<GQLAdminTransaction>;
  commissionStatus: Maybe<GQLCommissionStatus>;
  escrowAmount: Maybe<Scalars['Float']['output']>;
  externalId: Scalars['ID']['output'];
  finalizedBy: Maybe<GQLFinalizedBy>;
  hasInstallmentPayments: Scalars['Boolean']['output'];
  id: Maybe<Scalars['ID']['output']>;
  installmentCommissions: Array<GQLAdminTransaction>;
  interactionId: Maybe<Scalars['ID']['output']>;
  isCoList: Scalars['Boolean']['output'];
  isInstallment: Scalars['Boolean']['output'];
  isOriginalCoList: Scalars['Boolean']['output'];
  isOriginalInstallment: Scalars['Boolean']['output'];
  lastSubmittedAt: Maybe<Scalars['String']['output']>;
  parentCommission: Maybe<GQLAdminTransaction>;
  paymentStatus: Maybe<GQLPaymentStatus>;
  /** @deprecated use finalizedBy instead */
  reconciledBy: Maybe<GQLReconciledBy>;
  side: Maybe<GQLTransactionSide>;
  startingGrossCommission: Maybe<Scalars['Float']['output']>;
  status: Maybe<GQLTransactionStatus>;
  team: Maybe<GQLTransactionTeam>;
  type: Maybe<GQLPaymentTransactionType>;
};

export type GQLAdminTransactionsPaginationResult = GQLPaginationResponse & {
  __typename?: 'AdminTransactionsPaginationResult';
  items: Array<GQLAdminTransaction>;
  pageInfo: GQLPaginationPageInfo;
};

export type GQLAllocationGross = {
  __typename?: 'AllocationGross';
  agent: Maybe<Scalars['Float']['output']>;
  brokerage: Maybe<Scalars['Float']['output']>;
  parentTeam: Maybe<Scalars['Float']['output']>;
  team: Maybe<Scalars['Float']['output']>;
};

export type GQLAllocationTax = {
  __typename?: 'AllocationTax';
  agentAmount: Maybe<Scalars['Float']['output']>;
  parentTeamAmount: Maybe<Scalars['Float']['output']>;
  teamAmount: Maybe<Scalars['Float']['output']>;
};

export enum GQLAppFeature {
  /** @deprecated Access is always granted; clients no longer need to check this feature. */
  COMMUNITY_LISTINGS = 'COMMUNITY_LISTINGS',
  LEASES = 'LEASES'
}

export type GQLApproveCompanyInput = {
  company: GQLApproveCompanyStatusInput;
  contact: GQLSettlementContactV2UpdateInput;
};

export type GQLApproveCompanyStatusInput = {
  status?: InputMaybe<GQLSettlementCompanyStatus>;
};

export type GQLApproveDocumentInput = {
  documentId: Scalars['ID']['input'];
};

export type GQLAssignBrokersInput = {
  brokers: Array<GQLAssignedBrokerInfoInput>;
  groupEmail?: InputMaybe<Scalars['String']['input']>;
  reason: Scalars['String']['input'];
};

export type GQLAssignedBrokerInfoInput = {
  email: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type GQLAssociatedChecklistItemTemplateVersionV2 = {
  __typename?: 'AssociatedChecklistItemTemplateVersionV2';
  checklistTemplates: Maybe<Array<GQLChecklistTemplateVersionV2>>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['ID']['output'];
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  itemTemplateId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  publishedAt: Maybe<Scalars['DateTime']['output']>;
  publishedBy: Maybe<Scalars['ID']['output']>;
  required: Scalars['Boolean']['output'];
  riskLevel: GQLRiskLevel;
  rules: Array<GQLTemplateRuleV2>;
  status: GQLVersionStatus;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['ID']['output'];
  versionNumber: Scalars['Int']['output'];
};


export type GQLAssociatedChecklistItemTemplateVersionV2rulesArgs = {
  input: InputMaybe<GQLTemplateRuleListV2Params>;
};

export type GQLAttachmentInput = {
  name: Scalars['String']['input'];
  size: Scalars['Int']['input'];
  type: Scalars['String']['input'];
};

export type GQLAttentionItemPaginationInput = {
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
};

export type GQLAudit = {
  __typename?: 'Audit';
  assignableChecklistTemplates: GQLChecklistTemplateOptionsConnection;
  assignedBrokers: Maybe<Array<Scalars['ID']['output']>>;
  availableStages: Array<GQLAuditStage>;
  availableStatuses: Array<GQLAuditStatus>;
  /** @deprecated Use Audit.cancelationChecklists instead */
  cancelationChecklist: Maybe<GQLChecklist>;
  cancelationChecklists: Array<GQLChecklist>;
  checklist: Maybe<GQLChecklist>;
  checklistVersion: GQLChecklistVersion;
  completedInteractionDocuments: Array<GQLCompletedInteractionDocument>;
  createdAt: Scalars['String']['output'];
  cursors: GQLAuditCursors;
  document: GQLAuditDocument;
  documents: Array<GQLAuditDocument>;
  documentsDownloadStatus: GQLDownloadAuditDocumentsJob;
  expeditedTransaction: Maybe<Scalars['Boolean']['output']>;
  expirationDate: Maybe<Scalars['String']['output']>;
  externalId: Maybe<Scalars['ID']['output']>;
  file: GQLAuditFile;
  historicalDisclosuresFound: Maybe<Scalars['Boolean']['output']>;
  historicalDisclosuresSent: Maybe<Scalars['Boolean']['output']>;
  history: GQLAuditHistoryConnection;
  id: Scalars['ID']['output'];
  /** @deprecated Use Audit.completedInteractionDocuments instead */
  interactionDocuments: Array<GQLInteractionDocument>;
  interactionId: Scalars['ID']['output'];
  interactionType: GQLAuditInteractionType;
  isAutoSubmitOn: Scalars['Boolean']['output'];
  isDraft: Scalars['Boolean']['output'];
  listingReviewed: Maybe<Scalars['Boolean']['output']>;
  notes: Array<GQLNote>;
  notifications: Array<GQLAuditNotification>;
  offerReviewed: Maybe<Scalars['Boolean']['output']>;
  pendingDocumentsCount: Maybe<Scalars['Int']['output']>;
  property: GQLProperty;
  proposedChecklistVersionId: Maybe<Scalars['ID']['output']>;
  reactivationChecklist: Maybe<GQLChecklist>;
  rejectedDocumentsCount: Maybe<Scalars['Int']['output']>;
  requiredItemsCount: Maybe<Scalars['Int']['output']>;
  stage: Maybe<GQLAuditStage>;
  status: GQLAuditStatus;
  submitAsDraft: Scalars['Boolean']['output'];
  totalSessionDuration: Maybe<Scalars['Int']['output']>;
  transaction: GQLAuditTransaction;
  txnEmail: Maybe<Scalars['String']['output']>;
};


export type GQLAuditassignableChecklistTemplatesArgs = {
  input: GQLChecklistTemplateOptionsInput;
};


export type GQLAuditcursorsArgs = {
  input: GQLAuditsListParams;
};


export type GQLAuditdocumentArgs = {
  id: Scalars['ID']['input'];
};


export type GQLAuditdocumentsArgs = {
  input: InputMaybe<GQLAuditDocumentsFilter>;
};


export type GQLAuditdocumentsDownloadStatusArgs = {
  jobId: Scalars['ID']['input'];
};


export type GQLAuditfileArgs = {
  id: Scalars['ID']['input'];
};


export type GQLAudithistoryArgs = {
  input: GQLAuditHistoryParams;
};


export type GQLAuditnotesArgs = {
  input: InputMaybe<GQLAuditNotesFilter>;
};

export type GQLAuditByInteractionIdInput = {
  interactionId: Scalars['ID']['input'];
  interactionType?: InputMaybe<GQLInteractionType>;
};

export type GQLAuditCursors = {
  __typename?: 'AuditCursors';
  next: Maybe<Scalars['String']['output']>;
  previous: Maybe<Scalars['String']['output']>;
};

export type GQLAuditDocument = {
  __typename?: 'AuditDocument';
  autoAssigned: Scalars['Boolean']['output'];
  comments: Array<GQLNote>;
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  createdByIdentityUser: Maybe<GQLIdentityUser>;
  id: Scalars['ID']['output'];
  interactionDocumentId: Maybe<Scalars['ID']['output']>;
  isDraft: Scalars['Boolean']['output'];
  itemId: Maybe<Scalars['ID']['output']>;
  latestVersion: GQLAuditDocumentVersion;
  name: Scalars['String']['output'];
  parentDocumentId: Maybe<Scalars['ID']['output']>;
  tags: Array<GQLAuditDocumentTag>;
  updatedAt: Scalars['String']['output'];
  updatedBy: Scalars['String']['output'];
  updatedByIdentityUser: Maybe<GQLIdentityUser>;
  version: GQLAuditDocumentVersion;
  versions: Array<GQLAuditDocumentVersion>;
};


export type GQLAuditDocumentversionArgs = {
  version: Scalars['Int']['input'];
};

export enum GQLAuditDocumentReviewStatus {
  CORRECT = 'CORRECT',
  INCORRECT = 'INCORRECT'
}

export enum GQLAuditDocumentStatus {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED'
}

export type GQLAuditDocumentTag = {
  __typename?: 'AuditDocumentTag';
  label: Scalars['String']['output'];
};

export type GQLAuditDocumentVersion = {
  __typename?: 'AuditDocumentVersion';
  acceptancePending: Scalars['Boolean']['output'];
  comments: Array<GQLNote>;
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  createdByIdentityUser: Maybe<GQLIdentityUser>;
  fileId: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  isDraft: Scalars['Boolean']['output'];
  reviewStatus: Maybe<GQLAuditDocumentReviewStatus>;
  status: GQLAuditDocumentStatus;
  targetTier: GQLTargetTier;
  uploadStatus: GQLFileUploadStatus;
  version: Scalars['Int']['output'];
};

export type GQLAuditDocumentsFilter = {
  checklistItemId?: InputMaybe<Scalars['String']['input']>;
  isAssigned?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GQLAuditFile = {
  __typename?: 'AuditFile';
  contentType: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  type: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type GQLAuditHistory = {
  __typename?: 'AuditHistory';
  action: GQLAuditHistoryAction;
  actionType: GQLAuditHistoryActionType;
  auditId: Scalars['ID']['output'];
  createdAt: Scalars['String']['output'];
  createdBy: Maybe<Scalars['String']['output']>;
  createdByIdentityUser: Maybe<GQLIdentityUser>;
  event: GQLAuditHistoryEvent;
  id: Scalars['ID']['output'];
  masqueraderId: Maybe<Scalars['String']['output']>;
  masqueraderIdentityUser: Maybe<GQLIdentityUser>;
};

export enum GQLAuditHistoryAction {
  AGENT_CHANGED = 'AGENT_CHANGED',
  AUDIT_ASSIGNED = 'AUDIT_ASSIGNED',
  CHECKLIST_DOCUMENTS_DOWNLOADED = 'CHECKLIST_DOCUMENTS_DOWNLOADED',
  CHECKLIST_ITEM_ADDED = 'CHECKLIST_ITEM_ADDED',
  CHECKLIST_ITEM_COMMENT = 'CHECKLIST_ITEM_COMMENT',
  CHECKLIST_ITEM_COMMENT_EDITED = 'CHECKLIST_ITEM_COMMENT_EDITED',
  CHECKLIST_ITEM_DELETED = 'CHECKLIST_ITEM_DELETED',
  CHECKLIST_ITEM_REQUIRED = 'CHECKLIST_ITEM_REQUIRED',
  CHECKLIST_ITEM_UNREQUIRED = 'CHECKLIST_ITEM_UNREQUIRED',
  CHECKLIST_TEMPLATE_CHANGED = 'CHECKLIST_TEMPLATE_CHANGED',
  CLOSING_DATE_CHANGED = 'CLOSING_DATE_CHANGED',
  COMMISSION_CHANGED = 'COMMISSION_CHANGED',
  COMMUNICATION_RECEIVED = 'COMMUNICATION_RECEIVED',
  COMMUNICATION_SENT = 'COMMUNICATION_SENT',
  CONTACTS_CHANGED = 'CONTACTS_CHANGED',
  COVERSHEET_UPDATED = 'COVERSHEET_UPDATED',
  DOCUMENT_ADDED = 'DOCUMENT_ADDED',
  DOCUMENT_APPROVED = 'DOCUMENT_APPROVED',
  DOCUMENT_ARCHIVED = 'DOCUMENT_ARCHIVED',
  DOCUMENT_ASSIGNED = 'DOCUMENT_ASSIGNED',
  DOCUMENT_COMMENTED = 'DOCUMENT_COMMENTED',
  DOCUMENT_COMMENT_EDITED = 'DOCUMENT_COMMENT_EDITED',
  DOCUMENT_DOWNLOADED = 'DOCUMENT_DOWNLOADED',
  DOCUMENT_REJECTED = 'DOCUMENT_REJECTED',
  DOCUMENT_SIGNATURE_REQUESTED = 'DOCUMENT_SIGNATURE_REQUESTED',
  DOCUMENT_UNASSIGNED = 'DOCUMENT_UNASSIGNED',
  DOCUMENT_VALIDATED = 'DOCUMENT_VALIDATED',
  DOCUMENT_VERSION_UPDATED = 'DOCUMENT_VERSION_UPDATED',
  DOCUMENT_VIEWED = 'DOCUMENT_VIEWED',
  EXPIRED_DATE_CHANGED = 'EXPIRED_DATE_CHANGED',
  HISTORICAL_DISCLOSURES_FOUND = 'HISTORICAL_DISCLOSURES_FOUND',
  HISTORICAL_DISCLOSURES_SENT = 'HISTORICAL_DISCLOSURES_SENT',
  LISTING_OPENED = 'LISTING_OPENED',
  NEW_LISTING = 'NEW_LISTING',
  NEW_TRANSACTION = 'NEW_TRANSACTION',
  NHD_REPORT_REQUESTED = 'NHD_REPORT_REQUESTED',
  NOTE_ADDED = 'NOTE_ADDED',
  NOTE_EDITED = 'NOTE_EDITED',
  REACTIVATED = 'REACTIVATED',
  REACTIVATION_REQUESTED = 'REACTIVATION_REQUESTED',
  REVERTED_TO_LISTING = 'REVERTED_TO_LISTING',
  STAGE_CHANGED = 'STAGE_CHANGED',
  STATUS_CHANGED = 'STATUS_CHANGED',
  SUBMISSION_BLOCKED = 'SUBMISSION_BLOCKED',
  TRANSACTION_OPENED = 'TRANSACTION_OPENED',
  TRANSFER_OWNER = 'TRANSFER_OWNER'
}

export enum GQLAuditHistoryActionType {
  CHECKLIST_ITEM = 'CHECKLIST_ITEM',
  DOCUMENT = 'DOCUMENT',
  EMAIL_RECEIVED = 'EMAIL_RECEIVED',
  EMAIL_SENT = 'EMAIL_SENT',
  LISTING = 'LISTING',
  TRANSACTION = 'TRANSACTION'
}

export type GQLAuditHistoryConnection = {
  __typename?: 'AuditHistoryConnection';
  edges: Array<GQLAuditHistoryEdge>;
  pageInfo: GQLPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GQLAuditHistoryDownloadParams = {
  filter?: InputMaybe<GQLAuditHistoryFilter>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortModel?: InputMaybe<Array<GQLDatagridSortModel>>;
};

export type GQLAuditHistoryEdge = {
  __typename?: 'AuditHistoryEdge';
  cursor: Scalars['String']['output'];
  node: GQLAuditHistory;
};

export type GQLAuditHistoryEvent = {
  __typename?: 'AuditHistoryEvent';
  comment: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  referenceId: Scalars['ID']['output'];
  referenceType: GQLAuditHistoryReference;
  valueAfter: Scalars['String']['output'];
  valueBefore: Scalars['String']['output'];
};

export type GQLAuditHistoryFile = {
  __typename?: 'AuditHistoryFile';
  name: Scalars['String']['output'];
  readOnlySignedUrl: Scalars['String']['output'];
};

export type GQLAuditHistoryFilter = {
  action?: InputMaybe<Array<GQLAuditHistoryAction>>;
  actionType?: InputMaybe<Array<GQLAuditHistoryActionType>>;
  createdAtFinish?: InputMaybe<Scalars['String']['input']>;
  createdAtStart?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GQLAuditHistoryParams = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<GQLAuditHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortModel?: InputMaybe<Array<GQLDatagridSortModel>>;
};

export enum GQLAuditHistoryReference {
  AUDIT = 'AUDIT',
  AUDIT_CHECKLIST_CATEGORY = 'AUDIT_CHECKLIST_CATEGORY',
  AUDIT_CHECKLIST_ITEM = 'AUDIT_CHECKLIST_ITEM',
  CONTACT = 'CONTACT',
  DOCUMENT = 'DOCUMENT',
  DOCUMENT_VERSION = 'DOCUMENT_VERSION',
  NOTE = 'NOTE'
}

export enum GQLAuditInteractionType {
  LEASE = 'LEASE',
  LISTING = 'LISTING',
  OFFER = 'OFFER'
}

export type GQLAuditJob = {
  id: Scalars['ID']['output'];
  percentComplete: Scalars['Int']['output'];
  status: GQLAuditJobStatus;
};

export enum GQLAuditJobStatus {
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  SUCCEEDED = 'SUCCEEDED'
}

export type GQLAuditMetadata = {
  __typename?: 'AuditMetadata';
  auditId: Scalars['ID']['output'];
  createdAt: Scalars['String']['output'];
  createdByIdentityUser: Maybe<GQLIdentityUser>;
  ownerIdentityUsers: Array<Maybe<GQLIdentityUser>>;
  stage: Maybe<GQLAuditStage>;
  status: GQLAuditStatus;
  updatedAt: Scalars['String']['output'];
  updatedByIdentityUser: Maybe<GQLIdentityUser>;
};

export type GQLAuditMutations = {
  __typename?: 'AuditMutations';
  addChecklistItem: GQLChecklist;
  addComment: GQLNote;
  addNote: GQLNote;
  approveCancelation: GQLAudit;
  approveDocument: GQLAuditDocumentVersion;
  approveReactivation: GQLAudit;
  assignBrokers: GQLAudit;
  assignDocument: GQLAuditDocument;
  assignInteractionDocument: GQLAuditDocument;
  cancel: GQLAudit;
  changeOwners: GQLAudit;
  clearProposedChecklist: GQLAudit;
  copyInteractionDocument: GQLAuditDocument;
  createAttachments: Array<GQLCreateAttachmentsResponse>;
  createAuditHistory: GQLAuditHistory;
  createDocument: GQLCreateDocumentResponse;
  downloadDocuments: GQLDownloadAuditDocumentsJob;
  editComment: GQLNote;
  editNote: GQLNote;
  escalateDocument: GQLAuditDocumentVersion;
  proposeChecklist: GQLAudit;
  publish: GQLAudit;
  reactivate: GQLAudit;
  registerViewer: GQLViewer;
  rejectDocument: GQLAuditDocumentVersion;
  removeChecklistItem: GQLChecklist;
  removeDocument: Scalars['Boolean']['output'];
  requestCancelation: GQLAudit;
  requestReactivation: GQLAudit;
  reviewDocument: GQLAuditDocumentVersion;
  sendUpdate: Scalars['Boolean']['output'];
  sessionCreate: GQLAudit;
  setAutoSubmit: GQLAudit;
  setChecklist: GQLAudit;
  setStage: GQLAudit;
  setStatus: GQLAudit;
  splitDocument: Array<GQLAuditDocument>;
  unassignBrokers: GQLAudit;
  unassignDocument: GQLAuditDocument;
  updateAuditInfo: GQLAudit;
  updateChecklistItem: GQLChecklistItem;
  updateCoversheet: Scalars['Boolean']['output'];
  updateEscrowDate: Scalars['Boolean']['output'];
  updateListingPrice: Scalars['Boolean']['output'];
  updateSalesPrice: Scalars['Boolean']['output'];
};


export type GQLAuditMutationsaddChecklistItemArgs = {
  checklistId: Scalars['ID']['input'];
  input: GQLCreateChecklistItemInput;
};


export type GQLAuditMutationsaddCommentArgs = {
  input: GQLAddCommentInput;
};


export type GQLAuditMutationsaddNoteArgs = {
  input: GQLAddNoteInput;
};


export type GQLAuditMutationsapproveDocumentArgs = {
  input: GQLApproveDocumentInput;
};


export type GQLAuditMutationsassignBrokersArgs = {
  input: GQLAssignBrokersInput;
};


export type GQLAuditMutationsassignDocumentArgs = {
  checklistItemId: Scalars['ID']['input'];
  documentId: Scalars['ID']['input'];
};


export type GQLAuditMutationsassignInteractionDocumentArgs = {
  checklistItemId: Scalars['ID']['input'];
  interactionDocumentId: Scalars['ID']['input'];
};


export type GQLAuditMutationscancelArgs = {
  input: GQLCancelAuditInput;
};


export type GQLAuditMutationschangeOwnersArgs = {
  ownerEmails: Array<Scalars['String']['input']>;
};


export type GQLAuditMutationscopyInteractionDocumentArgs = {
  interactionDocumentId: Scalars['ID']['input'];
};


export type GQLAuditMutationscreateAttachmentsArgs = {
  input: GQLCreateAttachmentsInput;
};


export type GQLAuditMutationscreateAuditHistoryArgs = {
  input: GQLCreateAuditHistoryInput;
};


export type GQLAuditMutationscreateDocumentArgs = {
  input: GQLCreateDocumentInput;
};


export type GQLAuditMutationsdownloadDocumentsArgs = {
  input: InputMaybe<GQLDownloadDocumentsInput>;
};


export type GQLAuditMutationseditCommentArgs = {
  input: GQLEditCommentInput;
};


export type GQLAuditMutationseditNoteArgs = {
  input: GQLEditNoteInput;
};


export type GQLAuditMutationsescalateDocumentArgs = {
  input: GQLEscalateDocumentInput;
};


export type GQLAuditMutationsproposeChecklistArgs = {
  checklistTemplateId: Scalars['ID']['input'];
};


export type GQLAuditMutationsrejectDocumentArgs = {
  input: GQLRejectDocumentInput;
};


export type GQLAuditMutationsremoveChecklistItemArgs = {
  checklistId: Scalars['ID']['input'];
  checklistItemId: Scalars['ID']['input'];
};


export type GQLAuditMutationsremoveDocumentArgs = {
  input: GQLRemoveDocumentInput;
};


export type GQLAuditMutationsrequestCancelationArgs = {
  input: InputMaybe<GQLRequestCancelationInput>;
};


export type GQLAuditMutationsreviewDocumentArgs = {
  input: GQLReviewDocumentInput;
};


export type GQLAuditMutationssendUpdateArgs = {
  input: GQLSendAuditUpdateInput;
};


export type GQLAuditMutationssessionCreateArgs = {
  input: GQLCreateAuditSessionInput;
};


export type GQLAuditMutationssetAutoSubmitArgs = {
  submitAsDraft: Scalars['Boolean']['input'];
};


export type GQLAuditMutationssetChecklistArgs = {
  checklistTemplateId: Scalars['ID']['input'];
};


export type GQLAuditMutationssetStageArgs = {
  stage: GQLAuditStage;
};


export type GQLAuditMutationssetStatusArgs = {
  reason: InputMaybe<Scalars['String']['input']>;
  status: GQLAuditStatus;
};


export type GQLAuditMutationssplitDocumentArgs = {
  input: GQLSplitDocumentInput;
};


export type GQLAuditMutationsunassignDocumentArgs = {
  documentId: Scalars['ID']['input'];
};


export type GQLAuditMutationsupdateAuditInfoArgs = {
  input: GQLUpdateAuditInfoInput;
};


export type GQLAuditMutationsupdateChecklistItemArgs = {
  checklistId: Scalars['ID']['input'];
  checklistItemId: Scalars['ID']['input'];
  input: GQLUpdateChecklistItemInput;
};


export type GQLAuditMutationsupdateCoversheetArgs = {
  input: InputMaybe<GQLUpdateCoversheetInput>;
};


export type GQLAuditMutationsupdateEscrowDateArgs = {
  input: GQLUpdateEscrowInput;
};


export type GQLAuditMutationsupdateListingPriceArgs = {
  input: GQLUpdateListingPriceInput;
};


export type GQLAuditMutationsupdateSalesPriceArgs = {
  input: GQLUpdateSalesPriceInput;
};

export type GQLAuditNotesFilter = {
  checklistItemId?: InputMaybe<Scalars['String']['input']>;
  documentId?: InputMaybe<Scalars['String']['input']>;
  documentVersionId?: InputMaybe<Scalars['String']['input']>;
  isAssigned?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GQLAuditNotification = {
  __typename?: 'AuditNotification';
  acknowledged: Scalars['Boolean']['output'];
  acknowledgedAt: Maybe<Scalars['String']['output']>;
  acknowledgedBy: Maybe<Scalars['String']['output']>;
  action: GQLAuditHistoryAction;
  categoryId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  event: GQLAuditHistoryEvent;
  itemId: Scalars['String']['output'];
  note: Maybe<Scalars['String']['output']>;
};

export type GQLAuditSession = {
  __typename?: 'AuditSession';
  duration: Scalars['Int']['output'];
  endTime: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  startTime: Scalars['DateTime']['output'];
};

export enum GQLAuditStage {
  BROKER_ACCEPTED = 'BROKER_ACCEPTED',
  BROKER_APPROVAL_TO_PAY = 'BROKER_APPROVAL_TO_PAY',
  BROKER_REVIEW = 'BROKER_REVIEW',
  CLOSING_HOLD = 'CLOSING_HOLD',
  COMPLIANCE_HOLD = 'COMPLIANCE_HOLD',
  FINAL_REVIEW = 'FINAL_REVIEW',
  IN_REVIEW = 'IN_REVIEW',
  LEASE_REVIEW_COMPLETED = 'LEASE_REVIEW_COMPLETED',
  LISTING_INITIAL_REVIEW = 'LISTING_INITIAL_REVIEW',
  LISTING_REVIEWED = 'LISTING_REVIEWED',
  OFFER_INITIAL_REVIEW = 'OFFER_INITIAL_REVIEW',
  READY_FOR_DRIP_CAMPAIGN = 'READY_FOR_DRIP_CAMPAIGN',
  SECOND_REVIEW = 'SECOND_REVIEW'
}

export enum GQLAuditStatus {
  ACTIVE_LISTING = 'ACTIVE_LISTING',
  ARCHIVED = 'ARCHIVED',
  CANCELATION_REQUESTED = 'CANCELATION_REQUESTED',
  CANCELED = 'CANCELED',
  CLOSED = 'CLOSED',
  CREATED = 'CREATED',
  PENDING = 'PENDING',
  REACTIVATION_REQUESTED = 'REACTIVATION_REQUESTED',
  TRANSACTION_CANCELATION_REQUESTED = 'TRANSACTION_CANCELATION_REQUESTED',
  TRANSFER = 'TRANSFER'
}

export type GQLAuditTransaction = {
  __typename?: 'AuditTransaction';
  acceptanceDate: Maybe<Scalars['String']['output']>;
  additionalBuyingCommissionAmount: Maybe<Scalars['Float']['output']>;
  additionalListingCommissionAmount: Maybe<Scalars['Float']['output']>;
  buyingCommissionAmount: Maybe<Scalars['Float']['output']>;
  buyingCommissionPercentage: Maybe<Scalars['Float']['output']>;
  closingDate: Maybe<Scalars['String']['output']>;
  contacts: Array<GQLContact>;
  contractDate: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  dualAgency: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isPersonalDeal: Maybe<Scalars['Boolean']['output']>;
  leadSourceName: Maybe<Scalars['String']['output']>;
  leadSourceNameSpecified: Maybe<Scalars['String']['output']>;
  leaseEndDate: Maybe<Scalars['DateTime']['output']>;
  leaseId: Maybe<Scalars['ID']['output']>;
  leaseMonthlyRentAmount: Maybe<Scalars['Float']['output']>;
  leasePaymentDate: Maybe<Scalars['DateTime']['output']>;
  leaseRepresentation: Maybe<GQLLeaseRepresentation>;
  leaseStartDate: Maybe<Scalars['DateTime']['output']>;
  leaseTotalRentAmount: Maybe<Scalars['Float']['output']>;
  listingCommissionAmount: Maybe<Scalars['Float']['output']>;
  listingCommissionPercentage: Maybe<Scalars['Float']['output']>;
  listingEndDate: Maybe<Scalars['String']['output']>;
  listingPrice: Maybe<Scalars['Float']['output']>;
  listingStartDate: Maybe<Scalars['String']['output']>;
  onMarketDate: Maybe<Scalars['String']['output']>;
  ownerIdentityUsers: Array<Maybe<GQLIdentityUser>>;
  owners: Array<Scalars['String']['output']>;
  property: GQLProperty;
  salesPrice: Maybe<Scalars['Float']['output']>;
  type: GQLAuditInteractionType;
  updatedAt: Scalars['String']['output'];
  updatedBy: Scalars['String']['output'];
};

export type GQLAuditable = {
  createdAt: Maybe<Scalars['String']['output']>;
  createdBy: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['String']['output']>;
  updatedBy: Maybe<Scalars['String']['output']>;
};

export type GQLAuditsListConnection = {
  __typename?: 'AuditsListConnection';
  edges: Array<GQLAuditsListEdge>;
  pageInfo: GQLPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GQLAuditsListEdge = {
  __typename?: 'AuditsListEdge';
  cursor: Scalars['String']['output'];
  node: GQLAudit;
};

export type GQLAuditsListFilter = {
  acceptanceDateFinish?: InputMaybe<Scalars['String']['input']>;
  acceptanceDateStart?: InputMaybe<Scalars['String']['input']>;
  client?: InputMaybe<Array<Scalars['String']['input']>>;
  closingDateFinish?: InputMaybe<Scalars['String']['input']>;
  closingDateStart?: InputMaybe<Scalars['String']['input']>;
  createdAtFinish?: InputMaybe<Scalars['String']['input']>;
  createdAtStart?: InputMaybe<Scalars['String']['input']>;
  hasPendingDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  hasRejectedDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  hasRequiredItems?: InputMaybe<Scalars['Boolean']['input']>;
  hideEscalated?: InputMaybe<Scalars['Boolean']['input']>;
  interactionType?: InputMaybe<GQLAuditInteractionType>;
  isClosingEmailProgramParticipant?: InputMaybe<Scalars['Boolean']['input']>;
  isExpired?: InputMaybe<Scalars['Boolean']['input']>;
  isSoonToBeExpired?: InputMaybe<Scalars['Boolean']['input']>;
  listingEndDateFinish?: InputMaybe<Scalars['String']['input']>;
  listingEndDateStart?: InputMaybe<Scalars['String']['input']>;
  needsAttention?: InputMaybe<Scalars['Boolean']['input']>;
  primaryAgent?: InputMaybe<Array<Scalars['String']['input']>>;
  reviewPriority?: InputMaybe<GQLReviewPriority>;
  showEscalated?: InputMaybe<Scalars['Boolean']['input']>;
  stage?: InputMaybe<Array<GQLAuditStage>>;
  state?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Array<GQLAuditStatus>>;
  team?: InputMaybe<Array<Scalars['String']['input']>>;
  transactionCoordinator?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAtFinish?: InputMaybe<Scalars['String']['input']>;
  updatedAtStart?: InputMaybe<Scalars['String']['input']>;
};

export type GQLAuditsListParams = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<GQLAuditsListFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeSessionDuration?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortModel?: InputMaybe<Array<GQLDatagridSortModel>>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type GQLAuditsMutations = {
  __typename?: 'AuditsMutations';
  createAudit: GQLAudit;
  setAuditsOwners: Array<GQLAudit>;
};


export type GQLAuditsMutationscreateAuditArgs = {
  input: GQLCreateAuditInput;
};


export type GQLAuditsMutationssetAuditsOwnersArgs = {
  input: GQLSetAuditsOwnersInput;
};

export enum GQLAutoTagStatus {
  ELIGIBLE = 'ELIGIBLE',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  NOT_ELIGIBLE = 'NOT_ELIGIBLE',
  PROCESSING = 'PROCESSING',
  SUCCEEDED = 'SUCCEEDED'
}

export type GQLBasicInteractionContactResponse = {
  __typename?: 'BasicInteractionContactResponse';
  avatar: Maybe<Scalars['String']['output']>;
  cellPhone: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastName: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  teamId: Maybe<Scalars['String']['output']>;
  type: GQLInteractionContactType;
  userId: Maybe<Scalars['String']['output']>;
};

export type GQLBatchCursorPaginationInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<InputMaybe<GQLFacetFilter>>>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GQLDatagridSortModel>>>;
};

export type GQLBrokerage = {
  __typename?: 'Brokerage';
  cellPhone: Maybe<Scalars['String']['output']>;
  city: Maybe<Scalars['String']['output']>;
  companyName: Maybe<Scalars['String']['output']>;
  county: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  fax: Maybe<Scalars['String']['output']>;
  jurisdiction: Maybe<Scalars['String']['output']>;
  licenseNumber: Maybe<Scalars['String']['output']>;
  mlsCode: Maybe<Scalars['String']['output']>;
  mlsId: Maybe<Scalars['String']['output']>;
  officeEmail: Maybe<Scalars['String']['output']>;
  phone: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  street1: Maybe<Scalars['String']['output']>;
  street2: Maybe<Scalars['String']['output']>;
  taxId: Maybe<Scalars['String']['output']>;
  zip: Maybe<Scalars['String']['output']>;
};

export type GQLBrokerageInput = {
  cellPhone?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  jurisdiction?: InputMaybe<Scalars['String']['input']>;
  licenseNumber?: InputMaybe<Scalars['String']['input']>;
  mlsCode?: InputMaybe<Scalars['String']['input']>;
  mlsId?: InputMaybe<Scalars['String']['input']>;
  officeEmail?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street1?: InputMaybe<Scalars['String']['input']>;
  street2?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type GQLBuyerAgreementsAttentionItem = GQLNeedsAttentionItem & {
  __typename?: 'BuyerAgreementsAttentionItem';
  clientGroup: GQLInteractionsPaginationResult;
  id: Scalars['String']['output'];
  interactionCount: Scalars['PositiveInt']['output'];
  interactions: Array<GQLInteraction>;
};


export type GQLBuyerAgreementsAttentionItemclientGroupArgs = {
  input: GQLAttentionItemPaginationInput;
};

export enum GQLBuyerRelationshipType {
  EXCLUSIVE = 'EXCLUSIVE',
  NON_EXCLUSIVE = 'NON_EXCLUSIVE'
}

export type GQLCancelAuditInput = {
  reason: Scalars['String']['input'];
  transaction?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GQLCertifyTransactionInput = {
  lastModifiedAt: Scalars['String']['input'];
};

export type GQLChangeCompanyNameInput = {
  company: GQLChangeCompanyNameStatusInput;
  contact: GQLSettlementContactV2UpdateInput;
};

export type GQLChangeCompanyNameStatusInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<GQLSettlementCompanyStatus>;
};

export type GQLChecklist = {
  __typename?: 'Checklist';
  categories: Array<GQLChecklistCategory>;
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  interactionType: Maybe<GQLAuditInteractionType>;
  item: GQLChecklistItem;
  items: Array<GQLChecklistItem>;
  name: Scalars['String']['output'];
  propertyType: Maybe<GQLPropertyType>;
  type: Maybe<GQLChecklistType>;
};


export type GQLChecklistitemArgs = {
  id: Scalars['ID']['input'];
  includeDrafts: InputMaybe<Scalars['Boolean']['input']>;
};


export type GQLChecklistitemsArgs = {
  includeDrafts: InputMaybe<Scalars['Boolean']['input']>;
};

export type GQLChecklistCategory = {
  __typename?: 'ChecklistCategory';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  transactionPhase: GQLTransactionPhase;
};

export type GQLChecklistItem = {
  __typename?: 'ChecklistItem';
  categoryId: Scalars['ID']['output'];
  comments: Array<GQLNote>;
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  createdByIdentityUser: Maybe<GQLIdentityUser>;
  description: Maybe<Scalars['String']['output']>;
  documentType: Maybe<GQLChecklistItemDocumentType>;
  documents: Array<GQLAuditDocument>;
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  parentId: Scalars['ID']['output'];
  status: Maybe<GQLChecklistItemDerivedStatus>;
  updatedAt: Scalars['String']['output'];
  updatedBy: Scalars['String']['output'];
  updatedByIdentityUser: Maybe<GQLIdentityUser>;
};

export enum GQLChecklistItemDerivedStatus {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED'
}

export enum GQLChecklistItemDocumentType {
  BUYER_AGREEMENT = 'BUYER_AGREEMENT',
  LEGAL_DESCRIPTION = 'LEGAL_DESCRIPTION',
  LISTING_AGREEMENT = 'LISTING_AGREEMENT',
  PRELIM_TITLE = 'PRELIM_TITLE',
  PURCHASE_CONTRACT = 'PURCHASE_CONTRACT',
  TAX_RECORD = 'TAX_RECORD'
}

export type GQLChecklistItemTemplateDocumentTemplate = {
  __typename?: 'ChecklistItemTemplateDocumentTemplate';
  documentTemplateId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  itemTemplateId: Scalars['ID']['output'];
};

export type GQLChecklistItemTemplateListV2Error = GQLNodeErrorPayload & {
  __typename?: 'ChecklistItemTemplateListV2Error';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  status: Scalars['Int']['output'];
};

export type GQLChecklistItemTemplateListV2Params = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<GQLItemTemplateListFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortModel?: InputMaybe<Array<GQLDatagridSortModel>>;
};

export type GQLChecklistItemTemplateListV2Result = GQLConnectionResult & {
  __typename?: 'ChecklistItemTemplateListV2Result';
  connection: Maybe<GQLChecklistItemTemplateV2Connection>;
  errors: Maybe<Array<GQLChecklistItemTemplateListV2Error>>;
};

export type GQLChecklistItemTemplateV2 = GQLNode & {
  __typename?: 'ChecklistItemTemplateV2';
  acceptWhenAutoAssigned: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  documentTemplates: Array<GQLChecklistItemTemplateDocumentTemplate>;
  documentType: Maybe<GQLChecklistItemDocumentType>;
  id: Scalars['ID']['output'];
  isTierOneEligible: Scalars['Boolean']['output'];
  latestVersion: GQLChecklistItemTemplateVersionV2;
  locale: Maybe<Scalars['String']['output']>;
  shouldAutoAssign: Scalars['Boolean']['output'];
  shouldValidateTemplate: Scalars['Boolean']['output'];
  transactionPhase: GQLTransactionPhase;
};

export type GQLChecklistItemTemplateV2Connection = GQLConnection & {
  __typename?: 'ChecklistItemTemplateV2Connection';
  edges: Array<GQLChecklistItemTemplateV2Edge>;
  pageInfo: GQLPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GQLChecklistItemTemplateV2Edge = GQLEdge & {
  __typename?: 'ChecklistItemTemplateV2Edge';
  cursor: Scalars['String']['output'];
  node: GQLChecklistItemTemplateV2;
};

export type GQLChecklistItemTemplateV2Error = GQLNodeErrorPayload & {
  __typename?: 'ChecklistItemTemplateV2Error';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  status: Scalars['Int']['output'];
};

export type GQLChecklistItemTemplateV2Mutations = {
  __typename?: 'ChecklistItemTemplateV2Mutations';
  addDocumentTemplate: GQLChecklistItemTemplateV2Result;
  delete: GQLChecklistItemTemplateV2Result;
  deleteDocumentTemplate: GQLChecklistItemTemplateV2Result;
  publish: GQLChecklistItemTemplateV2Result;
  update: GQLChecklistItemTemplateV2Result;
  version: GQLChecklistItemTemplateVersionV2Mutations;
  versionCreate: GQLChecklistItemTemplateV2Result;
};


export type GQLChecklistItemTemplateV2MutationsaddDocumentTemplateArgs = {
  documentTemplateId: Scalars['ID']['input'];
};


export type GQLChecklistItemTemplateV2MutationsdeleteDocumentTemplateArgs = {
  itemTemplateDocumentId: Scalars['ID']['input'];
};


export type GQLChecklistItemTemplateV2MutationsupdateArgs = {
  input: GQLUpdateChecklistItemTemplateV2Input;
};


export type GQLChecklistItemTemplateV2MutationsversionArgs = {
  id: Scalars['ID']['input'];
};


export type GQLChecklistItemTemplateV2MutationsversionCreateArgs = {
  input: GQLCreateChecklistItemTemplateVersionV2Input;
};

export type GQLChecklistItemTemplateV2Result = GQLNodeResult & {
  __typename?: 'ChecklistItemTemplateV2Result';
  errors: Maybe<Array<GQLChecklistItemTemplateV2Error>>;
  node: Maybe<GQLChecklistItemTemplateV2>;
};

export type GQLChecklistItemTemplateVersionV2 = GQLNode & {
  __typename?: 'ChecklistItemTemplateVersionV2';
  checklistTemplates: Maybe<Array<GQLChecklistTemplateVersionV2>>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['ID']['output'];
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  itemTemplateId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  publishedAt: Maybe<Scalars['DateTime']['output']>;
  publishedBy: Maybe<Scalars['ID']['output']>;
  riskLevel: GQLRiskLevel;
  rules: Array<GQLTemplateRuleV2>;
  status: GQLVersionStatus;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['ID']['output'];
  versionNumber: Scalars['Int']['output'];
};


export type GQLChecklistItemTemplateVersionV2rulesArgs = {
  input: InputMaybe<GQLTemplateRuleListV2Params>;
};

export type GQLChecklistItemTemplateVersionV2Error = GQLNodeErrorPayload & {
  __typename?: 'ChecklistItemTemplateVersionV2Error';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  status: Scalars['Int']['output'];
};

export type GQLChecklistItemTemplateVersionV2Mutations = {
  __typename?: 'ChecklistItemTemplateVersionV2Mutations';
  delete: GQLChecklistItemTemplateV2Result;
  update: GQLChecklistItemTemplateVersionV2Result;
};


export type GQLChecklistItemTemplateVersionV2MutationsupdateArgs = {
  input: GQLUpdateChecklistItemTemplateVersionV2Input;
};

export type GQLChecklistItemTemplateVersionV2Result = GQLNodeResult & {
  __typename?: 'ChecklistItemTemplateVersionV2Result';
  errors: Maybe<Array<GQLChecklistItemTemplateVersionV2Error>>;
  node: Maybe<GQLChecklistItemTemplateVersionV2>;
};

export type GQLChecklistTemplateDraft = GQLNode & {
  __typename?: 'ChecklistTemplateDraft';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type GQLChecklistTemplateDraftsV2Edge = GQLEdge & {
  __typename?: 'ChecklistTemplateDraftsV2Edge';
  cursor: Scalars['String']['output'];
  node: GQLChecklistTemplateDraft;
};

export type GQLChecklistTemplateListV2Error = GQLNodeErrorPayload & {
  __typename?: 'ChecklistTemplateListV2Error';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  status: Scalars['Int']['output'];
};

export type GQLChecklistTemplateListV2Filter = {
  interactionType?: InputMaybe<GQLInteractionType>;
  locale?: InputMaybe<Scalars['String']['input']>;
  propertyType?: InputMaybe<GQLPropertyType>;
  status?: InputMaybe<Array<GQLVersionStatus>>;
};

export type GQLChecklistTemplateListV2Params = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<GQLChecklistTemplateListV2Filter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortModel?: InputMaybe<Array<GQLDatagridSortModel>>;
};

export type GQLChecklistTemplateListV2Result = GQLConnectionResult & {
  __typename?: 'ChecklistTemplateListV2Result';
  connection: Maybe<GQLChecklistTemplateV2Connection>;
  errors: Maybe<Array<GQLChecklistTemplateV2Error>>;
};

export type GQLChecklistTemplateOption = {
  __typename?: 'ChecklistTemplateOption';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type GQLChecklistTemplateOptionEdge = {
  __typename?: 'ChecklistTemplateOptionEdge';
  cursor: Scalars['String']['output'];
  node: GQLChecklistTemplateOption;
};

export type GQLChecklistTemplateOptionsConnection = {
  __typename?: 'ChecklistTemplateOptionsConnection';
  edges: Array<GQLChecklistTemplateOptionEdge>;
  pageInfo: GQLPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GQLChecklistTemplateOptionsInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type GQLChecklistTemplateV2 = GQLNode & {
  __typename?: 'ChecklistTemplateV2';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  interactionType: GQLInteractionType;
  latestVersion: GQLChecklistTemplateVersionV2;
  locale: Maybe<Scalars['String']['output']>;
  propertyType: GQLPropertyType;
};

export type GQLChecklistTemplateV2Connection = GQLConnection & {
  __typename?: 'ChecklistTemplateV2Connection';
  edges: Array<GQLChecklistTemplateV2Edge>;
  pageInfo: GQLPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GQLChecklistTemplateV2Edge = GQLEdge & {
  __typename?: 'ChecklistTemplateV2Edge';
  cursor: Scalars['String']['output'];
  node: GQLChecklistTemplateV2;
};

export type GQLChecklistTemplateV2Error = GQLNodeErrorPayload & {
  __typename?: 'ChecklistTemplateV2Error';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  status: Scalars['Int']['output'];
};

export type GQLChecklistTemplateV2Mutations = {
  __typename?: 'ChecklistTemplateV2Mutations';
  delete: GQLChecklistTemplateV2Result;
  publish: GQLChecklistTemplateV2Result;
  update: GQLChecklistTemplateV2Result;
  version: GQLChecklistTemplateVersionV2Mutations;
  versionCreate: GQLChecklistTemplateV2Result;
};


export type GQLChecklistTemplateV2MutationsupdateArgs = {
  input: GQLUpdateChecklistTemplateV2Input;
};


export type GQLChecklistTemplateV2MutationsversionArgs = {
  id: Scalars['ID']['input'];
};


export type GQLChecklistTemplateV2MutationsversionCreateArgs = {
  input: GQLCreateChecklistTemplateVersionV2Input;
};

export type GQLChecklistTemplateV2Result = GQLNodeResult & {
  __typename?: 'ChecklistTemplateV2Result';
  errors: Maybe<Array<GQLChecklistTemplateV2Error>>;
  node: Maybe<GQLChecklistTemplateV2>;
};

export type GQLChecklistTemplateVersionV2 = GQLNode & {
  __typename?: 'ChecklistTemplateVersionV2';
  categories: Array<GQLTemplateVersionCategoryV2>;
  checklistTemplateId: Scalars['ID']['output'];
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  interactionType: Maybe<GQLInteractionType>;
  name: Scalars['String']['output'];
  rules: Array<GQLTemplateRuleV2>;
  status: GQLVersionStatus;
  updatedAt: Scalars['DateTime']['output'];
  versionNumber: Scalars['Int']['output'];
};


export type GQLChecklistTemplateVersionV2rulesArgs = {
  input: InputMaybe<GQLTemplateRuleListV2Params>;
};

export type GQLChecklistTemplateVersionV2Error = GQLNodeErrorPayload & {
  __typename?: 'ChecklistTemplateVersionV2Error';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  status: Scalars['Int']['output'];
};

export type GQLChecklistTemplateVersionV2Mutations = {
  __typename?: 'ChecklistTemplateVersionV2Mutations';
  delete: GQLDeleteChecklistTemplateVersionV2Result;
  itemAssign: GQLChecklistTemplateVersionV2Result;
  itemUnassign: GQLChecklistTemplateVersionV2Result;
  itemUpdate: GQLChecklistTemplateVersionV2Result;
  update: GQLChecklistTemplateVersionV2Result;
};


export type GQLChecklistTemplateVersionV2MutationsitemAssignArgs = {
  input: Array<GQLItemAssignV2Input>;
};


export type GQLChecklistTemplateVersionV2MutationsitemUnassignArgs = {
  input: GQLItemUnassignV2Input;
};


export type GQLChecklistTemplateVersionV2MutationsitemUpdateArgs = {
  input: GQLItemRelationUpdateV2Input;
};


export type GQLChecklistTemplateVersionV2MutationsupdateArgs = {
  input: GQLUpdateChecklistTemplateVersionV2Input;
};

export type GQLChecklistTemplateVersionV2Result = GQLNodeResult & {
  __typename?: 'ChecklistTemplateVersionV2Result';
  errors: Maybe<Array<GQLChecklistTemplateVersionV2Error>>;
  node: Maybe<GQLChecklistTemplateVersionV2>;
};

export type GQLChecklistTemplatesDraftsV2Connection = GQLConnection & {
  __typename?: 'ChecklistTemplatesDraftsV2Connection';
  edges: Array<GQLChecklistTemplateDraftsV2Edge>;
  pageInfo: GQLPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GQLChecklistTemplatesDraftsV2Error = GQLNodeErrorPayload & {
  __typename?: 'ChecklistTemplatesDraftsV2Error';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  status: Scalars['Int']['output'];
};

export type GQLChecklistTemplatesDraftsV2Result = GQLConnectionResult & {
  __typename?: 'ChecklistTemplatesDraftsV2Result';
  connection: Maybe<GQLChecklistTemplatesDraftsV2Connection>;
  errors: Maybe<Array<GQLChecklistTemplatesDraftsV2Error>>;
};

export enum GQLChecklistType {
  CANCELATION = 'CANCELATION',
  MAIN = 'MAIN',
  REACTIVATION = 'REACTIVATION'
}

export enum GQLChecklistVersion {
  CHECKLIST_V1 = 'CHECKLIST_V1',
  CHECKLIST_V2 = 'CHECKLIST_V2'
}

export type GQLClientGroup = GQLInteraction & GQLNode & {
  __typename?: 'ClientGroup';
  acceptedOfferId: Maybe<Scalars['String']['output']>;
  agents: Array<GQLInteractionContactAgent>;
  agreementStatus: Maybe<GQLClientGroupAgreementStatus>;
  basicContacts: Maybe<Array<GQLBasicInteractionContactResponse>>;
  bindingAgreementDate: Maybe<Scalars['String']['output']>;
  clients: Array<GQLInteractionContactOther>;
  closingDate: Maybe<Scalars['String']['output']>;
  contactSuggestion: GQLContactSuggestion;
  /** A paginated list of contacts associated with the ContractGroup. */
  contacts: Maybe<Array<Maybe<GQLInteractionContact>>>;
  contractDate: Maybe<Scalars['String']['output']>;
  coverPhotoFileId: Maybe<Scalars['String']['output']>;
  coverPhotoUrl: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  displayPrice: Maybe<Scalars['Float']['output']>;
  displayStatus: GQLInteractionStatus;
  document: Maybe<GQLInteractionDocument>;
  documentPreview: GQLInteractionDocument;
  /**
   * The list of documents for the ClientGroup
   * with optional filters by status
   */
  documents: Maybe<GQLInteractionDocumentsConnection>;
  endDate: Maybe<Scalars['DateTime']['output']>;
  /** Get an Envelope for a ClientGroup */
  envelope: Maybe<GQLEnvelope>;
  /** Get a list of Envelopes for a ClientGroup */
  envelopes: Maybe<Array<Maybe<GQLEnvelope>>>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  isIntermediary: Scalars['Boolean']['output'];
  listingEndDate: Maybe<Scalars['String']['output']>;
  listingStartDate: Maybe<Scalars['String']['output']>;
  onMarketDate: Maybe<Scalars['String']['output']>;
  owner: Scalars['String']['output'];
  property: Maybe<GQLPropertyAddress>;
  referral: Maybe<GQLReferral>;
  /** Get a list of Envelopes in a Sent state (with status `partiallySigned`, `voided`, `completed`, `created`, `sent`, or `sending`) */
  sentEnvelopes: Maybe<Array<Maybe<GQLEnvelope>>>;
  sidebarUi: GQLInteractionSidebarItemsConnection;
  startDate: Maybe<Scalars['DateTime']['output']>;
  /** The account preference contact for syncing */
  syncContact: Maybe<GQLInteractionDefaultContact>;
  teamId: Maybe<Scalars['String']['output']>;
  transactions: Array<GQLTransaction>;
};


export type GQLClientGroupcontactSuggestionArgs = {
  input: GQLInteractionContactSuggestionInput;
};


export type GQLClientGroupcontactsArgs = {
  input: InputMaybe<GQLInteractionContactsInput>;
};


export type GQLClientGroupdocumentArgs = {
  id: Scalars['ID']['input'];
};


export type GQLClientGroupdocumentPreviewArgs = {
  documentVersionId: Scalars['ID']['input'];
};


export type GQLClientGroupdocumentsArgs = {
  input: InputMaybe<GQLInteractionDocumentsInput>;
};


export type GQLClientGroupenvelopeArgs = {
  input: GQLGetEnvelopeInput;
};


export type GQLClientGroupenvelopesArgs = {
  input: InputMaybe<GQLGetEnvelopesInput>;
};


export type GQLClientGroupsentEnvelopesArgs = {
  input: InputMaybe<GQLGetEnvelopesInput>;
};


export type GQLClientGroupsyncContactArgs = {
  input: GQLInteractionSyncContactInput;
};

export enum GQLClientGroupAgreementStatus {
  completed = 'completed',
  created = 'created',
  declined = 'declined',
  delivered = 'delivered',
  failed = 'failed',
  notFinalized = 'notFinalized',
  notSent = 'notSent',
  partiallySigned = 'partiallySigned',
  sending = 'sending',
  sent = 'sent',
  voided = 'voided'
}

export type GQLCoListMutationPayload = GQLMutationPayload & {
  __typename?: 'CoListMutationPayload';
  errors: Maybe<Array<GQLMutationProblem>>;
  query: GQLQuery;
  record: Maybe<Array<GQLAdminTransaction>>;
  status: GQLMutationStatus;
};

export type GQLCommission = GQLNode & {
  __typename?: 'Commission';
  address: GQLCommissionAddress;
  allocations: Array<GQLCommissionAllocation>;
  closeDate: Maybe<Scalars['String']['output']>;
  commissionStatus: Maybe<GQLCommissionStatus>;
  commissionSystem: GQLCommissionSystem;
  hasBeenSubmitted: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  interactionId: Maybe<Scalars['ID']['output']>;
  me: GQLCommissionProfile;
  paymentStatus: GQLPaymentStatus;
  representing: GQLRepresenting;
  team: Maybe<GQLCommissionTeam>;
  transactionStatus: GQLTransactionStatus;
  type: Maybe<GQLPaymentTransactionType>;
};

export type GQLCommissionAddress = {
  __typename?: 'CommissionAddress';
  city: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  street: Maybe<Scalars['String']['output']>;
  street2: Maybe<Scalars['String']['output']>;
  zip: Maybe<Scalars['String']['output']>;
};

export type GQLCommissionAllocation = GQLNode & {
  __typename?: 'CommissionAllocation';
  agent: GQLCommissionTeamMember;
  id: Scalars['ID']['output'];
};

export type GQLCommissionFormAttentionItem = GQLNeedsAttentionItem & {
  __typename?: 'CommissionFormAttentionItem';
  commissions: Array<GQLCommission>;
  id: Scalars['String']['output'];
  /** Indicates that one of the commissons has instant pay eligibility */
  instantPayEligible: Scalars['Boolean']['output'];
  /** Number of interactions with commissions requiring attention */
  interactionCount: Scalars['PositiveInt']['output'];
  /** Number of commissions that have not been submitted */
  notSubmittedCount: Scalars['PositiveInt']['output'];
  /** Number of commissions that are awaiting certification */
  readyToCertifyCount: Scalars['PositiveInt']['output'];
};

export type GQLCommissionLeadSourceProfiles = {
  __typename?: 'CommissionLeadSourceProfiles';
  leadSource: GQLTransactionCommissionLeadSource;
  profileIds: Array<Scalars['String']['output']>;
};

export type GQLCommissionNotification = GQLAuditable & GQLNode & {
  __typename?: 'CommissionNotification';
  createdAt: Maybe<Scalars['String']['output']>;
  createdBy: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  recipients: Array<GQLCommissionNotificationRecipient>;
  subject: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt: Maybe<Scalars['String']['output']>;
  updatedBy: Maybe<Scalars['String']['output']>;
  wasManuallyTriggered: Scalars['Boolean']['output'];
};

export type GQLCommissionNotificationRecipient = GQLAuditable & GQLNode & {
  __typename?: 'CommissionNotificationRecipient';
  createdAt: Maybe<Scalars['String']['output']>;
  createdBy: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  failedReason: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAt: Maybe<Scalars['String']['output']>;
  updatedBy: Maybe<Scalars['String']['output']>;
};

export type GQLCommissionNotificationsInput = {
  commissionId: Scalars['ID']['input'];
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  sort?: InputMaybe<Array<GQLDatagridSortModel>>;
};

export type GQLCommissionNotificationsPaginationResult = GQLPaginationResponse & {
  __typename?: 'CommissionNotificationsPaginationResult';
  items: Array<GQLCommissionNotification>;
  pageInfo: GQLPaginationPageInfo;
};

export type GQLCommissionParty = {
  id: Maybe<Scalars['ID']['output']>;
  type: GQLCommissionPartyType;
};

/** Commission Models */
export enum GQLCommissionPartyType {
  BROKERAGE = 'BROKERAGE',
  EXTERNAL_AGENT = 'EXTERNAL_AGENT',
  EXTERNAL_BROKERAGE = 'EXTERNAL_BROKERAGE',
  EXTERNAL_COMPANY = 'EXTERNAL_COMPANY',
  EXTERNAL_PERSON = 'EXTERNAL_PERSON',
  OUTSIDE_BROKERAGE = 'OUTSIDE_BROKERAGE',
  PROFILE = 'PROFILE',
  REAL_ESTATE_SERVICES = 'REAL_ESTATE_SERVICES',
  REFERRAL_COMPANY = 'REFERRAL_COMPANY',
  SETTLEMENT_COMPANY = 'SETTLEMENT_COMPANY',
  SETTLEMENT_CONTACT = 'SETTLEMENT_CONTACT',
  TEAM = 'TEAM',
  TEAM_MEMBER = 'TEAM_MEMBER'
}

/**
 * We can extend this as needed in the future.
 * For now just need to be able to do canForProfile checks.
 */
export type GQLCommissionProfile = {
  __typename?: 'CommissionProfile';
  additionalPermissions: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  role: Maybe<GQLTransactionProfileRoleType>;
};

export enum GQLCommissionStatus {
  ADJUSTMENT_COMPUTED = 'ADJUSTMENT_COMPUTED',
  ADJUSTMENT_SUBMITTED = 'ADJUSTMENT_SUBMITTED',
  COMPUTED = 'COMPUTED',
  CREATED = 'CREATED',
  DRAFT = 'DRAFT',
  FINAL_COMPUTED = 'FINAL_COMPUTED',
  FINAL_LOCKED = 'FINAL_LOCKED',
  FINAL_STATEMENT_GENERATED = 'FINAL_STATEMENT_GENERATED',
  FINAL_SUBMITTED = 'FINAL_SUBMITTED',
  LOCKED = 'LOCKED',
  NEW = 'NEW',
  STATEMENT_GENERATED = 'STATEMENT_GENERATED',
  SUBMITTED = 'SUBMITTED',
  TAXES_GENERATED = 'TAXES_GENERATED'
}

export type GQLCommissionSummary = {
  __typename?: 'CommissionSummary';
  agentCommission: Maybe<Scalars['Float']['output']>;
  agentGross: Maybe<Scalars['Float']['output']>;
  brokerageCommission: Maybe<Scalars['Float']['output']>;
  brokerageGross: Maybe<Scalars['Float']['output']>;
  escrowAmount: Maybe<Scalars['Float']['output']>;
  parentTeamCommission: Maybe<Scalars['Float']['output']>;
  parentTeamGross: Maybe<Scalars['Float']['output']>;
  parentTeamTaxAmount: Maybe<Scalars['Float']['output']>;
  /** @deprecated field removed */
  parentTeamYearToDate: Maybe<GQLYearToDate>;
  teamCommission: Maybe<Scalars['Float']['output']>;
  teamGross: Maybe<Scalars['Float']['output']>;
  teamTaxAmount: Maybe<Scalars['Float']['output']>;
  /** @deprecated field removed */
  teamYearToDate: Maybe<GQLYearToDate>;
};

export enum GQLCommissionSystem {
  BROKERMINT = 'BROKERMINT',
  SAP = 'SAP',
  SIDE = 'SIDE',
  UNKNOWN = 'UNKNOWN'
}

export type GQLCommissionTeam = GQLCommissionParty & GQLNode & {
  __typename?: 'CommissionTeam';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type: GQLCommissionPartyType;
  useSideInstantPay: Scalars['Boolean']['output'];
};

export type GQLCommissionTeamMember = GQLCommissionParty & GQLNode & {
  __typename?: 'CommissionTeamMember';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type: GQLCommissionPartyType;
};

export enum GQLCommissionType {
  AMOUNT = 'AMOUNT',
  PERCENTAGE = 'PERCENTAGE',
  PERCENTAGE_ALL_COMMISSIONS = 'PERCENTAGE_ALL_COMMISSIONS',
  PERCENTAGE_LISTING_COMMISSION = 'PERCENTAGE_LISTING_COMMISSION',
  PERCENTAGE_PURCHASE_COMMISSION = 'PERCENTAGE_PURCHASE_COMMISSION'
}

export type GQLCommissionsFacets = {
  __typename?: 'CommissionsFacets';
  paymentStatusGroup: Array<GQLPaymentStatusGroupFacetEntry>;
};

export type GQLCommissionsPaginationResult = GQLPaginationResponse & {
  __typename?: 'CommissionsPaginationResult';
  facets: Maybe<GQLCommissionsFacets>;
  items: Array<GQLCommission>;
  pageInfo: GQLPaginationPageInfo;
};

export type GQLCompletedInteractionDocument = {
  __typename?: 'CompletedInteractionDocument';
  completedAt: Maybe<Scalars['String']['output']>;
  documentTemplateId: Maybe<Scalars['String']['output']>;
  documentVersionId: Maybe<Scalars['String']['output']>;
  envelopeOrder: Maybe<Scalars['Int']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  interactionEnvelopeId: Maybe<Scalars['String']['output']>;
  isCustom: Maybe<Scalars['Boolean']['output']>;
  name: Maybe<Scalars['String']['output']>;
  propertyOptionGroupName: Maybe<Scalars['String']['output']>;
  signedFile: Maybe<GQLFile>;
};

export type GQLComplianceReviewAttentionItem = GQLNeedsAttentionItem & {
  __typename?: 'ComplianceReviewAttentionItem';
  audits: Array<GQLAudit>;
  id: Scalars['String']['output'];
  /** Number of interactions with audits requiring attention */
  interactionCount: Scalars['PositiveInt']['output'];
};

export type GQLConnection = {
  edges: Array<GQLEdge>;
  pageInfo: GQLPageInfo;
};

export type GQLConnectionResult = {
  connection: Maybe<GQLConnection>;
  errors: Maybe<Array<GQLNodeErrorPayload>>;
};

export type GQLContact = {
  __typename?: 'Contact';
  address: GQLAddress;
  agentLicenseNumber: Maybe<Scalars['String']['output']>;
  cellPhone: Maybe<Scalars['String']['output']>;
  companyName: Maybe<Scalars['String']['output']>;
  displayName: Maybe<Scalars['String']['output']>;
  displayType: GQLContactDisplayType;
  email: Maybe<Scalars['String']['output']>;
  entityName: Maybe<Scalars['String']['output']>;
  entityType: Maybe<GQLContactEntityType>;
  firstName: Maybe<Scalars['String']['output']>;
  homePhone: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  interactionContactId: Maybe<Scalars['ID']['output']>;
  isPrimary: Scalars['Boolean']['output'];
  isSelfRepresented: Scalars['Boolean']['output'];
  lastName: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer used in compliance */
  salesforceId: Maybe<Scalars['String']['output']>;
  sortPriority: Scalars['Int']['output'];
  teamId: Maybe<Scalars['String']['output']>;
  type: GQLContactType;
  userId: Maybe<Scalars['String']['output']>;
};

export enum GQLContactDisplayType {
  BUYER = 'BUYER',
  BUYERS_AGENT = 'BUYERS_AGENT',
  BUYERS_ATTORNEY = 'BUYERS_ATTORNEY',
  BUYERS_TC = 'BUYERS_TC',
  CLOSING_ATTORNEY = 'CLOSING_ATTORNEY',
  ESCROW_OFFICER = 'ESCROW_OFFICER',
  SELLER = 'SELLER',
  SELLERS_AGENT = 'SELLERS_AGENT',
  SELLERS_ATTORNEY = 'SELLERS_ATTORNEY',
  SELLERS_TC = 'SELLERS_TC',
  TITLE_OFFICER = 'TITLE_OFFICER'
}

export enum GQLContactEntityType {
  BROKERAGE = 'BROKERAGE',
  ENTITY = 'ENTITY',
  INDIVIDUAL = 'INDIVIDUAL',
  POWER_OF_ATTORNEY = 'POWER_OF_ATTORNEY',
  PROBATE = 'PROBATE',
  TRUST = 'TRUST'
}

export type GQLContactInput = {
  addressTypeUsed?: InputMaybe<Scalars['String']['input']>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  broker?: InputMaybe<GQLInteractionContactGeneralInput>;
  brokerage?: InputMaybe<GQLBrokerageInput>;
  cellPhone?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  commission?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  contactSource?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  entity?: InputMaybe<GQLOwnershipInput>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  etag?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  googleContactId?: InputMaybe<Scalars['String']['input']>;
  homePhone?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isSelfRepresented?: InputMaybe<Scalars['Boolean']['input']>;
  isSuccessor?: InputMaybe<Scalars['Boolean']['input']>;
  jurisdiction?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  licenseNumber?: InputMaybe<Scalars['String']['input']>;
  listingPeriod?: InputMaybe<Scalars['String']['input']>;
  mlsId?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  officeManager?: InputMaybe<GQLInteractionContactGeneralInput>;
  officeNumber?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  powerOfAttorney?: InputMaybe<GQLInteractionContactGeneralInput>;
  primaryMls?: InputMaybe<Scalars['String']['input']>;
  probate?: InputMaybe<GQLOwnershipInput>;
  role?: InputMaybe<Scalars['String']['input']>;
  sellingCommission?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street1?: InputMaybe<Scalars['String']['input']>;
  street2?: InputMaybe<Scalars['String']['input']>;
  supervisingBroker?: InputMaybe<GQLInteractionContactGeneralInput>;
  teamBusinessLicenseEntityNumber?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['String']['input']>;
  teamName?: InputMaybe<Scalars['String']['input']>;
  trust?: InputMaybe<GQLOwnershipInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type GQLContactResponse = {
  __typename?: 'ContactResponse';
  addressTypeUsed: Maybe<Scalars['String']['output']>;
  avatar: Maybe<Scalars['String']['output']>;
  broker: Maybe<GQLInteractionContactGeneralInfo>;
  brokerage: Maybe<GQLBrokerage>;
  cellPhone: Maybe<Scalars['String']['output']>;
  city: Maybe<Scalars['String']['output']>;
  commission: Maybe<Scalars['String']['output']>;
  companyName: Maybe<Scalars['String']['output']>;
  confirmationNumber: Maybe<Scalars['String']['output']>;
  contactSource: Maybe<Scalars['String']['output']>;
  country: Maybe<Scalars['String']['output']>;
  county: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  entity: Maybe<GQLOwnershipEntity>;
  entityType: Maybe<Scalars['String']['output']>;
  escrowNumber: Maybe<Scalars['String']['output']>;
  etag: Maybe<Scalars['String']['output']>;
  externalId: Maybe<Scalars['String']['output']>;
  fax: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  followUpBossContactId: Maybe<Scalars['String']['output']>;
  fullName: Maybe<Scalars['String']['output']>;
  googleContactId: Maybe<Scalars['String']['output']>;
  group: Maybe<Scalars['String']['output']>;
  homePhone: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  isSelfRepresented: Maybe<Scalars['Boolean']['output']>;
  isSuccessor: Maybe<Scalars['Boolean']['output']>;
  jurisdiction: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  licenseNumber: Maybe<Scalars['String']['output']>;
  licenseState: Maybe<Scalars['String']['output']>;
  listingPeriod: Maybe<Scalars['String']['output']>;
  mlsId: Maybe<Scalars['String']['output']>;
  nickname: Maybe<Scalars['String']['output']>;
  officeManager: Maybe<GQLInteractionContactGeneralInfo>;
  officeNumber: Maybe<Scalars['String']['output']>;
  order: Maybe<Scalars['Int']['output']>;
  ownershipStatus: Maybe<Scalars['String']['output']>;
  powerOfAttorney: Maybe<GQLInteractionContactGeneralInfo>;
  primaryMls: Maybe<Scalars['String']['output']>;
  probate: Maybe<GQLOwnershipEntity>;
  role: Maybe<Scalars['String']['output']>;
  sellingCommission: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  street1: Maybe<Scalars['String']['output']>;
  street2: Maybe<Scalars['String']['output']>;
  supervisingBroker: Maybe<GQLInteractionContactGeneralInfo>;
  teamBusinessLicenseEntityNumber: Maybe<Scalars['String']['output']>;
  teamId: Maybe<Scalars['String']['output']>;
  teamIdentityId: Maybe<Scalars['String']['output']>;
  teamName: Maybe<Scalars['String']['output']>;
  titleNumber: Maybe<Scalars['String']['output']>;
  trust: Maybe<GQLOwnershipEntity>;
  type: Maybe<Scalars['String']['output']>;
  userId: Maybe<Scalars['String']['output']>;
  userIdentityId: Maybe<Scalars['String']['output']>;
  zip: Maybe<Scalars['String']['output']>;
};

export type GQLContactSuggestion = {
  __typename?: 'ContactSuggestion';
  followUpBossPeople: Array<GQLContactSuggestionResult>;
  googlePeople: Array<GQLContactSuggestionResult>;
  sideAgents: Array<GQLContactSuggestionResult>;
  teamAgents: Array<GQLContactSuggestionResult>;
};

export type GQLContactSuggestionInput = {
  excludeNonCompliantTeams?: InputMaybe<Scalars['Boolean']['input']>;
  includeReferralAgents?: InputMaybe<Scalars['Boolean']['input']>;
  licenseStates?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchValue: Scalars['String']['input'];
  teamId?: InputMaybe<Scalars['ID']['input']>;
};

export type GQLContactSuggestionResult = {
  __typename?: 'ContactSuggestionResult';
  contactResponse: Maybe<GQLContactResponse>;
  contactSource: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  email: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  followUpBossId: Maybe<Scalars['String']['output']>;
  googleId: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  legacyExternalId: Maybe<Scalars['String']['output']>;
  photoUrl: Maybe<Scalars['String']['output']>;
  userId: Maybe<Scalars['String']['output']>;
};

export enum GQLContactType {
  AGENT = 'AGENT',
  ATTORNEY = 'ATTORNEY',
  CLIENT = 'CLIENT',
  CLOSING_ATTORNEY = 'CLOSING_ATTORNEY',
  COUNTERPARTY_AGENT = 'COUNTERPARTY_AGENT',
  COUNTERPARTY_ATTORNEY = 'COUNTERPARTY_ATTORNEY',
  COUNTERPARTY_CLIENT = 'COUNTERPARTY_CLIENT',
  COUNTERPARTY_TRANSACTION_COORDINATOR = 'COUNTERPARTY_TRANSACTION_COORDINATOR',
  ESCROW_OFFICER = 'ESCROW_OFFICER',
  TITLE_OFFICER = 'TITLE_OFFICER',
  TRANSACTION_COORDINATOR = 'TRANSACTION_COORDINATOR'
}

export enum GQLContentDisposition {
  attachment = 'attachment',
  inline = 'inline'
}

export type GQLCoverSheet = {
  __typename?: 'CoverSheet';
  acceptanceDate: Maybe<Scalars['String']['output']>;
  autoGenerated: Maybe<Scalars['Boolean']['output']>;
  bindingAgreementDate: Maybe<Scalars['String']['output']>;
  buyerRelationshipType: Maybe<GQLBuyerRelationshipType>;
  closingDate: Maybe<Scalars['String']['output']>;
  commissionAdditionalAmount: Maybe<Scalars['Float']['output']>;
  commissionAmountDollar: Maybe<Scalars['Float']['output']>;
  commissionAmountPercent: Maybe<Scalars['Float']['output']>;
  commissionType: Maybe<GQLCommissionType>;
  contacts: Array<GQLContactResponse>;
  contingencies: Maybe<Array<Maybe<GQLOfferContingency>>>;
  contractDate: Maybe<Scalars['String']['output']>;
  counterpartyCommissionAdditionalAmount: Maybe<Scalars['Float']['output']>;
  counterpartyCommissionAmountDollar: Maybe<Scalars['Float']['output']>;
  counterpartyCommissionAmountPercent: Maybe<Scalars['Float']['output']>;
  counterpartyCommissionType: Maybe<GQLCommissionType>;
  coverPhotoFileId: Maybe<Scalars['String']['output']>;
  coverPhotoUrl: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['String']['output']>;
  createdBy: Maybe<Scalars['String']['output']>;
  downPaymentAmount: Maybe<Scalars['Float']['output']>;
  downPaymentPercentage: Maybe<Scalars['Float']['output']>;
  emdAmount: Maybe<Scalars['Float']['output']>;
  emdDueDate: Maybe<Scalars['String']['output']>;
  emdHolderCompanyName: Maybe<Scalars['String']['output']>;
  endDate: Maybe<Scalars['String']['output']>;
  expirationDate: Maybe<Scalars['String']['output']>;
  /** @deprecated Use id or interactionId instead */
  externalId: Scalars['ID']['output'];
  financingType: Maybe<GQLFinancingType>;
  id: Scalars['ID']['output'];
  insideListingDescription: Maybe<Scalars['String']['output']>;
  interactionId: Scalars['ID']['output'];
  isDualAgency: Maybe<Scalars['Boolean']['output']>;
  isIntermediary: Maybe<Scalars['Boolean']['output']>;
  isPersonalDeal: Maybe<Scalars['Boolean']['output']>;
  leadSourceId: Maybe<Scalars['String']['output']>;
  leadSourceNameSpecified: Maybe<Scalars['String']['output']>;
  leaseEndDate: Maybe<Scalars['String']['output']>;
  leaseStartDate: Maybe<Scalars['String']['output']>;
  listingEndDate: Maybe<Scalars['String']['output']>;
  listingPrice: Maybe<Scalars['Float']['output']>;
  listingStartDate: Maybe<Scalars['String']['output']>;
  maximumPrice: Maybe<Scalars['Float']['output']>;
  minimumPrice: Maybe<Scalars['Float']['output']>;
  monthlyRent: Maybe<Scalars['Float']['output']>;
  mortgageRatePercentage: Maybe<Scalars['Float']['output']>;
  notes: Maybe<Scalars['String']['output']>;
  numbersDaysEmdDue: Maybe<Scalars['Int']['output']>;
  offerPrice: Maybe<Scalars['Float']['output']>;
  onMarketDate: Maybe<Scalars['String']['output']>;
  owner: Maybe<Scalars['String']['output']>;
  ownerUserIdentityId: Maybe<Scalars['String']['output']>;
  paymentDate: Maybe<Scalars['String']['output']>;
  property: Maybe<GQLPropertyInfo>;
  propertyExclusions: Maybe<Scalars['String']['output']>;
  propertyInclusions: Maybe<Scalars['String']['output']>;
  propertyRestrictionType: Maybe<GQLPropertyRestrictionType>;
  proposedClosingTimeframe: Maybe<Scalars['Int']['output']>;
  releaseOfEarnestMoney: Maybe<GQLReleaseOfEarnestMoney>;
  salesAgreementNumber: Maybe<Scalars['String']['output']>;
  salesPrice: Maybe<Scalars['Float']['output']>;
  sellerPaidClosingCostsAmount: Maybe<Scalars['Float']['output']>;
  sellerPaidClosingCostsPercentage: Maybe<Scalars['Float']['output']>;
  settlementDate: Maybe<Scalars['String']['output']>;
  showOnInsideListings: Maybe<Scalars['Boolean']['output']>;
  startDate: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
  teamId: Maybe<Scalars['String']['output']>;
  teamIdentityId: Maybe<Scalars['String']['output']>;
  terminationFee: Maybe<Scalars['Float']['output']>;
  totalOffersReceived: Maybe<Scalars['Int']['output']>;
  totalRentAmount: Maybe<Scalars['Float']['output']>;
  tourUrl: Maybe<Scalars['String']['output']>;
  updatedBy: Maybe<Scalars['String']['output']>;
};

export type GQLCoverSheetConfigQueryInput = {
  interactionId: Scalars['ID']['input'];
  interactionType: GQLInteractionType;
  representationType?: InputMaybe<GQLLeaseRepresentation>;
};

export type GQLCoverSheetMutations = {
  __typename?: 'CoverSheetMutations';
  createEntity: GQLCreateCoverSheetEntityResponse;
  createGoogleContact: GQLUpdateGoogleResponse;
  createOrUpdateContact: GQLUpdateCoverSheetResponse;
  deleteEntity: GQLDeleteCoverSheetResponse;
  updateCoverSheetFields: GQLUpdateCoverSheetResponse;
  updateGoogleContact: GQLUpdateGoogleResponse;
};


export type GQLCoverSheetMutationscreateEntityArgs = {
  input: GQLCreateCoverSheetEntityInput;
};


export type GQLCoverSheetMutationscreateGoogleContactArgs = {
  input: GQLUpdateGoogleContactInput;
};


export type GQLCoverSheetMutationscreateOrUpdateContactArgs = {
  input: GQLCreateOrUpdateCoverSheetContactInput;
};


export type GQLCoverSheetMutationsdeleteEntityArgs = {
  input: GQLDeleteCoverSheetEntityInput;
};


export type GQLCoverSheetMutationsupdateCoverSheetFieldsArgs = {
  input: GQLUpdateCoverSheetFieldsInput;
};


export type GQLCoverSheetMutationsupdateGoogleContactArgs = {
  input: GQLUpdateGoogleContactInput;
};

export type GQLCreateAttachmentsInput = {
  attachments: Array<GQLAttachmentInput>;
};

export type GQLCreateAttachmentsResponse = {
  __typename?: 'CreateAttachmentsResponse';
  file: GQLAuditFile;
  uploadUrl: Scalars['String']['output'];
};

export enum GQLCreateAuditHistoryAction {
  COMMUNICATION_RECEIVED = 'COMMUNICATION_RECEIVED',
  DOCUMENT_DOWNLOADED = 'DOCUMENT_DOWNLOADED',
  DOCUMENT_VIEWED = 'DOCUMENT_VIEWED',
  LISTING_OPENED = 'LISTING_OPENED',
  SUBMISSION_BLOCKED = 'SUBMISSION_BLOCKED',
  TRANSACTION_OPENED = 'TRANSACTION_OPENED'
}

export type GQLCreateAuditHistoryEvent = {
  comment?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  referenceId: Scalars['ID']['input'];
  referenceType: GQLAuditHistoryReference;
};

export type GQLCreateAuditHistoryInput = {
  action: GQLCreateAuditHistoryAction;
  actionType: GQLAuditHistoryActionType;
  createdByEmail?: InputMaybe<Scalars['String']['input']>;
  event?: InputMaybe<GQLCreateAuditHistoryEvent>;
};

export type GQLCreateAuditInput = {
  interactionId: Scalars['ID']['input'];
  interactionType: GQLAuditInteractionType;
};

export type GQLCreateAuditSessionInput = {
  endTime: Scalars['DateTime']['input'];
  startTime: Scalars['DateTime']['input'];
};

export type GQLCreateChecklistItemInput = {
  categoryId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  isRequired: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type GQLCreateChecklistItemTemplateV2Input = {
  acceptWhenAutoAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  documentType?: InputMaybe<GQLChecklistItemDocumentType>;
  locale: Scalars['String']['input'];
  name: Scalars['String']['input'];
  riskLevel?: InputMaybe<GQLRiskLevel>;
  status?: InputMaybe<GQLVersionStatus>;
  transactionPhase: GQLTransactionPhase;
};

export type GQLCreateChecklistItemTemplateVersionV2Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  riskLevel?: InputMaybe<GQLRiskLevel>;
};

export type GQLCreateChecklistTemplateV2Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  interactionType: GQLInteractionType;
  locale?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  propertyType: GQLPropertyType;
};

export type GQLCreateChecklistTemplateVersionV2Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type GQLCreateCoverSheetEntityInput = {
  entity: Scalars['String']['input'];
  entityType?: InputMaybe<Scalars['String']['input']>;
  fields: Array<GQLUpdateCoverSheetFieldData>;
  interactionId: Scalars['String']['input'];
  interactionType: GQLInteractionType;
};

export type GQLCreateCoverSheetEntityResponse = {
  __typename?: 'CreateCoverSheetEntityResponse';
  coverSheet: Maybe<GQLCoverSheet>;
  error: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type GQLCreateDelegateGroupInput = {
  delegatedToId: Array<Scalars['ID']['input']>;
  onBehalfOfId: Scalars['ID']['input'];
  permissions: Array<Scalars['String']['input']>;
};

export type GQLCreateDocTemplateInputInput = {
  applyCommaSeparator?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  docusignXOffset?: InputMaybe<Scalars['Float']['input']>;
  docusignYOffset?: InputMaybe<Scalars['Float']['input']>;
  dropdownOptions?: InputMaybe<Scalars['String']['input']>;
  dropdownPlaceholder?: InputMaybe<Scalars['String']['input']>;
  fontSize?: InputMaybe<Scalars['Float']['input']>;
  formation?: InputMaybe<GQLInitialsGroupFormation>;
  formula?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Array<GQLDocTemplateInputGroupInput>>;
  height?: InputMaybe<Scalars['Float']['input']>;
  image?: InputMaybe<GQLDocTemplatePageInputImageType>;
  initialsGroup?: InputMaybe<Array<GQLInitialsGroupItemInput>>;
  left?: InputMaybe<Scalars['Float']['input']>;
  maxLength?: InputMaybe<Scalars['String']['input']>;
  multiline?: InputMaybe<GQLDocTemplateInputGroupInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  optional?: InputMaybe<Scalars['Boolean']['input']>;
  optionalSide?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<GQLCreateDocTemplateInputOptionInput>>;
  recipientId?: InputMaybe<Scalars['String']['input']>;
  reportingName?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  scale?: InputMaybe<Scalars['Float']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  suffix?: InputMaybe<Scalars['String']['input']>;
  tabIndex?: InputMaybe<Scalars['Int']['input']>;
  targetFieldNames?: InputMaybe<Scalars['JSONObject']['input']>;
  textAlign?: InputMaybe<Scalars['String']['input']>;
  top?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<GQLInputType>;
  typeFace?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type GQLCreateDocTemplateInputOptionInput = {
  left?: InputMaybe<Scalars['Float']['input']>;
  reportingName?: InputMaybe<Scalars['String']['input']>;
  tabIndex?: InputMaybe<Scalars['Int']['input']>;
  top?: InputMaybe<Scalars['Float']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type GQLCreateDocumentInput = {
  checklistItemId?: InputMaybe<Scalars['ID']['input']>;
  documentId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type GQLCreateDocumentResponse = {
  __typename?: 'CreateDocumentResponse';
  document: GQLAuditDocument;
  uploadUrl: Scalars['String']['output'];
};

export type GQLCreateEnvelopeMutationPayload = GQLMutationPayload & {
  __typename?: 'CreateEnvelopeMutationPayload';
  errors: Maybe<Array<GQLMutationProblem>>;
  query: Maybe<GQLQuery>;
  record: Maybe<GQLRunner>;
  status: Maybe<GQLMutationStatus>;
};

export type GQLCreateIdentityBrokerageInput = {
  address: GQLCreateIdentityUserAddressInput;
  brokerEmail: Scalars['String']['input'];
  brokerLicenseId: Scalars['ID']['input'];
  brokerPhone: Scalars['String']['input'];
  brokerUserId: Scalars['ID']['input'];
  licenseExpiration: Scalars['String']['input'];
  licenseNumber: Scalars['String']['input'];
  market: GQLIdentitySupportedStateCode;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  phoneNumber: Scalars['String']['input'];
  type?: InputMaybe<GQLIdentityBrokerageType>;
};

export type GQLCreateIdentityLicenseInput = {
  expiration: Scalars['String']['input'];
  number: Scalars['String']['input'];
  state: GQLIdentitySupportedStateCode;
};

export type GQLCreateIdentityTeamMemberInput = {
  email: Scalars['String']['input'];
  externalId: Scalars['ID']['input'];
  licenseId?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  roles?: InputMaybe<Array<GQLIdentityTeamMemberRoleCode>>;
  userId: Scalars['ID']['input'];
};

export type GQLCreateIdentityUserAddressInput = {
  city: Scalars['String']['input'];
  country?: InputMaybe<GQLIdentitySupportedCountryCode>;
  county?: InputMaybe<Scalars['String']['input']>;
  postalCode: Scalars['String']['input'];
  state: GQLIdentityStateCode;
  street1: Scalars['String']['input'];
  street2?: InputMaybe<Scalars['String']['input']>;
};

export type GQLCreateIdentityUserContactInput = {
  isPersonal?: InputMaybe<Scalars['Boolean']['input']>;
  isPrimary: Scalars['Boolean']['input'];
  type: GQLIdentityContactType;
  value: Scalars['String']['input'];
};

export type GQLCreateInteractionContactInput = {
  fields: Array<GQLUpdateCoverSheetFieldData>;
  type: GQLInteractionContactType;
};

export type GQLCreateInteractionInput = {
  clientGroupId?: InputMaybe<Scalars['ID']['input']>;
  contacts?: InputMaybe<Array<GQLCreateInteractionContactInput>>;
  leaseRepresentation?: InputMaybe<GQLLeaseRepresentation>;
  location?: InputMaybe<GQLInteractionLocationInput>;
  mlsNumber?: InputMaybe<Scalars['String']['input']>;
  mlsServiceId?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['ID']['input']>;
  referralId?: InputMaybe<Scalars['ID']['input']>;
  referralType?: InputMaybe<GQLReferralType>;
  status?: InputMaybe<GQLInteractionStatus>;
  teamId?: InputMaybe<Scalars['ID']['input']>;
};

export type GQLCreateOfferFromUploadedPayload = GQLMutationPayload & {
  __typename?: 'CreateOfferFromUploadedPayload';
  errors: Maybe<Array<GQLMutationProblem>>;
  query: Maybe<GQLQuery>;
  record: Maybe<GQLRunner>;
  status: Maybe<GQLMutationStatus>;
};

export type GQLCreateOfferOnListingInput = {
  closingDate?: InputMaybe<Scalars['String']['input']>;
  commissionAdditionalAmount?: InputMaybe<Scalars['Float']['input']>;
  commissionType?: InputMaybe<GQLCommissionType>;
  commissionValue?: InputMaybe<Scalars['Float']['input']>;
  contacts?: InputMaybe<Array<InputMaybe<GQLContactInput>>>;
  contingencies?: InputMaybe<Array<InputMaybe<GQLOfferContingencyInput>>>;
  downPaymentAmount?: InputMaybe<Scalars['Float']['input']>;
  downPaymentPercentage?: InputMaybe<Scalars['Float']['input']>;
  emdAmount?: InputMaybe<Scalars['Float']['input']>;
  expirationDate?: InputMaybe<Scalars['String']['input']>;
  financingType?: InputMaybe<GQLFinancingType>;
  lenderName?: InputMaybe<Scalars['String']['input']>;
  mortgageRatePercentage?: InputMaybe<Scalars['Float']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  offerPrice: Scalars['Float']['input'];
  propertyExclusions?: InputMaybe<Scalars['String']['input']>;
  propertyInclusions?: InputMaybe<Scalars['String']['input']>;
  proposedClosingTimeframe?: InputMaybe<Scalars['Int']['input']>;
  releaseOfEarnestMoney?: InputMaybe<GQLReleaseOfEarnestMoneyInput>;
  sellerPaidClosingCostsAmount?: InputMaybe<Scalars['Float']['input']>;
  sellerPaidClosingCostsPercentage?: InputMaybe<Scalars['Float']['input']>;
  status: GQLOfferStatus;
  terminationFee?: InputMaybe<Scalars['Float']['input']>;
};

export type GQLCreateOrUpdateCoverSheetContactInput = {
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType: Scalars['String']['input'];
  followUpBossId?: InputMaybe<Scalars['String']['input']>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  interactionId: Scalars['String']['input'];
  interactionType: GQLInteractionType;
  /**
   * Whether to load the agent's team-member preferences — commission and MLS
   * memberships — when building the contact. These only matter for the primary
   * agent, and the requester may not be permitted to read another (non-team)
   * agent's preferences. Defaults to false; callers building a primary-agent
   * contact should pass true.
   */
  loadPreferences?: InputMaybe<Scalars['Boolean']['input']>;
  teamId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type GQLCreateOutsideBrokerageInput = {
  accountingSupplierId: Scalars['String']['input'];
  address?: InputMaybe<GQLFullAddressInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type GQLCreateRunnerResponseData = {
  __typename?: 'CreateRunnerResponseData';
  docusignEnvelopeId: Maybe<Scalars['String']['output']>;
  error: Maybe<GQLTrsResponseError>;
  interactionEnvelopeId: Maybe<Scalars['String']['output']>;
};

export type GQLCreateTemplateCategoryV2Input = {
  checklistType: GQLChecklistType;
  isSystem: Scalars['Boolean']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  sortPriority: Scalars['Int']['input'];
  transactionPhase: GQLTransactionPhase;
};

export type GQLCreateTemplateRuleV2Input = {
  definition: GQLRuleDefinitionInput;
  documentProcessor?: InputMaybe<GQLRuleDocumentProcessor>;
  itemVersionId?: InputMaybe<Scalars['ID']['input']>;
  multiDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pagesRange?: InputMaybe<Array<Scalars['PageRange']['input']>>;
  templateVersionId?: InputMaybe<Scalars['ID']['input']>;
  type: GQLRuleType;
};

export type GQLCursorPageInfo = {
  __typename?: 'CursorPageInfo';
  afterCursor: Maybe<Scalars['String']['output']>;
  beforeCursor: Maybe<Scalars['String']['output']>;
  nextPageUrl: Maybe<Scalars['String']['output']>;
  previousPageUrl: Maybe<Scalars['String']['output']>;
};

export type GQLCursorPaginationInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<InputMaybe<GQLFacetFilter>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GQLDatagridSortModel>>>;
};

export type GQLCursorPaginationResponse = {
  items: Array<GQLNode>;
  pageInfo: GQLCursorPageInfo;
};

export type GQLDatagridSortModel = {
  field: Scalars['String']['input'];
  segment?: InputMaybe<Scalars['String']['input']>;
  sort: GQLSortDirection;
};

export enum GQLDefaultContactType {
  escrowOfficer = 'escrowOfficer',
  titleOfficer = 'titleOfficer'
}

export type GQLDefinitionConditionInput = {
  all?: InputMaybe<Array<GQLDefinitionConditionInput>>;
  any?: InputMaybe<Array<GQLDefinitionConditionInput>>;
  fact?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<Scalars['JSONObject']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['PositiveInt']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type GQLDefinitionEvent = {
  __typename?: 'DefinitionEvent';
  params: Maybe<Scalars['JSONObject']['output']>;
  type: Scalars['String']['output'];
};

export type GQLDefinitionEventInput = {
  params?: InputMaybe<Scalars['JSONObject']['input']>;
  type: Scalars['String']['input'];
};

export type GQLDefinitionEventUpdateInput = {
  params?: InputMaybe<Scalars['JSONObject']['input']>;
  type: Scalars['String']['input'];
};

export type GQLDelegateGroup = GQLAuditable & GQLNode & {
  __typename?: 'DelegateGroup';
  createdAt: Maybe<Scalars['String']['output']>;
  createdBy: Maybe<Scalars['String']['output']>;
  delegatedRelations: Array<GQLDelegateGroupRelation>;
  history: GQLDelegateGroupHistoryPaginationResult;
  id: Scalars['ID']['output'];
  onBehalfOf: GQLPaymentTeamMember;
  permissions: Array<GQLDelegateGroupPermission>;
  updatedAt: Maybe<Scalars['String']['output']>;
  updatedBy: Maybe<Scalars['String']['output']>;
};


export type GQLDelegateGrouphistoryArgs = {
  input: GQLPaginationInput;
};

export type GQLDelegateGroupHistory = GQLAuditable & GQLNode & {
  __typename?: 'DelegateGroupHistory';
  createdAt: Maybe<Scalars['String']['output']>;
  createdBy: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  permissions: Maybe<GQLDelegateGroupHistoryPermissionChanges>;
  relations: Maybe<GQLDelegateGroupHistoryRelationChanges>;
  requestId: Maybe<Scalars['ID']['output']>;
  updatedAt: Maybe<Scalars['String']['output']>;
  updatedBy: Maybe<Scalars['String']['output']>;
};

export type GQLDelegateGroupHistoryPaginationResult = GQLPaginationResponse & {
  __typename?: 'DelegateGroupHistoryPaginationResult';
  items: Array<GQLDelegateGroupHistory>;
  pageInfo: GQLPaginationPageInfo;
};

export type GQLDelegateGroupHistoryPermissionChanges = {
  __typename?: 'DelegateGroupHistoryPermissionChanges';
  ADD: Array<Scalars['String']['output']>;
  DELETE: Array<Scalars['String']['output']>;
};

export type GQLDelegateGroupHistoryRelationChanges = {
  __typename?: 'DelegateGroupHistoryRelationChanges';
  ADD: Array<GQLPaymentTeamMember>;
  DELETE: Array<GQLPaymentTeamMember>;
};

export type GQLDelegateGroupInput = {
  id: Scalars['ID']['input'];
};

export type GQLDelegateGroupMutations = {
  __typename?: 'DelegateGroupMutations';
  create: GQLDelegateGroupPayload;
  delete: GQLDelegateGroupPayload;
  update: GQLDelegateGroupPayload;
};


export type GQLDelegateGroupMutationscreateArgs = {
  input: GQLCreateDelegateGroupInput;
};


export type GQLDelegateGroupMutationsdeleteArgs = {
  id: Scalars['ID']['input'];
};


export type GQLDelegateGroupMutationsupdateArgs = {
  id: Scalars['ID']['input'];
  input: GQLUpdateDelegateGroupInput;
};

export type GQLDelegateGroupPaginationResult = GQLPaginationResponse & {
  __typename?: 'DelegateGroupPaginationResult';
  items: Array<GQLDelegateGroup>;
  pageInfo: GQLPaginationPageInfo;
};

export type GQLDelegateGroupPayload = GQLMutationPayload & {
  __typename?: 'DelegateGroupPayload';
  errors: Maybe<Array<GQLMutationProblem>>;
  query: GQLQuery;
  record: Maybe<GQLDelegateGroup>;
  status: GQLMutationStatus;
};

export type GQLDelegateGroupPermission = GQLAuditable & GQLNode & {
  __typename?: 'DelegateGroupPermission';
  createdAt: Maybe<Scalars['String']['output']>;
  createdBy: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  permissionType: Scalars['String']['output'];
  updatedAt: Maybe<Scalars['String']['output']>;
  updatedBy: Maybe<Scalars['String']['output']>;
};

export type GQLDelegateGroupRelation = GQLAuditable & GQLNode & {
  __typename?: 'DelegateGroupRelation';
  createdAt: Maybe<Scalars['String']['output']>;
  createdBy: Maybe<Scalars['String']['output']>;
  delegatedTo: GQLPaymentTeamMember;
  id: Scalars['ID']['output'];
  updatedAt: Maybe<Scalars['String']['output']>;
  updatedBy: Maybe<Scalars['String']['output']>;
};

export type GQLDelegateGroupsInput = {
  delegatedTo?: InputMaybe<Scalars['ID']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  onBehalfOf?: InputMaybe<Scalars['ID']['input']>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  sort?: InputMaybe<Array<GQLDatagridSortModel>>;
};

export type GQLDeleteChecklistTemplateVersionV2Result = GQLNodeResult & {
  __typename?: 'DeleteChecklistTemplateVersionV2Result';
  errors: Maybe<Array<GQLChecklistTemplateVersionV2Error>>;
  node: Maybe<GQLChecklistTemplateV2>;
};

export type GQLDeleteCoverSheetEntityInput = {
  entity: Scalars['String']['input'];
  entityId: Scalars['String']['input'];
  interactionId: Scalars['String']['input'];
  interactionType: GQLInteractionType;
};

export type GQLDeleteCoverSheetResponse = {
  __typename?: 'DeleteCoverSheetResponse';
  coverSheet: Maybe<GQLCoverSheet>;
  error: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type GQLDeleteDocumentInput = {
  documentId: Scalars['ID']['input'];
};

export type GQLDeleteDocumentInputInput = {
  documentId: Scalars['ID']['input'];
  inputId: Scalars['ID']['input'];
  pageId: Scalars['ID']['input'];
};

export type GQLDeleteDocumentInputPayload = GQLMutationPayload & {
  __typename?: 'DeleteDocumentInputPayload';
  errors: Maybe<Array<GQLMutationProblem>>;
  query: Maybe<GQLQuery>;
  status: Maybe<GQLMutationStatus>;
};

export type GQLDeleteDocumentPayload = GQLMutationPayload & {
  __typename?: 'DeleteDocumentPayload';
  errors: Maybe<Array<GQLMutationProblem>>;
  query: Maybe<GQLQuery>;
  status: Maybe<GQLMutationStatus>;
};

export type GQLDeleteDocumentsByStatusInput = {
  currentStatus: GQLInteractionDocumentStatus;
};

export type GQLDeleteDocumentsByStatusPayload = GQLMutationPayload & {
  __typename?: 'DeleteDocumentsByStatusPayload';
  errors: Maybe<Array<GQLMutationProblem>>;
  query: Maybe<GQLQuery>;
  status: Maybe<GQLMutationStatus>;
};

export type GQLDemandTransaction = {
  __typename?: 'DemandTransaction';
  externalId: Scalars['ID']['output'];
  id: Maybe<Scalars['ID']['output']>;
};

export type GQLDispatchStatementsNotificationsInput = {
  lastModifiedAt: Scalars['String']['input'];
  statementTypes: Array<GQLPaymentTransactionStatementType>;
};

export type GQLDocTemplate = {
  __typename?: 'DocTemplate';
  appearsIn: Array<GQLDocTemplateAppearsIn>;
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  draftVersion: Maybe<GQLDocTemplateVersion>;
  error: Maybe<Array<Scalars['String']['output']>>;
  externalId: Maybe<Scalars['ID']['output']>;
  formLibrary: Maybe<Scalars['String']['output']>;
  formName: Maybe<Scalars['String']['output']>;
  formVersion: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isCustom: Maybe<Scalars['Boolean']['output']>;
  isGlobal: Scalars['Boolean']['output'];
  isReadyForReporting: Scalars['Boolean']['output'];
  listingOrder: Maybe<Scalars['Int']['output']>;
  locales: Array<GQLLocaleEntity>;
  name: Scalars['String']['output'];
  offerOrder: Maybe<Scalars['Int']['output']>;
  propertyOptionGroups: Array<GQLPropertyOptionGroupOnTemplate>;
  publishedVersion: Maybe<GQLDocTemplateVersion>;
  publishedVersionId: Maybe<Scalars['ID']['output']>;
  revisionMonth: Maybe<Scalars['Int']['output']>;
  revisionYear: Maybe<Scalars['Int']['output']>;
  sourceTemplateId: Maybe<Scalars['ID']['output']>;
  status: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  updatedBy: Scalars['String']['output'];
  version: GQLDocTemplateVersion;
  versions: Array<GQLDocTemplateVersion>;
};


export type GQLDocTemplateversionArgs = {
  input: GQLDocTemplateVersionInput;
};

export enum GQLDocTemplateAppearsIn {
  client_group = 'client_group',
  dual = 'dual',
  landlord = 'landlord',
  listing = 'listing',
  offer = 'offer',
  referral = 'referral',
  tenant = 'tenant'
}

export type GQLDocTemplateInput = {
  id: Scalars['ID']['input'];
  isExternalId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GQLDocTemplateInputGroupInput = {
  inputIdx: Scalars['String']['input'];
  pageIdx: Scalars['Int']['input'];
};

export type GQLDocTemplateInputOptionInput = {
  left?: InputMaybe<Scalars['Float']['input']>;
  reportingName?: InputMaybe<Scalars['String']['input']>;
  tabIndex?: InputMaybe<Scalars['Int']['input']>;
  top?: InputMaybe<Scalars['Float']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type GQLDocTemplateMutations = {
  __typename?: 'DocTemplateMutations';
  docVersion: GQLDocTemplateVersionMutations;
  updateTemplate: GQLDocTemplate;
};


export type GQLDocTemplateMutationsdocVersionArgs = {
  versionId: Scalars['ID']['input'];
};


export type GQLDocTemplateMutationsupdateTemplateArgs = {
  input: GQLUpdateDocTemplateInput;
};

export type GQLDocTemplatePage = {
  __typename?: 'DocTemplatePage';
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  fullPath: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inputs: Array<GQLDocTemplatePageInput>;
  name: Maybe<Scalars['String']['output']>;
  pageNumber: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
  updatedBy: Scalars['String']['output'];
  versionId: Scalars['ID']['output'];
};

export type GQLDocTemplatePageInput = {
  __typename?: 'DocTemplatePageInput';
  applyCommaSeparator: Maybe<Scalars['Boolean']['output']>;
  color: Maybe<Scalars['String']['output']>;
  disabled: Maybe<Scalars['Boolean']['output']>;
  docusignXOffset: Maybe<Scalars['Float']['output']>;
  docusignYOffset: Maybe<Scalars['Float']['output']>;
  dropdownOptions: Maybe<Scalars['String']['output']>;
  dropdownPlaceholder: Maybe<Scalars['String']['output']>;
  fontSize: Maybe<Scalars['Float']['output']>;
  formation: Maybe<GQLInitialsGroupFormation>;
  formula: Maybe<Scalars['String']['output']>;
  group: Maybe<Array<GQLDocTemplatePageInputGroup>>;
  height: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  image: Maybe<GQLDocTemplatePageInputImageType>;
  initialsGroup: Maybe<Array<GQLInitialsGroupItem>>;
  left: Maybe<Scalars['Float']['output']>;
  lineHeight: Maybe<Scalars['Float']['output']>;
  maxLength: Maybe<Scalars['String']['output']>;
  multiline: Maybe<GQLDocTemplatePageInputGroup>;
  name: Maybe<Scalars['String']['output']>;
  optional: Maybe<Scalars['Boolean']['output']>;
  optionalSide: Maybe<Scalars['String']['output']>;
  options: Maybe<Array<GQLInputOption>>;
  recipientId: Maybe<Scalars['String']['output']>;
  reportingName: Maybe<Scalars['String']['output']>;
  required: Maybe<Scalars['Boolean']['output']>;
  scale: Maybe<Scalars['Float']['output']>;
  slug: Maybe<Scalars['String']['output']>;
  suffix: Maybe<Scalars['String']['output']>;
  tabIndex: Maybe<Scalars['Int']['output']>;
  targetFieldNames: Maybe<Scalars['JSONObject']['output']>;
  textAlign: Maybe<Scalars['String']['output']>;
  textIndent: Maybe<Scalars['Float']['output']>;
  top: Maybe<Scalars['Float']['output']>;
  type: Maybe<GQLInputType>;
  typeFace: Maybe<Scalars['String']['output']>;
  value: Maybe<Scalars['String']['output']>;
  width: Maybe<Scalars['Float']['output']>;
};

export type GQLDocTemplatePageInputGroup = {
  __typename?: 'DocTemplatePageInputGroup';
  inputIdx: Scalars['String']['output'];
  pageIdx: Scalars['Int']['output'];
};

export enum GQLDocTemplatePageInputImageType {
  ALT = 'ALT',
  MAIN = 'MAIN'
}

export type GQLDocTemplatePageInputUpdatePayload = {
  __typename?: 'DocTemplatePageInputUpdatePayload';
  input: GQLDocTemplatePageInput;
  version: GQLDocTemplateVersion;
};

export type GQLDocTemplateVersion = {
  __typename?: 'DocTemplateVersion';
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  creatorName: Maybe<Scalars['String']['output']>;
  file: Maybe<GQLDocTemplateVersionFile>;
  id: Scalars['ID']['output'];
  pages: Array<GQLDocTemplatePage>;
  publishedAt: Maybe<Scalars['String']['output']>;
  publishedBy: Maybe<Scalars['String']['output']>;
  publisherName: Maybe<Scalars['String']['output']>;
  sourceVersionId: Maybe<Scalars['ID']['output']>;
  status: GQLDocTemplateVersionStatus;
  templateId: Scalars['ID']['output'];
  updatedAt: Scalars['String']['output'];
  updatedBy: Scalars['String']['output'];
  versionNumber: Scalars['Int']['output'];
};

export type GQLDocTemplateVersionFile = {
  __typename?: 'DocTemplateVersionFile';
  bucket: Scalars['String']['output'];
  contentType: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  customMetadata: Maybe<Scalars['JSONObject']['output']>;
  downloadUrl: Maybe<Scalars['String']['output']>;
  filePath: Scalars['String']['output'];
  fileType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  updatedBy: Scalars['String']['output'];
  uploadFailReason: Maybe<Scalars['String']['output']>;
  uploadStatus: Maybe<GQLUploadStatus>;
};

export type GQLDocTemplateVersionInput = {
  id: Scalars['ID']['input'];
  isExternalId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GQLDocTemplateVersionMutations = {
  __typename?: 'DocTemplateVersionMutations';
  createInput: GQLDocTemplatePageInputUpdatePayload;
  deleteInput: Scalars['String']['output'];
  publishVersion: GQLDocTemplateVersion;
  updateInput: GQLDocTemplatePageInputUpdatePayload;
  uploadFile: GQLUploadDocTemplateVersionFilePayload;
};


export type GQLDocTemplateVersionMutationscreateInputArgs = {
  input: GQLCreateDocTemplateInputInput;
  pageId: Scalars['ID']['input'];
};


export type GQLDocTemplateVersionMutationsdeleteInputArgs = {
  inputId: Scalars['ID']['input'];
  pageId: Scalars['ID']['input'];
};


export type GQLDocTemplateVersionMutationsupdateInputArgs = {
  input: GQLUpdateDocTemplateInputInput;
  inputId: Scalars['ID']['input'];
  newPageId: InputMaybe<Scalars['ID']['input']>;
  pageId: Scalars['ID']['input'];
};


export type GQLDocTemplateVersionMutationsuploadFileArgs = {
  name: Scalars['String']['input'];
};

export enum GQLDocTemplateVersionStatus {
  draft = 'draft',
  published = 'published'
}

export type GQLDocumentForUpload = {
  name: Scalars['String']['input'];
};

export type GQLDownloadAuditDocumentsJob = GQLAuditJob & {
  __typename?: 'DownloadAuditDocumentsJob';
  data: Maybe<GQLDownloadAuditDocumentsJobData>;
  id: Scalars['ID']['output'];
  percentComplete: Scalars['Int']['output'];
  status: GQLAuditJobStatus;
};

export type GQLDownloadAuditDocumentsJobData = {
  __typename?: 'DownloadAuditDocumentsJobData';
  fileId: Maybe<Scalars['ID']['output']>;
  fileName: Maybe<Scalars['String']['output']>;
};

export type GQLDownloadDocumentsInput = {
  documentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type GQLDownloadDocumentsMutationPayload = GQLMutationPayload & {
  __typename?: 'DownloadDocumentsMutationPayload';
  errors: Maybe<Array<GQLMutationProblem>>;
  query: Maybe<GQLQuery>;
  record: Maybe<GQLRunner>;
  status: Maybe<GQLMutationStatus>;
};

export type GQLDownloadEnvelopeMutationPayload = GQLMutationPayload & {
  __typename?: 'DownloadEnvelopeMutationPayload';
  errors: Maybe<Array<GQLMutationProblem>>;
  query: Maybe<GQLQuery>;
  record: Maybe<GQLRunner>;
  status: Maybe<GQLMutationStatus>;
};

export type GQLDownloadPreviewDocumentMutationPayload = GQLMutationPayload & {
  __typename?: 'DownloadPreviewDocumentMutationPayload';
  errors: Maybe<Array<GQLMutationProblem>>;
  query: Maybe<GQLQuery>;
  record: Maybe<GQLRunner>;
  status: Maybe<GQLMutationStatus>;
};

export type GQLDownloadRunnerResponseData = {
  __typename?: 'DownloadRunnerResponseData';
  downloadUrl: Maybe<Scalars['String']['output']>;
  error: Maybe<GQLTrsResponseError>;
};

export type GQLDuplicateDocumentInput = {
  documentId: Scalars['ID']['input'];
};

export type GQLDuplicateDocumentPayload = GQLMutationPayload & {
  __typename?: 'DuplicateDocumentPayload';
  errors: Maybe<Array<GQLMutationProblem>>;
  query: Maybe<GQLQuery>;
  record: Maybe<GQLInteractionDocument>;
  status: Maybe<GQLMutationStatus>;
};

export type GQLEdge = {
  cursor: Scalars['String']['output'];
  node: GQLNode;
};

export type GQLEditCommentInput = {
  comment: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type GQLEditNoteInput = {
  content: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type GQLEnvelope = {
  __typename?: 'Envelope';
  completedAt: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  declinedAt: Maybe<Scalars['String']['output']>;
  declinedBy: Maybe<Scalars['String']['output']>;
  declinedReason: Maybe<Scalars['String']['output']>;
  deliveredAt: Maybe<Scalars['String']['output']>;
  document: Maybe<GQLInteractionDocument>;
  documents: Maybe<GQLEnvelopeDocumentsConnection>;
  docusignEnvelopeId: Maybe<Scalars['String']['output']>;
  externalId: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  interactionId: Scalars['ID']['output'];
  interactionType: GQLInteractionType;
  isContractEnvelope: Scalars['Boolean']['output'];
  listOfUnsignedRecipients: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  recipients: Array<GQLRecipient>;
  sentAt: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  unsignedFile: Maybe<GQLEnvelopeFile>;
  updatedAt: Scalars['String']['output'];
  updatedBy: Scalars['String']['output'];
  voidedAt: Maybe<Scalars['String']['output']>;
  voidedBy: Maybe<Scalars['String']['output']>;
  voidedReason: Maybe<Scalars['String']['output']>;
};


export type GQLEnvelopedocumentArgs = {
  input: GQLGetEnvelopeDocumentInput;
};

export type GQLEnvelopeDocumentsConnection = GQLConnection & {
  __typename?: 'EnvelopeDocumentsConnection';
  edges: Array<GQLEnvelopeDocumentsEdge>;
  pageInfo: GQLPageInfo;
};

export type GQLEnvelopeDocumentsEdge = GQLEdge & {
  __typename?: 'EnvelopeDocumentsEdge';
  cursor: Scalars['String']['output'];
  node: GQLInteractionDocument;
};

export type GQLEnvelopeFile = {
  __typename?: 'EnvelopeFile';
  contentType: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['String']['output']>;
  createdBy: Maybe<Scalars['String']['output']>;
  filePath: Maybe<Scalars['String']['output']>;
  fileType: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  isDeleted: Maybe<Scalars['Boolean']['output']>;
  name: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['String']['output']>;
  updatedBy: Maybe<Scalars['String']['output']>;
};

export type GQLEnvelopeRecipient = {
  deliveryOrder?: InputMaybe<Scalars['Int']['input']>;
  email: Scalars['String']['input'];
  emailBody?: InputMaybe<Scalars['String']['input']>;
  emailSubject: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  recipientType?: InputMaybe<GQLInteractionEnvelopeRecipientType>;
};

export type GQLEnvelopesAttentionItem = GQLNeedsAttentionItem & {
  __typename?: 'EnvelopesAttentionItem';
  envelopeCount: Scalars['PositiveInt']['output'];
  id: Scalars['String']['output'];
  interactionCount: Scalars['PositiveInt']['output'];
  interactions: GQLInteractionsPaginationResult;
  /** @deprecated use interactions instead */
  leases: GQLInteractionsPaginationResult;
  /** @deprecated use interactions instead */
  listings: GQLListingsPaginationResult;
  /** @deprecated use interactions instead */
  offers: GQLOffersPaginationResult;
};


export type GQLEnvelopesAttentionIteminteractionsArgs = {
  input: GQLAttentionItemPaginationInput;
};


export type GQLEnvelopesAttentionItemleasesArgs = {
  input: GQLAttentionItemPaginationInput;
};


export type GQLEnvelopesAttentionItemlistingsArgs = {
  input: GQLAttentionItemPaginationInput;
};


export type GQLEnvelopesAttentionItemoffersArgs = {
  input: GQLAttentionItemPaginationInput;
};

export type GQLErrorData = {
  __typename?: 'ErrorData';
  message: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  stack: Maybe<Scalars['String']['output']>;
};

export type GQLErrorPayload = {
  critical: Scalars['Boolean']['output'];
  error: Maybe<GQLErrorData>;
  message: Scalars['String']['output'];
  retryable: Scalars['Boolean']['output'];
};

export type GQLEscalateDocumentInput = {
  documentId: Scalars['ID']['input'];
  documentVersionId: Scalars['ID']['input'];
  targetTier: GQLTargetTier;
};

export type GQLFacetFilter = {
  facet?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type GQLFeatureFlagAttributeInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  teams?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GQLFeatureFlagEvaluationError = GQLNodeErrorPayload & {
  __typename?: 'FeatureFlagEvaluationError';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  status: Scalars['Int']['output'];
};

export type GQLFeatureFlagEvaluationInput = {
  attributes?: InputMaybe<GQLFeatureFlagAttributeInput>;
  flag: Scalars['String']['input'];
  key: Scalars['String']['input'];
  kind: Scalars['String']['input'];
};

export type GQLFeatureFlagEvaluationResult = {
  __typename?: 'FeatureFlagEvaluationResult';
  enabled: Maybe<Scalars['Boolean']['output']>;
  errors: Maybe<Array<GQLFeatureFlagEvaluationError>>;
};

export type GQLFieldChange = {
  __typename?: 'FieldChange';
  field: Scalars['String']['output'];
  newValue: Maybe<Scalars['String']['output']>;
  oldValue: Maybe<Scalars['String']['output']>;
};

export type GQLFile = {
  __typename?: 'File';
  createdAt: Maybe<Scalars['String']['output']>;
  downloadUrl: Maybe<Scalars['String']['output']>;
  filePath: Maybe<Scalars['String']['output']>;
  fileType: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  name: Maybe<Scalars['String']['output']>;
  uploadFailReason: Maybe<Scalars['String']['output']>;
  uploadStatus: Maybe<GQLUploadStatus>;
};

export enum GQLFileUploadStatus {
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  SUCCEEDED = 'SUCCEEDED',
  UPLOADING = 'UPLOADING'
}

export type GQLFinalizeTransactionError = {
  __typename?: 'FinalizeTransactionError';
  isValid: Scalars['Boolean']['output'];
  type: GQLFinalizeTransactionErrorType;
  value: Maybe<Scalars['String']['output']>;
};

export enum GQLFinalizeTransactionErrorType {
  CLOSE_DATE_READY = 'CLOSE_DATE_READY',
  COMMISSION_STATUS_READY = 'COMMISSION_STATUS_READY',
  COMPLIANCE_COMPLETED = 'COMPLIANCE_COMPLETED',
  PAYMENT_RECEIVED = 'PAYMENT_RECEIVED',
  SETTLEMENT_CONTACT_APPROVED = 'SETTLEMENT_CONTACT_APPROVED',
  STATEMENTS_SENT = 'STATEMENTS_SENT',
  TRANSACTION_STATUS_READY = 'TRANSACTION_STATUS_READY'
}

export type GQLFinalizeTransactionPayload = GQLMutationPayload & {
  __typename?: 'FinalizeTransactionPayload';
  checks: Maybe<Array<GQLFinalizeTransactionError>>;
  errors: Maybe<Array<GQLMutationProblem>>;
  query: GQLQuery;
  record: Maybe<GQLAdminTransaction>;
  status: GQLMutationStatus;
};

export enum GQLFinalizedBy {
  AUTO_CLOSED = 'AUTO_CLOSED',
  INSTANT_PAID = 'INSTANT_PAID',
  MANUALLY_CLOSED = 'MANUALLY_CLOSED'
}

export enum GQLFinancingType {
  bond = 'bond',
  cash = 'cash',
  conventional = 'conventional',
  fha = 'fha',
  other = 'other',
  sellerFinancing = 'sellerFinancing',
  va = 'va'
}

export type GQLForwardDocumentByIdMutationPayload = GQLMutationPayload & {
  __typename?: 'ForwardDocumentByIdMutationPayload';
  errors: Maybe<Array<GQLMutationProblem>>;
  query: Maybe<GQLQuery>;
  record: Maybe<GQLRunner>;
  status: Maybe<GQLMutationStatus>;
};

export type GQLForwardDocumentsMutationPayload = GQLMutationPayload & {
  __typename?: 'ForwardDocumentsMutationPayload';
  errors: Maybe<Array<GQLMutationProblem>>;
  query: Maybe<GQLQuery>;
  record: Maybe<GQLRunner>;
  status: Maybe<GQLMutationStatus>;
};

export type GQLForwardEnvelopeMutationPayload = GQLMutationPayload & {
  __typename?: 'ForwardEnvelopeMutationPayload';
  errors: Maybe<Array<GQLMutationProblem>>;
  query: Maybe<GQLQuery>;
  record: Maybe<GQLRunner>;
  status: Maybe<GQLMutationStatus>;
};

export type GQLFullAddress = {
  __typename?: 'FullAddress';
  city: Maybe<Scalars['String']['output']>;
  country: Maybe<Scalars['String']['output']>;
  county: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  street1: Maybe<Scalars['String']['output']>;
  street2: Maybe<Scalars['String']['output']>;
  zip: Maybe<Scalars['String']['output']>;
};

export type GQLFullAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street1?: InputMaybe<Scalars['String']['input']>;
  street2?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type GQLGenerateFileUploadUrlsInput = {
  names: Array<Scalars['String']['input']>;
};

export type GQLGenerateFileUploadUrlsPayload = GQLMutationPayload & {
  __typename?: 'GenerateFileUploadUrlsPayload';
  errors: Maybe<Array<GQLMutationProblem>>;
  files: Maybe<Array<GQLTransactionFileDetails>>;
  query: Maybe<GQLQuery>;
  status: GQLMutationStatus;
};

export type GQLGenerateOfferMutationPayload = GQLMutationPayload & {
  __typename?: 'GenerateOfferMutationPayload';
  errors: Maybe<Array<GQLMutationProblem>>;
  query: Maybe<GQLQuery>;
  record: Maybe<GQLRunner>;
  status: Maybe<GQLMutationStatus>;
};

export type GQLGenericProblem = GQLMutationProblem & {
  __typename?: 'GenericProblem';
  message: Scalars['String']['output'];
};

export type GQLGetEnvelopeDocumentInput = {
  id: Scalars['ID']['input'];
};

export type GQLGetEnvelopeInput = {
  envelopeId: Scalars['ID']['input'];
};

export type GQLGetEnvelopesInput = {
  needsAttention?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type GQLHCInfo = {
  __typename?: 'HCInfo';
  version: Scalars['String']['output'];
};

export type GQLHCResponse = {
  __typename?: 'HCResponse';
  info: Maybe<GQLHCInfo>;
  status: Scalars['Int']['output'];
};

export type GQLHistory = GQLAuditable & GQLNode & {
  __typename?: 'History';
  changes: Array<GQLFieldChange>;
  createdAt: Maybe<Scalars['String']['output']>;
  createdBy: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  requestId: Maybe<Scalars['ID']['output']>;
  updatedAt: Maybe<Scalars['String']['output']>;
  updatedBy: Maybe<Scalars['String']['output']>;
};

export type GQLHistoryPaginationResult = GQLPaginationResponse & {
  __typename?: 'HistoryPaginationResult';
  items: Array<GQLHistory>;
  pageInfo: GQLPaginationPageInfo;
};

export type GQLHomePage = {
  __typename?: 'HomePage';
  id: Scalars['String']['output'];
  needsAttention: GQLNeedsAttentionSection;
};

export type GQLIdentityAddTeamMemberContactError = GQLRetryableErrorPayload & {
  __typename?: 'IdentityAddTeamMemberContactError';
  critical: Scalars['Boolean']['output'];
  error: Maybe<GQLErrorData>;
  message: Scalars['String']['output'];
  retryable: Scalars['Boolean']['output'];
};

export type GQLIdentityAddress = GQLNode & {
  __typename?: 'IdentityAddress';
  city: Maybe<Scalars['String']['output']>;
  country: Maybe<Scalars['String']['output']>;
  county: Maybe<Scalars['String']['output']>;
  formattedAddress: Maybe<Scalars['String']['output']>;
  /** @deprecated Use geolocationLatitude. */
  geoLocationLatitude: Maybe<Scalars['String']['output']>;
  /** @deprecated Use geolocationLongitude. */
  geoLocationLongitude: Maybe<Scalars['String']['output']>;
  geolocationLatitude: Maybe<Scalars['String']['output']>;
  geolocationLongitude: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  postalCode: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  street1: Maybe<Scalars['String']['output']>;
  street2: Maybe<Scalars['String']['output']>;
};

export type GQLIdentityAddressError = GQLRetryableErrorPayload & {
  __typename?: 'IdentityAddressError';
  critical: Scalars['Boolean']['output'];
  error: Maybe<GQLErrorData>;
  message: Scalars['String']['output'];
  retryable: Scalars['Boolean']['output'];
};

export type GQLIdentityAddressNotFoundError = GQLErrorPayload & {
  __typename?: 'IdentityAddressNotFoundError';
  critical: Scalars['Boolean']['output'];
  error: Maybe<GQLErrorData>;
  message: Scalars['String']['output'];
  retryable: Scalars['Boolean']['output'];
};

export type GQLIdentityAssociatedTeamMembersError = GQLRetryableErrorPayload & {
  __typename?: 'IdentityAssociatedTeamMembersError';
  critical: Scalars['Boolean']['output'];
  error: Maybe<GQLErrorData>;
  message: Scalars['String']['output'];
  retryable: Scalars['Boolean']['output'];
};

export type GQLIdentityAssociatedTeamMembersPayload = {
  __typename?: 'IdentityAssociatedTeamMembersPayload';
  /** @deprecated Changing to use Apollo errors, read Apollo error from record. */
  error: Maybe<GQLIdentityAssociatedTeamMembersError>;
  record: Maybe<Array<GQLIdentityTeamMember>>;
};

export type GQLIdentityAssociations = {
  __typename?: 'IdentityAssociations';
  brokerages: Maybe<Array<GQLIdentityBrokerage>>;
  teamMembers: Maybe<Array<GQLIdentityTeamMember>>;
  teams: Maybe<Array<GQLIdentityTeam>>;
};

export type GQLIdentityBroker = GQLNode & {
  __typename?: 'IdentityBroker';
  /** @deprecated Use user.displayName */
  displayName: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  /** @deprecated Use user.firstName */
  firstName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated Use user.lastName */
  lastName: Maybe<Scalars['String']['output']>;
  license: Maybe<GQLIdentityLicense>;
  phoneNumber: Maybe<Scalars['String']['output']>;
  /** @deprecated Use user.photoUrl */
  photoUrl: Maybe<Scalars['String']['output']>;
  user: Maybe<GQLIdentityBrokerUser>;
};

export type GQLIdentityBrokerAssignment = {
  __typename?: 'IdentityBrokerAssignment';
  alias: Scalars['String']['output'];
  email: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  license: Maybe<GQLIdentityLicense>;
  name: Maybe<Scalars['String']['output']>;
  phoneNumber: Maybe<Scalars['String']['output']>;
  photoUrl: Maybe<Scalars['String']['output']>;
  type: Maybe<GQLIdentityBrokerAssignmentType>;
};

export enum GQLIdentityBrokerAssignmentType {
  BROKERAGE = 'BROKERAGE',
  TEAM = 'TEAM'
}

export type GQLIdentityBrokerUser = {
  __typename?: 'IdentityBrokerUser';
  displayName: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName: Maybe<Scalars['String']['output']>;
  photoUrl: Maybe<Scalars['String']['output']>;
};

export type GQLIdentityBrokerage = GQLNode & {
  __typename?: 'IdentityBrokerage';
  address: Maybe<GQLIdentityAddress>;
  id: Scalars['ID']['output'];
  licenseExpiration: Maybe<Scalars['String']['output']>;
  licenseNumber: Maybe<Scalars['String']['output']>;
  managingBroker: Maybe<GQLIdentityBroker>;
  market: Maybe<GQLIdentitySupportedStateCode>;
  metadata: Maybe<GQLIdentityChangeHistory>;
  name: Maybe<Scalars['String']['output']>;
  phoneNumber: Maybe<Scalars['String']['output']>;
  teams: Maybe<Array<Maybe<GQLIdentityTeam>>>;
  type: Maybe<GQLIdentityBrokerageType>;
};

export type GQLIdentityBrokerageError = GQLRetryableErrorPayload & {
  __typename?: 'IdentityBrokerageError';
  critical: Scalars['Boolean']['output'];
  error: Maybe<GQLErrorData>;
  message: Scalars['String']['output'];
  retryable: Scalars['Boolean']['output'];
};

export type GQLIdentityBrokerageMutationPayload = {
  __typename?: 'IdentityBrokerageMutationPayload';
  error: Maybe<GQLIdentityBrokerageError>;
  record: Maybe<GQLIdentityBrokerage>;
  serviceError: Maybe<GQLIdentityServiceError>;
};

export type GQLIdentityBrokerageMutations = {
  __typename?: 'IdentityBrokerageMutations';
  delete: GQLIdentityDeleteBrokeragePayload;
  expandedUpdate: GQLIdentityBrokerageMutationPayload;
  team: GQLIdentityBrokerageTeamMutations;
  update: GQLIdentityBrokerageMutationPayload;
};


export type GQLIdentityBrokerageMutationsexpandedUpdateArgs = {
  input: GQLUpdateIdentityBrokerageInput;
};


export type GQLIdentityBrokerageMutationsteamArgs = {
  id: Scalars['ID']['input'];
};


export type GQLIdentityBrokerageMutationsupdateArgs = {
  input: GQLUpdateIdentityBrokerageInput;
};

export type GQLIdentityBrokeragePayload = {
  __typename?: 'IdentityBrokeragePayload';
  /** @deprecated Changing to use Apollo errors, read Apollo error from record. */
  error: Maybe<GQLIdentityBrokerageError>;
  record: Maybe<GQLIdentityBrokerage>;
};

export type GQLIdentityBrokerageTeamDeleteError = GQLIdentityBrokerageError;

export type GQLIdentityBrokerageTeamDeletePayload = {
  __typename?: 'IdentityBrokerageTeamDeletePayload';
  error: Maybe<GQLIdentityBrokerageTeamDeleteError>;
  record: Maybe<GQLIdentityBrokerage>;
};

export type GQLIdentityBrokerageTeamMutations = {
  __typename?: 'IdentityBrokerageTeamMutations';
  delete: GQLIdentityBrokerageTeamDeletePayload;
};

export enum GQLIdentityBrokerageType {
  LFRO = 'LFRO',
  STANDARD = 'STANDARD'
}

export type GQLIdentityBrokeragesConnection = {
  __typename?: 'IdentityBrokeragesConnection';
  edges: Maybe<Array<Maybe<GQLIdentityBrokeragesEdge>>>;
  pageInfo: GQLPageInfo;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type GQLIdentityBrokeragesEdge = {
  __typename?: 'IdentityBrokeragesEdge';
  cursor: Maybe<Scalars['String']['output']>;
  node: Maybe<GQLIdentityBrokerage>;
};

export type GQLIdentityBrokeragesPayload = {
  __typename?: 'IdentityBrokeragesPayload';
  /** @deprecated Changing to use Apollo errors, read Apollo error from record. */
  error: Maybe<GQLIdentityBrokerageError>;
  record: Maybe<GQLIdentityBrokeragesResponse>;
};

export type GQLIdentityBrokeragesResponse = {
  __typename?: 'IdentityBrokeragesResponse';
  brokerages: Maybe<GQLIdentityBrokeragesConnection>;
};

export type GQLIdentityChangeHistory = {
  __typename?: 'IdentityChangeHistory';
  createdAt: Maybe<Scalars['String']['output']>;
  createdBy: Maybe<GQLIdentityChangeSource>;
  updatedAt: Maybe<Scalars['String']['output']>;
  updatedBy: Maybe<GQLIdentityChangeSource>;
};

export type GQLIdentityChangeSource = {
  __typename?: 'IdentityChangeSource';
  automation: Maybe<Scalars['String']['output']>;
  user: Maybe<GQLIdentityUser>;
};

export type GQLIdentityContact = GQLNode & {
  __typename?: 'IdentityContact';
  associations: Maybe<GQLIdentityContactAssociations>;
  id: Scalars['ID']['output'];
  isPersonal: Scalars['Boolean']['output'];
  isPrimary: Scalars['Boolean']['output'];
  personal: Scalars['Boolean']['output'];
  type: Maybe<GQLIdentityContactType>;
  value: Scalars['String']['output'];
};

export type GQLIdentityContactAddNewMutationPayload = {
  __typename?: 'IdentityContactAddNewMutationPayload';
  error: Maybe<GQLIdentityCreateUserContactError>;
  record: Maybe<GQLIdentityUser>;
};

export type GQLIdentityContactAssociations = {
  __typename?: 'IdentityContactAssociations';
  associations: Maybe<Array<GQLIdentityAssociations>>;
  brokerages: Maybe<Array<GQLIdentityBrokerage>>;
  members: Maybe<Array<GQLIdentityTeamMember>>;
  teams: Maybe<Array<GQLIdentityTeam>>;
};

export type GQLIdentityContactError = GQLRetryableErrorPayload & {
  __typename?: 'IdentityContactError';
  critical: Scalars['Boolean']['output'];
  error: Maybe<GQLErrorData>;
  message: Scalars['String']['output'];
  retryable: Scalars['Boolean']['output'];
};

export enum GQLIdentityContactType {
  EMAIL = 'EMAIL',
  PHONE = 'PHONE'
}

export type GQLIdentityCreateAddressError = GQLMutationProblem & {
  __typename?: 'IdentityCreateAddressError';
  code: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type GQLIdentityCreateAddressInput = {
  city: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  state: GQLIdentityStateCode;
  street1: Scalars['String']['input'];
  street2?: InputMaybe<Scalars['String']['input']>;
};

export type GQLIdentityCreateAddressPayload = GQLMutationPayload & {
  __typename?: 'IdentityCreateAddressPayload';
  errors: Maybe<Array<GQLIdentityCreateAddressError>>;
  query: Maybe<GQLQuery>;
  record: Maybe<GQLIdentityAddress>;
  status: Maybe<GQLMutationStatus>;
};

export type GQLIdentityCreateTeamMemberError = GQLIdentityTeamMemberError;

export type GQLIdentityCreateUserContactError = GQLIdentityContactError;

export type GQLIdentityDeleteBrokeragePayload = {
  __typename?: 'IdentityDeleteBrokeragePayload';
  error: Maybe<GQLIdentityBrokerageError>;
  record: Maybe<GQLIdentityDeleteResourceAcknowledgement>;
};

export type GQLIdentityDeleteResourceAcknowledgement = {
  __typename?: 'IdentityDeleteResourceAcknowledgement';
  success: Scalars['Boolean']['output'];
};

export enum GQLIdentityExpirationStatus {
  ACTIVE = 'ACTIVE',
  EXPIRED = 'EXPIRED',
  EXPIRING_SOON = 'EXPIRING_SOON',
  NO_EXPIRATION = 'NO_EXPIRATION'
}

export type GQLIdentityLaunchManager = {
  __typename?: 'IdentityLaunchManager';
  contact: GQLIdentityTeamMinimalContact;
  displayName: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  photoUrl: Maybe<Scalars['String']['output']>;
  userId: Maybe<Scalars['String']['output']>;
};

export type GQLIdentityLicense = GQLNode & {
  __typename?: 'IdentityLicense';
  associations: Maybe<Array<GQLIdentityAssociations>>;
  brokerages: Maybe<Array<Maybe<GQLIdentityBrokerage>>>;
  expiration: Maybe<Scalars['String']['output']>;
  expirationStatus: Maybe<GQLIdentityExpirationStatus>;
  externalId: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  metadata: Maybe<GQLIdentityChangeHistory>;
  number: Maybe<Scalars['String']['output']>;
  state: Maybe<GQLIdentitySupportedState>;
  teamMembers: Maybe<Array<Maybe<GQLIdentityTeamMember>>>;
  teams: Maybe<Array<Maybe<GQLIdentityTeam>>>;
};

export type GQLIdentityLicenseAddNewMutationPayload = {
  __typename?: 'IdentityLicenseAddNewMutationPayload';
  error: Maybe<GQLIdentityUserLicenseAddNewErrorPayload>;
  record: Maybe<GQLIdentityUser>;
};

export type GQLIdentityLicenseDeleteError = GQLRetryableErrorPayload & {
  __typename?: 'IdentityLicenseDeleteError';
  critical: Scalars['Boolean']['output'];
  error: Maybe<GQLErrorData>;
  message: Scalars['String']['output'];
  retryable: Scalars['Boolean']['output'];
};

export type GQLIdentityLicenseDuplicateError = GQLErrorPayload & {
  __typename?: 'IdentityLicenseDuplicateError';
  critical: Scalars['Boolean']['output'];
  error: Maybe<GQLErrorData>;
  message: Scalars['String']['output'];
  retryable: Scalars['Boolean']['output'];
};

export type GQLIdentityLicenseError = GQLRetryableErrorPayload & {
  __typename?: 'IdentityLicenseError';
  critical: Scalars['Boolean']['output'];
  error: Maybe<GQLErrorData>;
  message: Scalars['String']['output'];
  retryable: Scalars['Boolean']['output'];
};

export type GQLIdentityLicenseExpiredError = GQLErrorPayload & {
  __typename?: 'IdentityLicenseExpiredError';
  critical: Scalars['Boolean']['output'];
  error: Maybe<GQLErrorData>;
  message: Scalars['String']['output'];
  retryable: Scalars['Boolean']['output'];
};

export type GQLIdentityLicenseIsAssociatedError = GQLErrorPayload & {
  __typename?: 'IdentityLicenseIsAssociatedError';
  critical: Scalars['Boolean']['output'];
  error: Maybe<GQLErrorData>;
  message: Scalars['String']['output'];
  retryable: Scalars['Boolean']['output'];
};

export type GQLIdentityLicenseNotFoundError = GQLErrorPayload & {
  __typename?: 'IdentityLicenseNotFoundError';
  critical: Scalars['Boolean']['output'];
  error: Maybe<GQLErrorData>;
  message: Scalars['String']['output'];
  retryable: Scalars['Boolean']['output'];
};

export type GQLIdentityLicensePayload = GQLIdentityLicense | GQLIdentityLicenseError | GQLIdentityLicenseNotFoundError;

export type GQLIdentityLicenseUnsupportedStateError = GQLErrorPayload & {
  __typename?: 'IdentityLicenseUnsupportedStateError';
  critical: Scalars['Boolean']['output'];
  error: Maybe<GQLErrorData>;
  message: Scalars['String']['output'];
  retryable: Scalars['Boolean']['output'];
};

export type GQLIdentityLicenseUpdateMutationPayload = {
  __typename?: 'IdentityLicenseUpdateMutationPayload';
  error: Maybe<GQLIdentityUserLicenseUpdateErrorPayload>;
  license: Maybe<GQLIdentityLicense>;
  record: Maybe<GQLIdentityUser>;
  serviceError: Maybe<GQLIdentityServiceError>;
};

export type GQLIdentityLogin = GQLNode & {
  __typename?: 'IdentityLogin';
  email: Maybe<Scalars['String']['output']>;
  externalId: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  provider: Maybe<Scalars['String']['output']>;
  userName: Maybe<Scalars['String']['output']>;
};

export type GQLIdentityMeError = GQLRetryableErrorPayload & {
  __typename?: 'IdentityMeError';
  critical: Scalars['Boolean']['output'];
  error: Maybe<GQLErrorData>;
  message: Scalars['String']['output'];
  retryable: Scalars['Boolean']['output'];
};

export type GQLIdentityMePayload = {
  __typename?: 'IdentityMePayload';
  /** @deprecated Changing to use Apollo errors, read Apollo error from record. */
  error: Maybe<GQLIdentityMeError>;
  record: Maybe<GQLIdentityUser>;
};

export type GQLIdentityMultipleListingService = {
  __typename?: 'IdentityMultipleListingService';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  listingIdTip: Maybe<Scalars['String']['output']>;
  locales: Array<GQLIdentityStateCode>;
  name: Scalars['String']['output'];
  provider: Scalars['String']['output'];
  providerId: Maybe<Scalars['String']['output']>;
};

export type GQLIdentityOfficeManager = {
  __typename?: 'IdentityOfficeManager';
  contact: GQLIdentityOfficeManagerContact;
  displayName: Maybe<Scalars['String']['output']>;
  externalId: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  legacyExternalId: Maybe<Scalars['String']['output']>;
  license: Maybe<GQLIdentityOfficeManagerLicense>;
  photoUrl: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
};

export type GQLIdentityOfficeManagerContact = {
  __typename?: 'IdentityOfficeManagerContact';
  email: Scalars['String']['output'];
  phone: Maybe<Scalars['String']['output']>;
};

export type GQLIdentityOfficeManagerLicense = {
  __typename?: 'IdentityOfficeManagerLicense';
  expiration: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  number: Scalars['String']['output'];
  state: Scalars['String']['output'];
};

export type GQLIdentityOrganization = {
  __typename?: 'IdentityOrganization';
  teams: Array<Maybe<GQLIdentityTeamPayload>>;
};

export type GQLIdentityOrganizationError = GQLErrorPayload & {
  __typename?: 'IdentityOrganizationError';
  critical: Scalars['Boolean']['output'];
  error: Maybe<GQLErrorData>;
  message: Scalars['String']['output'];
  retryable: Scalars['Boolean']['output'];
};

export type GQLIdentityOrganizationPayload = GQLIdentityOrganization | GQLIdentityOrganizationError;

export type GQLIdentityServiceError = {
  __typename?: 'IdentityServiceError';
  code: Scalars['String']['output'];
  error: Scalars['String']['output'];
  errors: Maybe<Array<GQLIdentityServiceErrorsListItem>>;
  message: Scalars['String']['output'];
  reasons: Maybe<Array<GQLIdentityServiceErrorReasons>>;
  statusCode: Scalars['Int']['output'];
};

export type GQLIdentityServiceErrorReasons = {
  __typename?: 'IdentityServiceErrorReasons';
  key: Scalars['String']['output'];
  message: Maybe<Scalars['String']['output']>;
  type: GQLIdentityServiceErrorReasonsType;
  value: Scalars['String']['output'];
};

export enum GQLIdentityServiceErrorReasonsType {
  field = 'field',
  resource = 'resource'
}

export type GQLIdentityServiceErrorsListItem = {
  __typename?: 'IdentityServiceErrorsListItem';
  detail: Scalars['String']['output'];
  keyword: Scalars['String']['output'];
  pointer: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type GQLIdentitySignatureError = GQLMutationProblem & {
  __typename?: 'IdentitySignatureError';
  code: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type GQLIdentityState = {
  __typename?: 'IdentityState';
  code: GQLIdentityStateCode;
  name: Scalars['String']['output'];
};

export enum GQLIdentityStateCode {
  /** Alaska */
  AK = 'AK',
  /** Alabama */
  AL = 'AL',
  /** Arkansas */
  AR = 'AR',
  /** American Samoa */
  AS = 'AS',
  /** Arizona */
  AZ = 'AZ',
  /** California */
  CA = 'CA',
  /** Colorado */
  CO = 'CO',
  /** Connecticut */
  CT = 'CT',
  /** District of Columbia */
  DC = 'DC',
  /** Delaware */
  DE = 'DE',
  /** Florida */
  FL = 'FL',
  /** Federated States of Micronesia */
  FM = 'FM',
  /** Georgia */
  GA = 'GA',
  /** Guam */
  GU = 'GU',
  /** Hawaii */
  HI = 'HI',
  /** Iowa */
  IA = 'IA',
  /** Idaho */
  ID = 'ID',
  /** Illinois */
  IL = 'IL',
  /** Indiana */
  IN = 'IN',
  /** Kansas */
  KS = 'KS',
  /** Kentucky */
  KY = 'KY',
  /** Louisiana */
  LA = 'LA',
  /** Massachusetts */
  MA = 'MA',
  /** Maryland */
  MD = 'MD',
  /** Maine */
  ME = 'ME',
  /** Marshall Islands */
  MH = 'MH',
  /** Michigan */
  MI = 'MI',
  /** Minnesota */
  MN = 'MN',
  /** Missouri */
  MO = 'MO',
  /** Northern Mariana Islands */
  MP = 'MP',
  /** Mississippi */
  MS = 'MS',
  /** Montana */
  MT = 'MT',
  /** North Carolina */
  NC = 'NC',
  /** North Dakota */
  ND = 'ND',
  /** Nebraska */
  NE = 'NE',
  /** New Hampshire */
  NH = 'NH',
  /** New Jersey */
  NJ = 'NJ',
  /** New Mexico */
  NM = 'NM',
  /** Nevada */
  NV = 'NV',
  /** New York */
  NY = 'NY',
  /** Ohio */
  OH = 'OH',
  /** Oklahoma */
  OK = 'OK',
  /** Oregon */
  OR = 'OR',
  /** Pennsylvania */
  PA = 'PA',
  /** Puerto Rico */
  PR = 'PR',
  /** Palau */
  PW = 'PW',
  /** Rhode Island */
  RI = 'RI',
  /** South Carolina */
  SC = 'SC',
  /** South Dakota */
  SD = 'SD',
  /** Tennessee */
  TN = 'TN',
  /** Texas */
  TX = 'TX',
  /** Utah */
  UT = 'UT',
  /** Virginia */
  VA = 'VA',
  /** Virgin Islands */
  VI = 'VI',
  /** Vermont */
  VT = 'VT',
  /** Washington */
  WA = 'WA',
  /** Wisconsin */
  WI = 'WI',
  /** West Virginia */
  WV = 'WV',
  /** Wyoming */
  WY = 'WY'
}

export type GQLIdentitySuccessManager = {
  __typename?: 'IdentitySuccessManager';
  contact: GQLIdentityTeamMinimalContact;
  displayName: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  photoUrl: Maybe<Scalars['String']['output']>;
  userId: Maybe<Scalars['String']['output']>;
};

export type GQLIdentitySupportedCountry = {
  __typename?: 'IdentitySupportedCountry';
  code: GQLIdentitySupportedCountryCode;
};

export enum GQLIdentitySupportedCountryCode {
  /** United States */
  US = 'US'
}

export type GQLIdentitySupportedState = {
  __typename?: 'IdentitySupportedState';
  code: GQLIdentitySupportedStateCode;
  name: Scalars['String']['output'];
};

export enum GQLIdentitySupportedStateCode {
  /** Arizona */
  AZ = 'AZ',
  /** California */
  CA = 'CA',
  /** Colorado */
  CO = 'CO',
  /** District of Columbia */
  DC = 'DC',
  /** Florida */
  FL = 'FL',
  /** Georgia */
  GA = 'GA',
  /** Kentucky */
  KY = 'KY',
  /** Massachusetts */
  MA = 'MA',
  /** Maryland */
  MD = 'MD',
  /** North Carolina */
  NC = 'NC',
  /** New Jersey */
  NJ = 'NJ',
  /** Nevada */
  NV = 'NV',
  /** New York */
  NY = 'NY',
  /** Ohio */
  OH = 'OH',
  /** Oregon */
  OR = 'OR',
  /** South Carolina */
  SC = 'SC',
  /** Texas */
  TX = 'TX',
  /** Virginia */
  VA = 'VA',
  /** Washington */
  WA = 'WA'
}

/** An extension on the IdentityTeam type that includes the payments field */
export type GQLIdentityTeam = GQLNode & {
  __typename?: 'IdentityTeam';
  accountingSupplierId: Maybe<Scalars['String']['output']>;
  alias: Scalars['String']['output'];
  brandId: Maybe<Scalars['ID']['output']>;
  brokerage: Maybe<GQLIdentityBrokerage>;
  brokerageId: Maybe<Scalars['ID']['output']>;
  description: Maybe<Scalars['String']['output']>;
  doingBusinessAs: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  externalId: Maybe<Scalars['String']['output']>;
  gtmSegment: Maybe<GQLIdentityTeamGTMSegemnt>;
  /** @deprecated Use IdentityTeam.logoHorizontalUri instead */
  horizontalLogoUri: Maybe<Scalars['String']['output']>;
  /** @deprecated Use IdentityTeam.logoHorizontalUriAlt instead */
  horizontalLogoUriAlt: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  integrations: Array<GQLIntegrations>;
  isCompliant: Maybe<Scalars['Boolean']['output']>;
  isInstantPayEligible: Scalars['Boolean']['output'];
  launchManager: Maybe<GQLIdentityLaunchManager>;
  leadAgents: Array<GQLIdentityUser>;
  legacyExternalId: Maybe<Scalars['String']['output']>;
  legalName: Maybe<Scalars['String']['output']>;
  logoHorizontalUri: Maybe<Scalars['String']['output']>;
  logoHorizontalUriAlt: Maybe<Scalars['String']['output']>;
  logoUri: Maybe<Scalars['String']['output']>;
  logoUriAlt: Maybe<Scalars['String']['output']>;
  mailingAddress: Maybe<GQLIdentityAddress>;
  members: Maybe<Array<Maybe<GQLIdentityTeamMember>>>;
  metadata: Maybe<GQLIdentityChangeHistory>;
  mlsMemberships: Array<GQLIdentityTeamMlsMembership>;
  mlsOfficeEmail: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  nrdsId: Maybe<Scalars['String']['output']>;
  officeManager: Maybe<GQLIdentityOfficeManager>;
  organization: Maybe<GQLIdentityOrganizationPayload>;
  parentTeam: Maybe<GQLIdentityTeamPayload>;
  paymentHistory: GQLHistoryPaginationResult;
  paymentMembers: GQLTeamMembersV2PaginationResult;
  paymentsId: Maybe<Scalars['ID']['output']>;
  phoneNumber: Maybe<Scalars['String']['output']>;
  registeredAddress: Maybe<GQLIdentityAddress>;
  status: GQLIdentityTeamStatus;
  successManager: Maybe<GQLIdentitySuccessManager>;
  supervisingBroker: Maybe<GQLIdentityBroker>;
  transactionCoordinators: Maybe<GQLIdentityTransactionCoordinatorPayload>;
  type: Scalars['String']['output'];
  useAutoSendStatements: Scalars['Boolean']['output'];
  websiteUrl: Maybe<Scalars['String']['output']>;
  zendeskType: Maybe<GQLIdentityTeamType>;
};


/** An extension on the IdentityTeam type that includes the payments field */
export type GQLIdentityTeampaymentHistoryArgs = {
  input: GQLPaginationInput;
};


/** An extension on the IdentityTeam type that includes the payments field */
export type GQLIdentityTeampaymentMembersArgs = {
  input: GQLTeamMembersByTeamInput;
};

export type GQLIdentityTeamAddNewMutations = {
  __typename?: 'IdentityTeamAddNewMutations';
  teamMember: Maybe<GQLIdentityTeamMemberAddNewMutationPayload>;
};


export type GQLIdentityTeamAddNewMutationsteamMemberArgs = {
  input: GQLCreateIdentityTeamMemberInput;
};

export type GQLIdentityTeamDeletePayload = {
  __typename?: 'IdentityTeamDeletePayload';
  error: Maybe<GQLIdentityTeamError>;
  record: Maybe<GQLIdentityDeleteResourceAcknowledgement>;
};

export type GQLIdentityTeamError = GQLRetryableErrorPayload & {
  __typename?: 'IdentityTeamError';
  critical: Scalars['Boolean']['output'];
  error: Maybe<GQLErrorData>;
  message: Scalars['String']['output'];
  retryable: Scalars['Boolean']['output'];
};

export type GQLIdentityTeamGTMSegemnt = {
  __typename?: 'IdentityTeamGTMSegemnt';
  code: Maybe<GQLIdentityTeamGTMSegemntCode>;
  name: Maybe<Scalars['String']['output']>;
};

export enum GQLIdentityTeamGTMSegemntCode {
  CORE = 'CORE',
  EMERGING = 'EMERGING',
  LIMITED_OFFERING = 'LIMITED_OFFERING',
  ON_DEMAND = 'ON_DEMAND',
  STRATEGIC = 'STRATEGIC'
}

export type GQLIdentityTeamLocation = GQLNode & {
  __typename?: 'IdentityTeamLocation';
  alias: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isOffboarding: Scalars['Boolean']['output'];
  legalName: Maybe<Scalars['String']['output']>;
  logoHorizontalUri: Maybe<Scalars['String']['output']>;
  logoUri: Maybe<Scalars['String']['output']>;
  mailingAddress: Maybe<GQLIdentityAddress>;
  rootTeam: GQLIdentityTeam;
  status: GQLIdentityTeamStatus;
};

export type GQLIdentityTeamLocationsConnection = {
  __typename?: 'IdentityTeamLocationsConnection';
  edges: Maybe<Array<Maybe<GQLIdentityTeamLocationsEdge>>>;
  pageInfo: GQLPageInfo;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type GQLIdentityTeamLocationsEdge = {
  __typename?: 'IdentityTeamLocationsEdge';
  cursor: Maybe<Scalars['String']['output']>;
  node: Maybe<GQLIdentityTeamLocation>;
};

export type GQLIdentityTeamMate = {
  __typename?: 'IdentityTeamMate';
  permissions: Maybe<GQLIdentityTeamMatePermissions>;
  teamMember: Maybe<GQLIdentityTeamMember>;
};

/**
 * Transaction permissions are relative to the team member user.
 * CORE GET user-settintgs/:teamMemberUserId/submit-as-permissions -> [:teamMateUserId]
 * CORE GET user-settintgs/:teamMemberUserId/sharing-permissions -> [:teamMateUserId]
 */
export type GQLIdentityTeamMatePermissions = {
  __typename?: 'IdentityTeamMatePermissions';
  submitAs: Maybe<Scalars['Boolean']['output']>;
  transactionSharing: Maybe<Scalars['Boolean']['output']>;
};

export type GQLIdentityTeamMember = GQLNode & {
  __typename?: 'IdentityTeamMember';
  assignments: Maybe<Array<Maybe<GQLIdentityTeamMember>>>;
  contacts: Maybe<GQLIdentityTeamMemberContacts>;
  email: Scalars['String']['output'];
  externalId: Maybe<Scalars['String']['output']>;
  formattedDisplayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  legacyExternalId: Maybe<Scalars['String']['output']>;
  license: Maybe<GQLIdentityLicense>;
  metadata: Maybe<GQLIdentityChangeHistory>;
  phoneNumber: Maybe<Scalars['String']['output']>;
  preferences: Maybe<GQLIdentityTeamMemberPreferences>;
  roles: Array<GQLIdentityTeamMemberRole>;
  status: Maybe<GQLIdentityTeamMemberStatus>;
  team: GQLIdentityTeam;
  teamMates: Array<GQLIdentityTeamMate>;
  transactionCoordinators: Maybe<Array<GQLIdentityUser>>;
  user: GQLIdentityUser;
};

export type GQLIdentityTeamMemberAddNewMutationPayload = {
  __typename?: 'IdentityTeamMemberAddNewMutationPayload';
  error: Maybe<GQLIdentityCreateTeamMemberError>;
  record: Maybe<GQLIdentityTeam>;
};

export type GQLIdentityTeamMemberAddNewMutations = {
  __typename?: 'IdentityTeamMemberAddNewMutations';
  contact: Maybe<GQLIdentityTeamTeamMemberContactAddPayload>;
};


export type GQLIdentityTeamMemberAddNewMutationscontactArgs = {
  input: GQLAddIdentityTeamMemberContactInput;
};

export type GQLIdentityTeamMemberConnection = {
  __typename?: 'IdentityTeamMemberConnection';
  edges: Maybe<Array<Maybe<GQLIdentityTeamMembersEdge>>>;
  pageInfo: GQLPageInfo;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type GQLIdentityTeamMemberContact = {
  __typename?: 'IdentityTeamMemberContact';
  address: Maybe<GQLIdentityAddress>;
  cellPhone: Maybe<Scalars['String']['output']>;
  companyName: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName: Maybe<Scalars['String']['output']>;
  role: Maybe<Scalars['String']['output']>;
  titleNumber: Maybe<Scalars['String']['output']>;
};

export type GQLIdentityTeamMemberContactMutations = {
  __typename?: 'IdentityTeamMemberContactMutations';
  update: GQLIdentityTeamTeamMemberContactUpdatePayload;
};


export type GQLIdentityTeamMemberContactMutationsupdateArgs = {
  input: GQLUpdateIdentityTeamMemberContactInput;
};

export enum GQLIdentityTeamMemberContactType {
  escrow_officer = 'escrow_officer',
  title_officer = 'title_officer'
}

export type GQLIdentityTeamMemberContacts = {
  __typename?: 'IdentityTeamMemberContacts';
  escrowOfficer: Maybe<GQLIdentityTeamMemberContact>;
  titleOfficer: Maybe<GQLIdentityTeamMemberContact>;
};

export type GQLIdentityTeamMemberDeleteError = GQLRetryableErrorPayload & {
  __typename?: 'IdentityTeamMemberDeleteError';
  critical: Scalars['Boolean']['output'];
  error: Maybe<GQLErrorData>;
  message: Scalars['String']['output'];
  retryable: Scalars['Boolean']['output'];
};

export type GQLIdentityTeamMemberDeleteErrorPayload = GQLIdentityTeamMemberDeleteError | GQLIdentityTeamMemberNotFoundError;

export type GQLIdentityTeamMemberDeletePayload = {
  __typename?: 'IdentityTeamMemberDeletePayload';
  error: Maybe<GQLIdentityTeamMemberDeleteErrorPayload>;
  record: Maybe<GQLIdentityTeam>;
};

export type GQLIdentityTeamMemberError = GQLRetryableErrorPayload & {
  __typename?: 'IdentityTeamMemberError';
  critical: Scalars['Boolean']['output'];
  error: Maybe<GQLErrorData>;
  message: Scalars['String']['output'];
  retryable: Scalars['Boolean']['output'];
};

export type GQLIdentityTeamMemberInput = {
  teamId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type GQLIdentityTeamMemberMlsPreference = {
  __typename?: 'IdentityTeamMemberMlsPreference';
  mls: GQLMlsVendor;
  primary: Scalars['Boolean']['output'];
};

export type GQLIdentityTeamMemberMutationPayload = {
  __typename?: 'IdentityTeamMemberMutationPayload';
  error: Maybe<GQLIdentityTeamMemberError>;
  record: Maybe<GQLIdentityTeamMember>;
};

export type GQLIdentityTeamMemberMutations = {
  __typename?: 'IdentityTeamMemberMutations';
  addNew: GQLIdentityTeamMemberAddNewMutations;
  contact: Maybe<GQLIdentityTeamMemberContactMutations>;
  delete: Maybe<GQLIdentityTeamMemberDeletePayload>;
  preferences: Maybe<GQLIdentityTeamMemberPreferencesMutations>;
  transactionCoordinators: Maybe<GQLIdentityTeamMemberTransactionCoordinatorsMutations>;
  update: Maybe<GQLIdentityTeamTeamMembersUpdatePayload>;
};


export type GQLIdentityTeamMemberMutationscontactArgs = {
  id: Scalars['ID']['input'];
};


export type GQLIdentityTeamMemberMutationsupdateArgs = {
  input: GQLUpdateIdentityTeamMemberInput;
};

export type GQLIdentityTeamMemberNotFoundError = GQLErrorPayload & {
  __typename?: 'IdentityTeamMemberNotFoundError';
  critical: Scalars['Boolean']['output'];
  error: Maybe<GQLErrorData>;
  message: Scalars['String']['output'];
  retryable: Scalars['Boolean']['output'];
};

export type GQLIdentityTeamMemberPayload = {
  __typename?: 'IdentityTeamMemberPayload';
  /** @deprecated Changing to use Apollo errors, read Apollo error from record. */
  error: Maybe<GQLIdentityTeamMemberError>;
  record: Maybe<GQLIdentityTeamMember>;
};

export type GQLIdentityTeamMemberPreferenceMlsService = {
  id: Scalars['ID']['input'];
  primary: Scalars['Boolean']['input'];
};

export type GQLIdentityTeamMemberPreferences = {
  __typename?: 'IdentityTeamMemberPreferences';
  agentCommission: Maybe<Scalars['String']['output']>;
  docusignCarbonCopy: Array<Scalars['String']['output']>;
  expandedMlsSubscriptions: Array<Maybe<GQLMlsVendor>>;
  listingPeriod: Maybe<Scalars['String']['output']>;
  mlsPreferences: Array<GQLIdentityTeamMemberMlsPreference>;
  primaryMLS: Maybe<GQLMlsVendor>;
  sellingAgentCommission: Maybe<Scalars['String']['output']>;
};

export type GQLIdentityTeamMemberPreferencesMutations = {
  __typename?: 'IdentityTeamMemberPreferencesMutations';
  update: Maybe<GQLIdentityTeamTeamMemberPreferencesUpdatePayload>;
};


export type GQLIdentityTeamMemberPreferencesMutationsupdateArgs = {
  input: GQLUpdateIdentityTeamMemberPreferencesInput;
};

export type GQLIdentityTeamMemberRole = {
  __typename?: 'IdentityTeamMemberRole';
  code: GQLIdentityTeamMemberRoleCode;
  name: Scalars['String']['output'];
};

export enum GQLIdentityTeamMemberRoleCode {
  /** Agent */
  AGENT = 'AGENT',
  /** Lead */
  LEAD = 'LEAD',
  /** Member */
  MEMBER = 'MEMBER',
  /** Referral agent */
  REFERRAL_AGENT = 'REFERRAL_AGENT',
  /** Transaction coordinator */
  TRANSACTION_COORDINATOR = 'TRANSACTION_COORDINATOR'
}

export enum GQLIdentityTeamMemberStatus {
  ACTIVE = 'ACTIVE',
  DRAFT = 'DRAFT',
  INACTIVE = 'INACTIVE',
  OFFBOARDING = 'OFFBOARDING',
  ONBOARDING = 'ONBOARDING'
}

export type GQLIdentityTeamMemberTransactionCoordinatorsMutations = {
  __typename?: 'IdentityTeamMemberTransactionCoordinatorsMutations';
  add: Maybe<GQLIdentityTeamMemberMutationPayload>;
  remove: Maybe<GQLIdentityTeamMemberMutationPayload>;
};


export type GQLIdentityTeamMemberTransactionCoordinatorsMutationsaddArgs = {
  tcUserId: Scalars['ID']['input'];
};


export type GQLIdentityTeamMemberTransactionCoordinatorsMutationsremoveArgs = {
  tcUserId: Scalars['ID']['input'];
};

export type GQLIdentityTeamMemberUpdateError = GQLRetryableErrorPayload & {
  __typename?: 'IdentityTeamMemberUpdateError';
  critical: Scalars['Boolean']['output'];
  error: Maybe<GQLErrorData>;
  message: Scalars['String']['output'];
  retryable: Scalars['Boolean']['output'];
};

export type GQLIdentityTeamMembersEdge = {
  __typename?: 'IdentityTeamMembersEdge';
  cursor: Maybe<Scalars['String']['output']>;
  node: Maybe<GQLIdentityTeamMember>;
};

export type GQLIdentityTeamMembersError = GQLRetryableErrorPayload & {
  __typename?: 'IdentityTeamMembersError';
  critical: Scalars['Boolean']['output'];
  error: Maybe<GQLErrorData>;
  message: Scalars['String']['output'];
  retryable: Scalars['Boolean']['output'];
};

export type GQLIdentityTeamMinimalContact = {
  __typename?: 'IdentityTeamMinimalContact';
  email: Maybe<Scalars['String']['output']>;
  phone: Maybe<Scalars['String']['output']>;
};

export type GQLIdentityTeamMlsMembership = {
  __typename?: 'IdentityTeamMlsMembership';
  id: Scalars['ID']['output'];
  multipleListingService: GQLIdentityMultipleListingService;
  primary: Scalars['Boolean']['output'];
  registrationNumber: Scalars['String']['output'];
  teamId: Scalars['ID']['output'];
};

export type GQLIdentityTeamMutations = {
  __typename?: 'IdentityTeamMutations';
  addNew: Maybe<GQLIdentityTeamAddNewMutations>;
  delete: GQLIdentityTeamDeletePayload;
  supervisingBroker: Maybe<GQLIdentityTeamSupervisingBrokerMutations>;
  teamMember: Maybe<GQLIdentityTeamMemberMutations>;
  update: Maybe<GQLIdentityTeamPayload>;
};


export type GQLIdentityTeamMutationsteamMemberArgs = {
  id: Scalars['ID']['input'];
};


export type GQLIdentityTeamMutationsupdateArgs = {
  input: GQLUpdateIdentityTeamMutationInput;
};

export type GQLIdentityTeamNotFoundError = GQLErrorPayload & {
  __typename?: 'IdentityTeamNotFoundError';
  critical: Scalars['Boolean']['output'];
  error: Maybe<GQLErrorData>;
  message: Scalars['String']['output'];
  retryable: Scalars['Boolean']['output'];
};

export type GQLIdentityTeamPayload = GQLIdentityTeam | GQLIdentityTeamError | GQLIdentityTeamNotFoundError;

export enum GQLIdentityTeamStatus {
  ACTIVE = 'ACTIVE',
  DRAFT = 'DRAFT',
  INACTIVE = 'INACTIVE',
  OFFBOARDING = 'OFFBOARDING',
  ONBOARDING = 'ONBOARDING'
}

export type GQLIdentityTeamSupervisingBrokerError = GQLRetryableErrorPayload & {
  __typename?: 'IdentityTeamSupervisingBrokerError';
  critical: Scalars['Boolean']['output'];
  error: Maybe<GQLErrorData>;
  message: Scalars['String']['output'];
  retryable: Scalars['Boolean']['output'];
};

export type GQLIdentityTeamSupervisingBrokerMutations = {
  __typename?: 'IdentityTeamSupervisingBrokerMutations';
  update: Maybe<GQLIdentityUpdateTeamSupervisingBrokerPayload>;
};


export type GQLIdentityTeamSupervisingBrokerMutationsupdateArgs = {
  input: GQLUpdateIdentityTeamSupervisingBroker;
};

export type GQLIdentityTeamTeamMemberContactAddPayload = {
  __typename?: 'IdentityTeamTeamMemberContactAddPayload';
  error: Maybe<GQLIdentityAddTeamMemberContactError>;
  record: Maybe<GQLIdentityTeamMember>;
};

export type GQLIdentityTeamTeamMemberContactUpdatePayload = {
  __typename?: 'IdentityTeamTeamMemberContactUpdatePayload';
  error: Maybe<GQLIdentityUpdateTeamMemberContactError>;
  record: Maybe<GQLIdentityTeamMember>;
};

export type GQLIdentityTeamTeamMemberPreferencesUpdatePayload = {
  __typename?: 'IdentityTeamTeamMemberPreferencesUpdatePayload';
  error: Maybe<GQLIdentityUpdateTeamMemberPreferencesError>;
  record: Maybe<GQLIdentityTeamMember>;
};

export type GQLIdentityTeamTeamMembersUpdatePayload = {
  __typename?: 'IdentityTeamTeamMembersUpdatePayload';
  error: Maybe<GQLIdentityUpdateTeamMemberPayloadError>;
  record: Maybe<GQLIdentityTeam>;
};

export type GQLIdentityTeamType = {
  __typename?: 'IdentityTeamType';
  code: Maybe<GQLIdentityTeamTypeCode>;
  name: Maybe<Scalars['String']['output']>;
};

export enum GQLIdentityTeamTypeCode {
  EXPANSION_MARKET = 'EXPANSION_MARKET',
  EXTENDED_OFFERING_CO_BRAND = 'EXTENDED_OFFERING_CO_BRAND',
  EXTENDED_OFFERING_STANDALONE = 'EXTENDED_OFFERING_STANDALONE',
  TRADITIONAL = 'TRADITIONAL'
}

export type GQLIdentityTeamsConnection = {
  __typename?: 'IdentityTeamsConnection';
  edges: Maybe<Array<Maybe<GQLIdentityTeamsEdge>>>;
  pageInfo: GQLPageInfo;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type GQLIdentityTeamsEdge = {
  __typename?: 'IdentityTeamsEdge';
  cursor: Maybe<Scalars['String']['output']>;
  node: Maybe<GQLIdentityTeam>;
};

export type GQLIdentityTeamsPayload = {
  __typename?: 'IdentityTeamsPayload';
  /** @deprecated Changing to use Apollo errors, read Apollo error from record. */
  error: Maybe<GQLIdentityTeamError>;
  record: Maybe<GQLIdentityTeamsResponse>;
};

export type GQLIdentityTeamsResponse = {
  __typename?: 'IdentityTeamsResponse';
  teams: Maybe<GQLIdentityTeamsConnection>;
};

export type GQLIdentityTransactionCoordinatorPayload = {
  __typename?: 'IdentityTransactionCoordinatorPayload';
  error: Maybe<GQLIdentityTeamMembersError>;
  /** @deprecated Changing to use Apollo errors, read Apollo error from record. */
  record: Maybe<Array<GQLIdentityTeamMember>>;
};

export type GQLIdentityUpdateTeamMemberContactError = GQLRetryableErrorPayload & {
  __typename?: 'IdentityUpdateTeamMemberContactError';
  critical: Scalars['Boolean']['output'];
  error: Maybe<GQLErrorData>;
  message: Scalars['String']['output'];
  retryable: Scalars['Boolean']['output'];
};

export type GQLIdentityUpdateTeamMemberPayloadError = GQLIdentityTeamMemberNotFoundError | GQLIdentityTeamMemberUpdateError;

export type GQLIdentityUpdateTeamMemberPreferencesError = GQLRetryableErrorPayload & {
  __typename?: 'IdentityUpdateTeamMemberPreferencesError';
  critical: Scalars['Boolean']['output'];
  error: Maybe<GQLErrorData>;
  message: Scalars['String']['output'];
  retryable: Scalars['Boolean']['output'];
};

export type GQLIdentityUpdateTeamSupervisingBrokerPayload = {
  __typename?: 'IdentityUpdateTeamSupervisingBrokerPayload';
  error: Maybe<GQLIdentityTeamSupervisingBrokerError>;
  record: Maybe<GQLIdentityTeam>;
};

export type GQLIdentityUpdateUserContactError = GQLIdentityContactError;

export type GQLIdentityUpdateUserContactPayload = {
  __typename?: 'IdentityUpdateUserContactPayload';
  error: Maybe<GQLIdentityUpdateUserContactError>;
  record: Maybe<GQLIdentityUser>;
};

export type GQLIdentityUpdateUserSignaturePayload = GQLMutationPayload & {
  __typename?: 'IdentityUpdateUserSignaturePayload';
  errors: Maybe<Array<GQLIdentitySignatureError>>;
  query: Maybe<GQLQuery>;
  record: Maybe<GQLIdentityUser>;
  status: GQLMutationStatus;
};

export type GQLIdentityUser = GQLNode & {
  __typename?: 'IdentityUser';
  address: Maybe<GQLIdentityAddress>;
  agentTeam: Maybe<GQLIdentityTeam>;
  brokerAssignments: Maybe<Array<Maybe<GQLIdentityBrokerAssignment>>>;
  contactSuggestion: Maybe<GQLContactSuggestion>;
  displayName: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  emails: Maybe<Array<Maybe<GQLIdentityContact>>>;
  externalId: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  fullName: Maybe<Scalars['String']['output']>;
  hasAccessToFeature: Scalars['Boolean']['output'];
  /** @deprecated Check for user ADMIN role and interactions:read scope */
  hasGlobalInteractionAccess: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  interactionPermissions: GQLInteractionPermissions;
  interactionsAgents: GQLIdentityAssociatedTeamMembersPayload;
  lastName: Maybe<Scalars['String']['output']>;
  legacyExternalId: Maybe<Scalars['String']['output']>;
  licenses: Maybe<Array<GQLIdentityLicensePayload>>;
  logins: Maybe<Array<Maybe<GQLIdentityLogin>>>;
  metadata: Maybe<GQLIdentityChangeHistory>;
  nrdsId: Maybe<Scalars['String']['output']>;
  paymentPortalUrl: Scalars['String']['output'];
  paymentSetupStatus: Maybe<GQLUserPaymentStatus>;
  personalEmail: Maybe<Scalars['String']['output']>;
  phoneNumber: Maybe<Scalars['String']['output']>;
  phoneNumbers: Maybe<Array<Maybe<GQLIdentityContact>>>;
  photoUrl: Maybe<Scalars['String']['output']>;
  roles: Array<GQLIdentityUserRole>;
  signature: Maybe<Scalars['String']['output']>;
  status: Maybe<GQLIdentityUserStatus>;
  /** @deprecated Use interactionPermissions.submitAs.teamMembers or submitAsUsers */
  submitAs: GQLIdentityAssociatedTeamMembersPayload;
  /** @deprecated Use interactionPermissions.submitAs.teamMembers */
  submitAsMembers: Maybe<Array<GQLIdentityTeamMember>>;
  /** @deprecated Use interactionPermissions.submitAs.mlsPreferences */
  submitAsMlsPreferences: Maybe<Array<GQLMlsVendor>>;
  /** @deprecated Use interactionPermissions.submitAs.users */
  submitAsUsers: Maybe<Array<GQLIdentityUser>>;
  teamMemberships: Maybe<Array<Maybe<GQLIdentityTeamMember>>>;
  /** @deprecated Use transactionSharingMembers or transactionSharingUsers */
  transactionSharing: GQLIdentityAssociatedTeamMembersPayload;
  /** @deprecated Use interactionPermissions.transactionSharing.teamMembers */
  transactionSharingMembers: Maybe<Array<GQLIdentityTeamMember>>;
  transactionSharingUsers: Maybe<Array<GQLIdentityUser>>;
};


export type GQLIdentityUsercontactSuggestionArgs = {
  input: GQLContactSuggestionInput;
};


export type GQLIdentityUserhasAccessToFeatureArgs = {
  feature: InputMaybe<GQLAppFeature>;
};


export type GQLIdentityUserpaymentPortalUrlArgs = {
  input: GQLPaymentPortalUrlParams;
};

export type GQLIdentityUserAddNewMutations = {
  __typename?: 'IdentityUserAddNewMutations';
  contact: Maybe<GQLIdentityContactAddNewMutationPayload>;
  license: Maybe<GQLIdentityLicenseAddNewMutationPayload>;
};


export type GQLIdentityUserAddNewMutationscontactArgs = {
  input: GQLCreateIdentityUserContactInput;
};


export type GQLIdentityUserAddNewMutationslicenseArgs = {
  input: GQLCreateIdentityLicenseInput;
};

export type GQLIdentityUserConnection = {
  __typename?: 'IdentityUserConnection';
  edges: Array<GQLIdentityUserEdge>;
  pageInfo: GQLPageInfo;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type GQLIdentityUserContactDeleteError = GQLRetryableErrorPayload & {
  __typename?: 'IdentityUserContactDeleteError';
  critical: Scalars['Boolean']['output'];
  error: Maybe<GQLErrorData>;
  message: Scalars['String']['output'];
  retryable: Scalars['Boolean']['output'];
};

export type GQLIdentityUserContactDeleteErrorPayload = GQLIdentityUserContactDeleteError | GQLIdentityUserContactDeletePrimaryError | GQLIdentityUserContactNotFoundError;

export type GQLIdentityUserContactDeletePrimaryError = GQLErrorPayload & {
  __typename?: 'IdentityUserContactDeletePrimaryError';
  critical: Scalars['Boolean']['output'];
  error: Maybe<GQLErrorData>;
  message: Scalars['String']['output'];
  retryable: Scalars['Boolean']['output'];
};

export type GQLIdentityUserContactMutations = {
  __typename?: 'IdentityUserContactMutations';
  delete: Maybe<GQLIdentityUserDeleteContactAcknowledgement>;
  update: Maybe<GQLIdentityUpdateUserContactPayload>;
};


export type GQLIdentityUserContactMutationsupdateArgs = {
  input: GQLUpdateIdentityUserContactInput;
};

export type GQLIdentityUserContactNotFoundError = GQLErrorPayload & {
  __typename?: 'IdentityUserContactNotFoundError';
  critical: Scalars['Boolean']['output'];
  error: Maybe<GQLErrorData>;
  message: Scalars['String']['output'];
  retryable: Scalars['Boolean']['output'];
};

export type GQLIdentityUserDeleteContactAcknowledgement = {
  __typename?: 'IdentityUserDeleteContactAcknowledgement';
  error: Maybe<GQLIdentityUserContactDeleteErrorPayload>;
  record: Maybe<GQLIdentityUser>;
};

export type GQLIdentityUserEdge = {
  __typename?: 'IdentityUserEdge';
  cursor: Maybe<Scalars['String']['output']>;
  node: GQLIdentityUser;
};

export type GQLIdentityUserError = GQLRetryableErrorPayload & {
  __typename?: 'IdentityUserError';
  code: Maybe<GQLIdentityUserErrorCode>;
  critical: Scalars['Boolean']['output'];
  error: Maybe<GQLErrorData>;
  message: Scalars['String']['output'];
  retryable: Scalars['Boolean']['output'];
};

export enum GQLIdentityUserErrorCode {
  UNKNOWN = 'UNKNOWN'
}

export type GQLIdentityUserGoogleContactMutations = {
  __typename?: 'IdentityUserGoogleContactMutations';
  save: GQLContactResponse;
};


export type GQLIdentityUserGoogleContactMutationssaveArgs = {
  input: GQLContactInput;
};

export type GQLIdentityUserGrantedTransactionPermissionsMutations = {
  __typename?: 'IdentityUserGrantedTransactionPermissionsMutations';
  user: GQLIdentityUserMutationPayload;
  users: GQLIdentityUserMutationPayload;
};


export type GQLIdentityUserGrantedTransactionPermissionsMutationsuserArgs = {
  input: GQLIdentityUserTransactionPermissionsInput;
};


export type GQLIdentityUserGrantedTransactionPermissionsMutationsusersArgs = {
  inputs: Array<GQLIdentityUserTransactionPermissionsInput>;
};

export type GQLIdentityUserLicenseAddNewErrorPayload = GQLIdentityLicenseDuplicateError | GQLIdentityLicenseError;

export type GQLIdentityUserLicenseDeleteErrorPayload = GQLIdentityLicenseDeleteError | GQLIdentityLicenseIsAssociatedError | GQLIdentityLicenseNotFoundError | GQLIdentityUserNotFoundError;

export type GQLIdentityUserLicenseDeletePayload = {
  __typename?: 'IdentityUserLicenseDeletePayload';
  error: Maybe<GQLIdentityUserLicenseDeleteErrorPayload>;
  record: Maybe<GQLIdentityUser>;
};

export type GQLIdentityUserLicenseUpdateErrorPayload = GQLIdentityLicenseDuplicateError | GQLIdentityLicenseError | GQLIdentityLicenseExpiredError | GQLIdentityLicenseIsAssociatedError | GQLIdentityLicenseNotFoundError;

export type GQLIdentityUserLicensesMutations = {
  __typename?: 'IdentityUserLicensesMutations';
  delete: Maybe<GQLIdentityUserLicenseDeletePayload>;
  update: Maybe<GQLIdentityLicenseUpdateMutationPayload>;
};


export type GQLIdentityUserLicensesMutationsupdateArgs = {
  input: GQLUpdateIdentityLicenseInput;
};

export type GQLIdentityUserMutationPayload = {
  __typename?: 'IdentityUserMutationPayload';
  error: Maybe<GQLIdentityUserError>;
  record: Maybe<GQLIdentityUser>;
};

export type GQLIdentityUserMutations = {
  __typename?: 'IdentityUserMutations';
  addNew: Maybe<GQLIdentityUserAddNewMutations>;
  avatar: GQLIdentityUser;
  contacts: Maybe<GQLIdentityUserContactMutations>;
  googleContacts: Maybe<GQLIdentityUserGoogleContactMutations>;
  grantedTransactionPermissions: Maybe<GQLIdentityUserGrantedTransactionPermissionsMutations>;
  licenses: Maybe<GQLIdentityUserLicensesMutations>;
  recievedTransactionPermissions: Maybe<GQLIdentityUserRecievedTransactionPermissionsMutations>;
  signature: GQLIdentityUserSignatureMutations;
  update: Maybe<GQLUpdateIdentityUserPayload>;
  updateAccountInfo: GQLUpdateIdentityUserAccountInfoPayload;
};


export type GQLIdentityUserMutationsavatarArgs = {
  input: GQLUpdateIdentityUserAvatarInput;
};


export type GQLIdentityUserMutationscontactsArgs = {
  id: Scalars['ID']['input'];
};


export type GQLIdentityUserMutationslicensesArgs = {
  id: Scalars['ID']['input'];
};


export type GQLIdentityUserMutationssignatureArgs = {
  id: Scalars['ID']['input'];
};


export type GQLIdentityUserMutationsupdateArgs = {
  input: GQLUpdateIdentityUserInput;
};


export type GQLIdentityUserMutationsupdateAccountInfoArgs = {
  input: GQLUpdateIdentityUserAccountInfoInput;
};

export type GQLIdentityUserNotFoundError = GQLErrorPayload & {
  __typename?: 'IdentityUserNotFoundError';
  critical: Scalars['Boolean']['output'];
  error: Maybe<GQLErrorData>;
  message: Scalars['String']['output'];
  retryable: Scalars['Boolean']['output'];
};

export type GQLIdentityUserPayload = GQLIdentityUser | GQLIdentityUserError | GQLIdentityUserNotFoundError;

export type GQLIdentityUserRecievedTransactionPermissionsMutations = {
  __typename?: 'IdentityUserRecievedTransactionPermissionsMutations';
  users: GQLIdentityUsersMutationPayload;
};


export type GQLIdentityUserRecievedTransactionPermissionsMutationsusersArgs = {
  inputs: Array<GQLIdentityUserTransactionPermissionsInput>;
};

export type GQLIdentityUserRole = {
  __typename?: 'IdentityUserRole';
  code: GQLIdentityUserRoleCode;
  name: Scalars['String']['output'];
};

export enum GQLIdentityUserRoleCode {
  /** Administrator */
  ADMIN = 'ADMIN',
  /** Auditor */
  AUDITOR = 'AUDITOR',
  /** Broker */
  BROKER = 'BROKER',
  /** Payment specialist */
  PAYMENT_SPECIALIST = 'PAYMENT_SPECIALIST',
  /** TRANSACTION_COORDINATOR */
  TRANSACTION_COORDINATOR = 'TRANSACTION_COORDINATOR'
}

export type GQLIdentityUserSignatureMutations = {
  __typename?: 'IdentityUserSignatureMutations';
  update: Maybe<GQLIdentityUpdateUserSignaturePayload>;
};


export type GQLIdentityUserSignatureMutationsupdateArgs = {
  input: GQLUpdateIdentitySignatureInput;
};

export enum GQLIdentityUserStatus {
  ACTIVE = 'ACTIVE',
  DEACTIVATED = 'DEACTIVATED',
  DRAFT = 'DRAFT',
  NONE = 'NONE',
  SUSPENDED = 'SUSPENDED'
}

export type GQLIdentityUserTeamMembersError = GQLRetryableErrorPayload & {
  __typename?: 'IdentityUserTeamMembersError';
  critical: Scalars['Boolean']['output'];
  error: Maybe<GQLErrorData>;
  message: Scalars['String']['output'];
  retryable: Scalars['Boolean']['output'];
};

export type GQLIdentityUserTransactionPermissionsInput = {
  id: Scalars['ID']['input'];
  permissions: GQLUpdateTransactionPermissionsUserInput;
};

export type GQLIdentityUsersMutationPayload = {
  __typename?: 'IdentityUsersMutationPayload';
  error: Maybe<GQLIdentityUserError>;
  record: Maybe<Array<GQLIdentityUser>>;
};

export enum GQLInitialsGroupFormation {
  grid = 'grid',
  horizontal = 'horizontal',
  vertical = 'vertical'
}

export type GQLInitialsGroupItem = {
  __typename?: 'InitialsGroupItem';
  left: Scalars['Float']['output'];
  recipientId: Scalars['String']['output'];
  tooltip: Maybe<Scalars['String']['output']>;
  top: Scalars['Float']['output'];
};

export type GQLInitialsGroupItemInput = {
  left: Scalars['Float']['input'];
  recipientId: Scalars['String']['input'];
  top: Scalars['Float']['input'];
};

/**
 * For document-template inputs only - core-service schema does not have nullable
 * and this has an override in InputMapper
 * @deprecated
 */
export type GQLInput = {
  __typename?: 'Input';
  applyCommaSeparator: Maybe<Scalars['Boolean']['output']>;
  color: Maybe<Scalars['String']['output']>;
  disabled: Maybe<Scalars['Boolean']['output']>;
  documentId: Scalars['ID']['output'];
  dropdownOptions: Maybe<Array<GQLInputDropdownOption>>;
  fontSize: Maybe<Scalars['Float']['output']>;
  height: Maybe<Scalars['Float']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  initialsGroup: Maybe<Array<GQLInitialsGroupItem>>;
  isAutoTag: Scalars['Boolean']['output'];
  isInjected: Scalars['Boolean']['output'];
  isSyncEnabled: Maybe<Scalars['Boolean']['output']>;
  lastLineWidth: Maybe<Scalars['Float']['output']>;
  left: Maybe<Scalars['Float']['output']>;
  lineHeight: Maybe<Scalars['Float']['output']>;
  maxLength: Maybe<Scalars['String']['output']>;
  maxLengths: Maybe<Array<Scalars['String']['output']>>;
  name: Maybe<Scalars['String']['output']>;
  optional: Maybe<Scalars['Boolean']['output']>;
  optionalSide: Maybe<Scalars['String']['output']>;
  options: Maybe<Array<Maybe<GQLInputOption>>>;
  pageId: Maybe<Scalars['ID']['output']>;
  readOnly: Maybe<Scalars['Boolean']['output']>;
  recipientId: Maybe<Scalars['String']['output']>;
  required: Maybe<Scalars['Boolean']['output']>;
  scale: Maybe<Scalars['Float']['output']>;
  suffix: Maybe<Scalars['String']['output']>;
  tabIndex: Maybe<Scalars['Int']['output']>;
  targetFieldNames: Maybe<Scalars['JSONObject']['output']>;
  textAlign: Maybe<Scalars['String']['output']>;
  textIndent: Maybe<Scalars['Float']['output']>;
  tooltip: Maybe<Scalars['String']['output']>;
  top: Maybe<Scalars['Float']['output']>;
  type: Maybe<GQLInputType>;
  typeFace: Maybe<Scalars['String']['output']>;
  value: Maybe<Scalars['String']['output']>;
  width: Maybe<Scalars['Float']['output']>;
};

export type GQLInputDropdownOption = {
  __typename?: 'InputDropdownOption';
  label: Maybe<Scalars['String']['output']>;
  value: Maybe<Scalars['String']['output']>;
};

export type GQLInputInput = {
  applyCommaSeparator?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  fontSize?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  left?: InputMaybe<Scalars['Float']['input']>;
  lineHeight?: InputMaybe<Scalars['Float']['input']>;
  maxLength?: InputMaybe<Scalars['String']['input']>;
  maxLengths?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  optional?: InputMaybe<Scalars['Boolean']['input']>;
  optionalSide?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<GQLInputOptionInput>>;
  pageId?: InputMaybe<Scalars['ID']['input']>;
  readOnly?: InputMaybe<Scalars['Boolean']['input']>;
  recipientId?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  suffix?: InputMaybe<Scalars['String']['input']>;
  tabIndex?: InputMaybe<Scalars['Int']['input']>;
  targetFieldNames?: InputMaybe<Scalars['JSONObject']['input']>;
  textAlign?: InputMaybe<Scalars['String']['input']>;
  textIndent?: InputMaybe<Scalars['Float']['input']>;
  top?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<GQLInputType>;
  typeFace?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type GQLInputOption = {
  __typename?: 'InputOption';
  left: Maybe<Scalars['Float']['output']>;
  reportingName: Maybe<Scalars['String']['output']>;
  tabIndex: Maybe<Scalars['Int']['output']>;
  top: Maybe<Scalars['Float']['output']>;
  value: Maybe<Scalars['String']['output']>;
};

export type GQLInputOptionInput = {
  left?: InputMaybe<Scalars['Float']['input']>;
  reportingName?: InputMaybe<Scalars['String']['input']>;
  tabIndex?: InputMaybe<Scalars['Int']['input']>;
  top?: InputMaybe<Scalars['Float']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum GQLInputType {
  checkbox = 'checkbox',
  date = 'date',
  datesToWords = 'datesToWords',
  decimalsToWords = 'decimalsToWords',
  dropdown = 'dropdown',
  image = 'image',
  initial = 'initial',
  initialsGroup = 'initialsGroup',
  math = 'math',
  multiline = 'multiline',
  numbersToWords = 'numbersToWords',
  preparedDate = 'preparedDate',
  radio = 'radio',
  signature = 'signature',
  signatureDate = 'signatureDate',
  strikethrough = 'strikethrough',
  string = 'string',
  textarea = 'textarea'
}

export type GQLInstallmentCreateInput = {
  amount: Scalars['Float']['input'];
  closeDate: Scalars['String']['input'];
};

export type GQLInstallmentMutationInput = {
  cancel?: InputMaybe<Array<Scalars['ID']['input']>>;
  create?: InputMaybe<Array<GQLInstallmentCreateInput>>;
  update?: InputMaybe<Array<GQLInstallmentUpdateInput>>;
};

export type GQLInstallmentMutationPayload = GQLMutationPayload & {
  __typename?: 'InstallmentMutationPayload';
  errors: Maybe<Array<GQLMutationProblem>>;
  query: GQLQuery;
  record: Maybe<GQLAdminTransaction>;
  status: GQLMutationStatus;
};

export type GQLInstallmentMutations = {
  __typename?: 'InstallmentMutations';
  update: GQLInstallmentMutationPayload;
};


export type GQLInstallmentMutationsupdateArgs = {
  id: Scalars['ID']['input'];
  input: GQLInstallmentMutationInput;
};

export type GQLInstallmentUpdateInput = {
  amount: Scalars['Float']['input'];
  closeDate: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export enum GQLIntegrations {
  followUpBoss = 'followUpBoss',
  googleCalendar = 'googleCalendar',
  googlePeople = 'googlePeople'
}

export type GQLInteraction = {
  acceptedOfferId: Maybe<Scalars['String']['output']>;
  basicContacts: Maybe<Array<GQLBasicInteractionContactResponse>>;
  bindingAgreementDate: Maybe<Scalars['String']['output']>;
  closingDate: Maybe<Scalars['String']['output']>;
  contactSuggestion: GQLContactSuggestion;
  /** A paginated list of contacts associated with the Interaction */
  contacts: Maybe<Array<Maybe<GQLInteractionContact>>>;
  contractDate: Maybe<Scalars['String']['output']>;
  coverPhotoFileId: Maybe<Scalars['String']['output']>;
  coverPhotoUrl: Maybe<Scalars['String']['output']>;
  displayPrice: Maybe<Scalars['Float']['output']>;
  displayStatus: GQLInteractionStatus;
  document: Maybe<GQLInteractionDocument>;
  documentPreview: GQLInteractionDocument;
  /**
   * The list of documents for the interaction
   * with optional filters by status
   */
  documents: Maybe<GQLInteractionDocumentsConnection>;
  /** Get an Envelope for an Interaction */
  envelope: Maybe<GQLEnvelope>;
  /** Get a list of Envelopes for an Interaction */
  envelopes: Maybe<Array<Maybe<GQLEnvelope>>>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  isIntermediary: Scalars['Boolean']['output'];
  listingEndDate: Maybe<Scalars['String']['output']>;
  listingStartDate: Maybe<Scalars['String']['output']>;
  onMarketDate: Maybe<Scalars['String']['output']>;
  owner: Scalars['String']['output'];
  property: Maybe<GQLPropertyAddress>;
  /** Get a list of Envelopes in a Sent state (with status `partiallySigned`, `notFinalized`, `voided`, `completed`, `created`, `sent`, or `sending`) */
  sentEnvelopes: Maybe<Array<Maybe<GQLEnvelope>>>;
  sidebarUi: GQLInteractionSidebarItemsConnection;
  /** The account preference contact for syncing */
  syncContact: Maybe<GQLInteractionDefaultContact>;
  teamId: Maybe<Scalars['String']['output']>;
  transactions: Array<GQLTransaction>;
};


export type GQLInteractioncontactSuggestionArgs = {
  input: GQLInteractionContactSuggestionInput;
};


export type GQLInteractioncontactsArgs = {
  input: InputMaybe<GQLInteractionContactsInput>;
};


export type GQLInteractiondocumentArgs = {
  id: Scalars['ID']['input'];
};


export type GQLInteractiondocumentPreviewArgs = {
  documentVersionId: Scalars['ID']['input'];
};


export type GQLInteractiondocumentsArgs = {
  input: InputMaybe<GQLInteractionDocumentsInput>;
};


export type GQLInteractionenvelopeArgs = {
  input: GQLGetEnvelopeInput;
};


export type GQLInteractionenvelopesArgs = {
  input: InputMaybe<GQLGetEnvelopesInput>;
};


export type GQLInteractionsentEnvelopesArgs = {
  input: InputMaybe<GQLGetEnvelopesInput>;
};


export type GQLInteractionsyncContactArgs = {
  input: GQLInteractionSyncContactInput;
};

export type GQLInteractionCSVFileResponse = {
  __typename?: 'InteractionCSVFileResponse';
  fileName: Scalars['String']['output'];
  fileUrl: Scalars['String']['output'];
};

/**
 * A union of all the different types of InteractionContacts,
 * which may have different available fields (ex. license number, etc.)
 */
export type GQLInteractionContact = GQLInteractionContactAgent | GQLInteractionContactOther;

export type GQLInteractionContactAgent = GQLInteractionContactBase & {
  __typename?: 'InteractionContactAgent';
  address: Maybe<GQLAddress>;
  avatar: Maybe<Scalars['String']['output']>;
  brokerage: Maybe<GQLBrokerage>;
  cellPhone: Maybe<Scalars['String']['output']>;
  contactSource: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  email: Maybe<Scalars['String']['output']>;
  fax: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  googleContactId: Maybe<Scalars['String']['output']>;
  homePhone: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  licenseNumber: Maybe<Scalars['String']['output']>;
  nickname: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  supervisingBroker: Maybe<GQLInteractionContactGeneralInfo>;
  teamId: Maybe<Scalars['String']['output']>;
  type: GQLInteractionContactType;
  userId: Maybe<Scalars['String']['output']>;
};

export type GQLInteractionContactBase = {
  address: Maybe<GQLAddress>;
  avatar: Maybe<Scalars['String']['output']>;
  cellPhone: Maybe<Scalars['String']['output']>;
  contactSource: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  email: Maybe<Scalars['String']['output']>;
  fax: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  googleContactId: Maybe<Scalars['String']['output']>;
  homePhone: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  nickname: Maybe<Scalars['String']['output']>;
  order: Maybe<Scalars['Int']['output']>;
  teamId: Maybe<Scalars['String']['output']>;
  type: GQLInteractionContactType;
  userId: Maybe<Scalars['String']['output']>;
};

export type GQLInteractionContactGeneralInfo = {
  __typename?: 'InteractionContactGeneralInfo';
  cellPhone: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  licenseNumber: Maybe<Scalars['String']['output']>;
  nickname: Maybe<Scalars['String']['output']>;
};

export type GQLInteractionContactGeneralInput = {
  cellPhone?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  licenseNumber?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
};

export type GQLInteractionContactOther = GQLInteractionContactBase & {
  __typename?: 'InteractionContactOther';
  address: Maybe<GQLAddress>;
  avatar: Maybe<Scalars['String']['output']>;
  cellPhone: Maybe<Scalars['String']['output']>;
  clientTypes: Array<GQLReferralClientType>;
  companyName: Maybe<Scalars['String']['output']>;
  contactSource: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  email: Maybe<Scalars['String']['output']>;
  entityName: Maybe<Scalars['String']['output']>;
  entityType: Maybe<Scalars['String']['output']>;
  fax: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  googleContactId: Maybe<Scalars['String']['output']>;
  homePhone: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  nickname: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  /** @deprecated use clientTypes instead */
  referralClientTypes: Maybe<GQLReferralClientTypes>;
  role: Maybe<Scalars['String']['output']>;
  teamId: Maybe<Scalars['String']['output']>;
  type: GQLInteractionContactType;
  userId: Maybe<Scalars['String']['output']>;
};

export type GQLInteractionContactSuggestionInput = {
  excludeNonCompliantTeams?: InputMaybe<Scalars['Boolean']['input']>;
  includeReferralAgents?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchValue: Scalars['String']['input'];
};

export enum GQLInteractionContactType {
  agent = 'agent',
  appraiser = 'appraiser',
  attorney = 'attorney',
  client = 'client',
  closingAttorney = 'closingAttorney',
  counterpartyAgent = 'counterpartyAgent',
  counterpartyAttorney = 'counterpartyAttorney',
  counterpartyClient = 'counterpartyClient',
  counterpartyTransactionCoordinator = 'counterpartyTransactionCoordinator',
  escrowOfficer = 'escrowOfficer',
  homeWarranty = 'homeWarranty',
  lender = 'lender',
  other = 'other',
  propertyManagingAgent = 'propertyManagingAgent',
  titleOfficer = 'titleOfficer',
  transactionCoordinator = 'transactionCoordinator'
}

export type GQLInteractionContactsFilter = {
  types?: InputMaybe<Array<InputMaybe<GQLInteractionContactType>>>;
};

export type GQLInteractionContactsInput = {
  filter?: InputMaybe<GQLInteractionContactsFilter>;
};

export type GQLInteractionDefaultContact = {
  __typename?: 'InteractionDefaultContact';
  avatar: Maybe<Scalars['String']['output']>;
  cellPhone: Maybe<Scalars['String']['output']>;
  city: Maybe<Scalars['String']['output']>;
  companyName: Maybe<Scalars['String']['output']>;
  contactSource: Maybe<Scalars['String']['output']>;
  county: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  fax: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  googleContactId: Maybe<Scalars['String']['output']>;
  homePhone: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  nickname: Maybe<Scalars['String']['output']>;
  role: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  street1: Maybe<Scalars['String']['output']>;
  street2: Maybe<Scalars['String']['output']>;
  userId: Maybe<Scalars['String']['output']>;
  zip: Maybe<Scalars['String']['output']>;
};

/** A document associated with a Listing or Offer */
export type GQLInteractionDocument = GQLNode & {
  __typename?: 'InteractionDocument';
  answerCount: Scalars['Int']['output'];
  autoTagStatus: GQLAutoTagStatus;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  documentTemplateId: Maybe<Scalars['String']['output']>;
  documentVersionFile: Maybe<GQLFile>;
  documentVersionId: Maybe<Scalars['ID']['output']>;
  documentVersionNumber: Maybe<Scalars['Int']['output']>;
  envelope: Maybe<GQLInteractionEnvelope>;
  envelopeOrder: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  interactionEnvelopeId: Maybe<Scalars['String']['output']>;
  isAutoTagged: Scalars['Boolean']['output'];
  isCustom: Maybe<Scalars['Boolean']['output']>;
  isExternal: Maybe<Scalars['Boolean']['output']>;
  isRequired: Scalars['Boolean']['output'];
  isTagged: Maybe<Scalars['Boolean']['output']>;
  lastModifiedAt: Scalars['DateTime']['output'];
  missingRequiredFields: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  pages: Maybe<Array<Maybe<GQLPage>>>;
  preOrder: Scalars['Float']['output'];
  propertyOptionGroupName: Maybe<Scalars['String']['output']>;
  signedFile: Maybe<GQLFile>;
  status: GQLInteractionDocumentStatus;
};


/** A document associated with a Listing or Offer */
export type GQLInteractionDocumentsignedFileArgs = {
  input: InputMaybe<GQLSignedFileOptions>;
};

/**
 * NOTE: This is separate from "Input" because it relates to document-templates
 * which has a schema in core-service which does not have nullables where the
 * one for interaction documents does - this was intentional to mover towards simple types
 * with nullables.
 */
export type GQLInteractionDocumentInput = {
  __typename?: 'InteractionDocumentInput';
  applyCommaSeparator: Maybe<Scalars['Boolean']['output']>;
  color: Maybe<Scalars['String']['output']>;
  disabled: Maybe<Scalars['Boolean']['output']>;
  dropdownOptions: Maybe<Array<GQLInputDropdownOption>>;
  fontSize: Maybe<Scalars['Float']['output']>;
  height: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  isAutoTag: Maybe<Scalars['Boolean']['output']>;
  isSyncEnabled: Maybe<Scalars['Boolean']['output']>;
  left: Maybe<Scalars['Float']['output']>;
  lineHeight: Maybe<Scalars['Float']['output']>;
  maxLength: Maybe<Scalars['String']['output']>;
  maxLengths: Maybe<Array<Scalars['String']['output']>>;
  name: Maybe<Scalars['String']['output']>;
  optional: Maybe<Scalars['Boolean']['output']>;
  optionalSide: Maybe<Scalars['String']['output']>;
  options: Maybe<Array<Maybe<GQLInputOption>>>;
  readOnly: Maybe<Scalars['Boolean']['output']>;
  recipientId: Maybe<Scalars['String']['output']>;
  required: Maybe<Scalars['Boolean']['output']>;
  suffix: Maybe<Scalars['String']['output']>;
  tabIndex: Maybe<Scalars['Int']['output']>;
  targetFieldNames: Maybe<Scalars['JSONObject']['output']>;
  textAlign: Maybe<Scalars['String']['output']>;
  textIndent: Maybe<Scalars['Float']['output']>;
  top: Maybe<Scalars['Float']['output']>;
  type: Maybe<GQLInputType>;
  typeFace: Maybe<Scalars['String']['output']>;
  value: Maybe<Scalars['String']['output']>;
  width: Maybe<Scalars['Float']['output']>;
};

export enum GQLInteractionDocumentStatus {
  active = 'active',
  draft = 'draft',
  inactive = 'inactive',
  sent = 'sent'
}

export type GQLInteractionDocumentUploadDetails = {
  __typename?: 'InteractionDocumentUploadDetails';
  document: GQLInteractionDocument;
  uploadUrl: Scalars['String']['output'];
};

export type GQLInteractionDocumentsConnection = GQLConnection & {
  __typename?: 'InteractionDocumentsConnection';
  edges: Array<GQLInteractionDocumentsEdge>;
  pageInfo: GQLPageInfo;
};

export type GQLInteractionDocumentsEdge = GQLEdge & {
  __typename?: 'InteractionDocumentsEdge';
  cursor: Scalars['String']['output'];
  node: GQLInteractionDocument;
};

/**
 * Use to retrieve a subset of documents
 * instead of the entire list
 */
export type GQLInteractionDocumentsFilter = {
  facets?: InputMaybe<Array<InputMaybe<GQLFacetFilter>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<GQLInteractionDocumentStatus>;
};

export type GQLInteractionDocumentsInput = {
  filter?: InputMaybe<GQLInteractionDocumentsFilter>;
};

/** A placeholder type for future work on envelopes */
export type GQLInteractionEnvelope = GQLNode & {
  __typename?: 'InteractionEnvelope';
  id: Maybe<Scalars['ID']['output']>;
};

export enum GQLInteractionEnvelopeRecipientType {
  CarbonCopy = 'CarbonCopy',
  CertifiedDelivery = 'CertifiedDelivery',
  Editor = 'Editor',
  InPersonSigner = 'InPersonSigner',
  Signer = 'Signer'
}

export type GQLInteractionLocales = {
  __typename?: 'InteractionLocales';
  city: Maybe<Scalars['String']['output']>;
  country: Maybe<Scalars['String']['output']>;
  county: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
};

export type GQLInteractionLocationInput = {
  city: Scalars['String']['input'];
  county: Scalars['String']['input'];
  state: Scalars['String']['input'];
  street1: Scalars['String']['input'];
  street2?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
};

export type GQLInteractionMutationInput = {
  id: Scalars['ID']['input'];
  type: GQLInteractionType;
};

export type GQLInteractionMutationPayload = {
  __typename?: 'InteractionMutationPayload';
  errors: Maybe<Array<GQLMutationProblem>>;
  record: Maybe<GQLInteraction>;
  status: Maybe<GQLMutationStatus>;
};

export type GQLInteractionMutations = {
  __typename?: 'InteractionMutations';
  /** Add a single input to an InteractionDocument */
  addDocumentInput: GQLAddInputPayload;
  /**
   * Add one or more documents to an interaction.
   * Documents can be added by their individual IDs
   * or by their Property Option Group ID
   */
  addDocuments: GQLAddDocumentsToInteractionPayload;
  /**
   * Add a single document to an interaction for uploading.
   * Returns an upload URL to be used for the actual file transfer.
   */
  addDocumentsForUpload: GQLAddDocumentsForUploadToInteractionPayload;
  /** Delete a single document that is not part of an envelope */
  deleteDocument: GQLDeleteDocumentPayload;
  /** Delete a single input from a listing document */
  deleteDocumentInput: GQLDeleteDocumentInputPayload;
  /** Delete multiple documents that are not part of an envelope by current status */
  deleteDocumentsByStatus: GQLDeleteDocumentsByStatusPayload;
  /** Duplicate a single document by ID */
  duplicateDocument: GQLDuplicateDocumentPayload;
  /** Update a single Answer (aka. Input value) on an InteractionDocument */
  updateAnswer: Maybe<GQLUpdateAnswerPayload>;
  /** Update a single document field (aka. Input) on an InteractionDocument */
  updateDocumentInput: GQLUpdateDocumentInputPayload;
  /** Update the status of a single document */
  updateDocumentStatus: GQLUpdateDocumentStatusPayload;
  /** Update the envelope order of a single document */
  updateDocumentsEnvelopeOrder: GQLUpdateDocumentsEnvelopeOrderPayload;
  /** Update the status of multiple documents by their existing status */
  updateDocumentsStatus: GQLUpdateDocumentsStatusPayload;
  /** Update whether the interaction is isArchived */
  updateIsArchived: GQLInteractionMutationPayload;
  /** Update the status of the interaction */
  updateStatus: GQLInteractionMutationPayload;
};


export type GQLInteractionMutationsaddDocumentInputArgs = {
  input: GQLAddDocumentInputInput;
};


export type GQLInteractionMutationsaddDocumentsArgs = {
  input: GQLAddDocumentsToInteractionInput;
};


export type GQLInteractionMutationsaddDocumentsForUploadArgs = {
  input: GQLAddDocumentsForUploadToInteractionInput;
};


export type GQLInteractionMutationsdeleteDocumentArgs = {
  input: GQLDeleteDocumentInput;
};


export type GQLInteractionMutationsdeleteDocumentInputArgs = {
  input: GQLDeleteDocumentInputInput;
};


export type GQLInteractionMutationsdeleteDocumentsByStatusArgs = {
  input: GQLDeleteDocumentsByStatusInput;
};


export type GQLInteractionMutationsduplicateDocumentArgs = {
  input: GQLDuplicateDocumentInput;
};


export type GQLInteractionMutationsupdateAnswerArgs = {
  input: GQLUpdateAnswerInput;
};


export type GQLInteractionMutationsupdateDocumentInputArgs = {
  input: GQLUpdateDocumentInputInput;
};


export type GQLInteractionMutationsupdateDocumentStatusArgs = {
  input: GQLUpdateDocumentStatusInput;
};


export type GQLInteractionMutationsupdateDocumentsEnvelopeOrderArgs = {
  input: GQLUpdateDocumentsEnvelopeOrderInput;
};


export type GQLInteractionMutationsupdateDocumentsStatusArgs = {
  input: GQLUpdateDocumentsStatusInput;
};


export type GQLInteractionMutationsupdateIsArchivedArgs = {
  input: GQLUpdateInteractionIsArchivedInput;
};


export type GQLInteractionMutationsupdateStatusArgs = {
  input: GQLUpdateInteractionStatusInput;
};

export type GQLInteractionOnReferral = {
  __typename?: 'InteractionOnReferral';
  id: Scalars['ID']['output'];
  status: GQLInteractionStatus;
  type: GQLInteractionType;
  userHasAccess: Scalars['Boolean']['output'];
};

export type GQLInteractionPermissionSubmitAsTeamMembersResponse = GQLCursorPaginationResponse & {
  __typename?: 'InteractionPermissionSubmitAsTeamMembersResponse';
  items: Array<GQLIdentityTeamMember>;
  pageInfo: GQLCursorPageInfo;
};

export type GQLInteractionPermissionSubmitAsUserResponse = GQLCursorPaginationResponse & {
  __typename?: 'InteractionPermissionSubmitAsUserResponse';
  items: Array<GQLIdentityUser>;
  pageInfo: GQLCursorPageInfo;
};

export type GQLInteractionPermissionTransactionSharingTeamMembersResponse = GQLCursorPaginationResponse & {
  __typename?: 'InteractionPermissionTransactionSharingTeamMembersResponse';
  items: Array<GQLIdentityTeamMember>;
  pageInfo: GQLCursorPageInfo;
};

export type GQLInteractionPermissionTransactionSharingUsersResponse = GQLCursorPaginationResponse & {
  __typename?: 'InteractionPermissionTransactionSharingUsersResponse';
  items: Array<GQLIdentityUser>;
  pageInfo: GQLCursorPageInfo;
};

export type GQLInteractionPermissions = {
  __typename?: 'InteractionPermissions';
  submitAs: GQLInteractionPermissionsSubmitAs;
  transactionSharing: GQLInteractionPermissionsTransactionSharing;
};

export type GQLInteractionPermissionsSubmitAs = {
  __typename?: 'InteractionPermissionsSubmitAs';
  mlsPreferences: Array<GQLMlsVendor>;
  states: Array<GQLIdentitySupportedStateCode>;
  /** Response is a pagination shape, but always returns a single page of all results. */
  teamMembers: GQLInteractionPermissionSubmitAsTeamMembersResponse;
  users: GQLInteractionPermissionSubmitAsUserResponse;
};


export type GQLInteractionPermissionsSubmitAsteamMembersArgs = {
  input: InputMaybe<GQLCursorPaginationInput>;
};


export type GQLInteractionPermissionsSubmitAsusersArgs = {
  input: InputMaybe<GQLBatchCursorPaginationInput>;
};

export type GQLInteractionPermissionsTransactionSharing = {
  __typename?: 'InteractionPermissionsTransactionSharing';
  states: Array<GQLIdentitySupportedStateCode>;
  /** Response is a pagination shape, but always returns a single page of all results. */
  teamMembers: GQLInteractionPermissionTransactionSharingTeamMembersResponse;
  users: GQLInteractionPermissionTransactionSharingUsersResponse;
};


export type GQLInteractionPermissionsTransactionSharingteamMembersArgs = {
  input: InputMaybe<GQLCursorPaginationInput>;
};


export type GQLInteractionPermissionsTransactionSharingusersArgs = {
  input: InputMaybe<GQLBatchCursorPaginationInput>;
};

export type GQLInteractionQueryInput = {
  id: Scalars['ID']['input'];
  type: GQLInteractionType;
};

export type GQLInteractionSidebarItemsConnection = {
  __typename?: 'InteractionSidebarItemsConnection';
  edges: Array<GQLInteractionSidebarItemsEdge>;
};

export type GQLInteractionSidebarItemsEdge = {
  __typename?: 'InteractionSidebarItemsEdge';
  badge: Maybe<GQLSidebarLinkBadge>;
  cursor: Scalars['String']['output'];
  node: GQLSidebarItem;
  pathname: Scalars['String']['output'];
};

export enum GQLInteractionStatus {
  acceptancePending = 'acceptancePending',
  accepted = 'accepted',
  accepting = 'accepting',
  active = 'active',
  activeCont = 'activeCont',
  backUp = 'backUp',
  buyerCountered = 'buyerCountered',
  cancellationPending = 'cancellationPending',
  cancelled = 'cancelled',
  closed = 'closed',
  comingSoon = 'comingSoon',
  counterOfferSent = 'counterOfferSent',
  countering = 'countering',
  expired = 'expired',
  handshake = 'handshake',
  lost = 'lost',
  noStatus = 'noStatus',
  offMarket = 'offMarket',
  onMarket = 'onMarket',
  pending = 'pending',
  preListing = 'preListing',
  ratified = 'ratified',
  rejected = 'rejected',
  sellerCountered = 'sellerCountered',
  underReview = 'underReview',
  withdrawn = 'withdrawn'
}

export type GQLInteractionSyncContactInput = {
  type: GQLDefaultContactType;
};

export enum GQLInteractionType {
  clientGroup = 'clientGroup',
  lease = 'lease',
  listing = 'listing',
  offer = 'offer',
  referral = 'referral',
  userTemplate = 'userTemplate'
}

export type GQLInteractionsInput = {
  includeContacts?: InputMaybe<Scalars['Boolean']['input']>;
  isGlobal?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<GQLPaginationInput>;
  type: GQLInteractionType;
};

export type GQLInteractionsMutationInput = {
  type: GQLInteractionType;
};

export type GQLInteractionsMutations = {
  __typename?: 'InteractionsMutations';
  create: GQLInteractionMutationPayload;
};


export type GQLInteractionsMutationscreateArgs = {
  input: GQLCreateInteractionInput;
};

export type GQLInteractionsPaginationResult = GQLPaginationResponse & {
  __typename?: 'InteractionsPaginationResult';
  items: Array<GQLInteraction>;
  pageInfo: GQLPaginationPageInfo;
};

export type GQLItemAssignV2Input = {
  checklistItemTemplateId: Scalars['ID']['input'];
  checklistTemplateCategoryId: Scalars['ID']['input'];
};

export type GQLItemRelationUpdateV2Input = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  checklistItemTemplateId: Scalars['ID']['input'];
  required?: InputMaybe<Scalars['Boolean']['input']>;
  sortPriority?: InputMaybe<Scalars['Int']['input']>;
};

export type GQLItemTemplateListFilter = {
  acceptWhenAutoAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  documentType?: InputMaybe<Array<GQLChecklistItemDocumentType>>;
  isTierOneEligible?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  riskLevel?: InputMaybe<Array<GQLRiskLevel>>;
  shouldAutoAssign?: InputMaybe<Scalars['Boolean']['input']>;
  shouldValidateTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Array<GQLVersionStatus>>;
  transactionPhase?: InputMaybe<GQLTransactionPhase>;
};

export type GQLItemUnassignV2Input = {
  checklistItemTemplateId: Scalars['ID']['input'];
};

export type GQLLease = GQLInteraction & GQLNode & {
  __typename?: 'Lease';
  acceptedOfferId: Maybe<Scalars['String']['output']>;
  basicContacts: Maybe<Array<GQLBasicInteractionContactResponse>>;
  bindingAgreementDate: Maybe<Scalars['String']['output']>;
  canViewOfferDocuments: Scalars['Boolean']['output'];
  closingDate: Maybe<Scalars['String']['output']>;
  contactSuggestion: GQLContactSuggestion;
  /** A paginated list of contacts associated with the Lease. */
  contacts: Maybe<Array<Maybe<GQLInteractionContact>>>;
  contractDate: Maybe<Scalars['String']['output']>;
  coverPhotoFileId: Maybe<Scalars['String']['output']>;
  coverPhotoUrl: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  /** If the user is unable to generate an offer, it returns the reason why. Otherwise, it returns null. */
  disableGenerateOfferReason: Maybe<Scalars['String']['output']>;
  displayPrice: Maybe<Scalars['Float']['output']>;
  displayStatus: GQLInteractionStatus;
  document: Maybe<GQLInteractionDocument>;
  documentPreview: GQLInteractionDocument;
  /**
   * The list of documents for the Lease
   * with optional filters by status
   */
  documents: Maybe<GQLInteractionDocumentsConnection>;
  /** Get an Envelope for a Lease */
  envelope: Maybe<GQLEnvelope>;
  /** Get a list of Envelopes for a Lease */
  envelopes: Maybe<Array<Maybe<GQLEnvelope>>>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  isIntermediary: Scalars['Boolean']['output'];
  leaseEndDate: Maybe<Scalars['String']['output']>;
  leaseStartDate: Maybe<Scalars['String']['output']>;
  listingEndDate: Maybe<Scalars['String']['output']>;
  listingStartDate: Maybe<Scalars['String']['output']>;
  monthlyRent: Maybe<Scalars['Float']['output']>;
  onMarketDate: Maybe<Scalars['String']['output']>;
  owner: Scalars['String']['output'];
  packages: Maybe<Array<Maybe<GQLOfferPackage>>>;
  paymentDate: Maybe<Scalars['String']['output']>;
  property: Maybe<GQLPropertyAddress>;
  referral: Maybe<GQLReferral>;
  representation: Maybe<GQLLeaseRepresentation>;
  /** Get a list of Envelopes in a Sent state (with status `partiallySigned`, `notFinalized`, `voided`, `completed`, `created`, `sent`, or `sending`) */
  sentEnvelopes: Maybe<Array<Maybe<GQLEnvelope>>>;
  sidebarUi: GQLInteractionSidebarItemsConnection;
  /** The account preference contact for syncing */
  syncContact: Maybe<GQLInteractionDefaultContact>;
  teamId: Maybe<Scalars['String']['output']>;
  totalRentAmount: Maybe<Scalars['Float']['output']>;
  transactions: Array<GQLTransaction>;
};


export type GQLLeasecontactSuggestionArgs = {
  input: GQLInteractionContactSuggestionInput;
};


export type GQLLeasecontactsArgs = {
  input: InputMaybe<GQLInteractionContactsInput>;
};


export type GQLLeasedocumentArgs = {
  id: Scalars['ID']['input'];
};


export type GQLLeasedocumentPreviewArgs = {
  documentVersionId: Scalars['ID']['input'];
};


export type GQLLeasedocumentsArgs = {
  input: InputMaybe<GQLInteractionDocumentsInput>;
};


export type GQLLeaseenvelopeArgs = {
  input: GQLGetEnvelopeInput;
};


export type GQLLeaseenvelopesArgs = {
  input: InputMaybe<GQLGetEnvelopesInput>;
};


export type GQLLeasepackagesArgs = {
  input: InputMaybe<GQLOfferPackagesQueryInput>;
};


export type GQLLeasesentEnvelopesArgs = {
  input: InputMaybe<GQLGetEnvelopesInput>;
};


export type GQLLeasesyncContactArgs = {
  input: GQLInteractionSyncContactInput;
};

export enum GQLLeaseRepresentation {
  dual = 'dual',
  landlord = 'landlord',
  tenant = 'tenant'
}

export type GQLListing = GQLInteraction & GQLNode & {
  __typename?: 'Listing';
  acceptedOfferId: Maybe<Scalars['String']['output']>;
  basicContacts: Maybe<Array<GQLBasicInteractionContactResponse>>;
  bindingAgreementDate: Maybe<Scalars['String']['output']>;
  closingDate: Maybe<Scalars['String']['output']>;
  contactSuggestion: GQLContactSuggestion;
  /** A paginated list of contacts associated with the Listing. */
  contacts: Maybe<Array<Maybe<GQLInteractionContact>>>;
  contractDate: Maybe<Scalars['String']['output']>;
  coverPhotoFileId: Maybe<Scalars['String']['output']>;
  coverPhotoUrl: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  displayPrice: Maybe<Scalars['Float']['output']>;
  displayStatus: GQLInteractionStatus;
  document: Maybe<GQLInteractionDocument>;
  documentPreview: GQLInteractionDocument;
  /**
   * The list of documents for the Listing
   * with optional filters by status
   */
  documents: Maybe<GQLInteractionDocumentsConnection>;
  /** Get an Envelope for an Interaction */
  envelope: Maybe<GQLEnvelope>;
  /** Get a list of Envelopes for an Interaction */
  envelopes: Maybe<Array<Maybe<GQLEnvelope>>>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  isIntermediary: Scalars['Boolean']['output'];
  listingEndDate: Maybe<Scalars['String']['output']>;
  listingStartDate: Maybe<Scalars['String']['output']>;
  offer: Maybe<GQLOffer>;
  offerExperience: GQLOfferExperience;
  offers: Array<GQLOffer>;
  offersWithDocumentStats: Array<GQLOfferWithDocumentStatus>;
  onMarketDate: Maybe<Scalars['String']['output']>;
  owner: Scalars['String']['output'];
  property: Maybe<GQLPropertyAddress>;
  referral: Maybe<GQLReferral>;
  /** Get a list of Envelopes in a Sent state (with status `partiallySigned`, `notFinalized`, `voided`, `completed`, `created`, `sent`, or `sending`) */
  sentEnvelopes: Maybe<Array<Maybe<GQLEnvelope>>>;
  sidebarUi: GQLInteractionSidebarItemsConnection;
  /** The account preference contact for syncing */
  syncContact: Maybe<GQLInteractionDefaultContact>;
  teamId: Maybe<Scalars['String']['output']>;
  transactions: Array<GQLTransaction>;
};


export type GQLListingcontactSuggestionArgs = {
  input: GQLInteractionContactSuggestionInput;
};


export type GQLListingcontactsArgs = {
  input: InputMaybe<GQLInteractionContactsInput>;
};


export type GQLListingdocumentArgs = {
  id: Scalars['ID']['input'];
};


export type GQLListingdocumentPreviewArgs = {
  documentVersionId: Scalars['ID']['input'];
};


export type GQLListingdocumentsArgs = {
  input: InputMaybe<GQLInteractionDocumentsInput>;
};


export type GQLListingenvelopeArgs = {
  input: GQLGetEnvelopeInput;
};


export type GQLListingenvelopesArgs = {
  input: InputMaybe<GQLGetEnvelopesInput>;
};


export type GQLListingofferArgs = {
  input: GQLListingOfferInput;
};


export type GQLListingoffersArgs = {
  input: InputMaybe<GQLListingOffersInput>;
};


export type GQLListingsentEnvelopesArgs = {
  input: InputMaybe<GQLGetEnvelopesInput>;
};


export type GQLListingsyncContactArgs = {
  input: GQLInteractionSyncContactInput;
};

export type GQLListingAgreementsAttentionItem = GQLNeedsAttentionItem & {
  __typename?: 'ListingAgreementsAttentionItem';
  id: Scalars['String']['output'];
  interactionCount: Scalars['PositiveInt']['output'];
  interactions: Array<GQLInteraction>;
  /** @deprecated only surface lisitngs */
  leases: GQLInteractionsPaginationResult;
  listings: GQLListingsPaginationResult;
};


export type GQLListingAgreementsAttentionItemleasesArgs = {
  input: GQLAttentionItemPaginationInput;
};


export type GQLListingAgreementsAttentionItemlistingsArgs = {
  input: GQLAttentionItemPaginationInput;
};

export type GQLListingMutationInput = {
  /** The id of the listing being mutated */
  id: Scalars['ID']['input'];
};

export type GQLListingMutations = {
  __typename?: 'ListingMutations';
  /** Creates an offer on listing */
  createOfferOnListing: GQLOfferMutationPayload;
  /** Updates status of an offer on listing */
  updateOfferOnListingStatus: GQLOfferMutationPayload;
  /** Uploads an offer on listing contract */
  uploadOfferOnListingContract: GQLOfferOnListingContractUploadPayload;
};


export type GQLListingMutationscreateOfferOnListingArgs = {
  input: GQLCreateOfferOnListingInput;
};


export type GQLListingMutationsupdateOfferOnListingStatusArgs = {
  input: GQLUpdateOfferOnListingStatusInput;
};


export type GQLListingMutationsuploadOfferOnListingContractArgs = {
  input: GQLUploadOfferOnListingContractInput;
};

export type GQLListingOfferInput = {
  id: Scalars['ID']['input'];
};

export type GQLListingOffersInput = {
  sortModel?: InputMaybe<Array<GQLDatagridSortModel>>;
  status?: InputMaybe<GQLOfferStatus>;
};

export type GQLListingQueryInput = {
  id: Scalars['ID']['input'];
};

export type GQLListingsPaginationResult = GQLPaginationResponse & {
  __typename?: 'ListingsPaginationResult';
  items: Array<GQLListing>;
  pageInfo: GQLPaginationPageInfo;
};

export type GQLLobAutocompleteError = GQLRetryableErrorPayload & {
  __typename?: 'LobAutocompleteError';
  critical: Scalars['Boolean']['output'];
  error: Maybe<GQLErrorData>;
  message: Scalars['String']['output'];
  retryable: Scalars['Boolean']['output'];
};

export type GQLLobAutocompleteInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  prefix: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type GQLLobAutocompleteResponse = {
  __typename?: 'LobAutocompleteResponse';
  error: Maybe<GQLLobAutocompleteError>;
  node: Maybe<GQLLobAutocompleteSuggestionsConnection>;
};

export type GQLLobAutocompleteSuggestion = {
  __typename?: 'LobAutocompleteSuggestion';
  city: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  state: Scalars['String']['output'];
  street1: Scalars['String']['output'];
};

export type GQLLobAutocompleteSuggestionsConnection = {
  __typename?: 'LobAutocompleteSuggestionsConnection';
  edges: Maybe<Array<Maybe<GQLLobAutocompleteSuggestionsEdge>>>;
};

export type GQLLobAutocompleteSuggestionsEdge = {
  __typename?: 'LobAutocompleteSuggestionsEdge';
  node: Maybe<GQLLobAutocompleteSuggestion>;
};

export type GQLLocaleEntity = {
  __typename?: 'LocaleEntity';
  cityName: Maybe<Scalars['String']['output']>;
  country: Scalars['String']['output'];
  countyName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  localeId: Scalars['String']['output'];
  state: Maybe<Scalars['String']['output']>;
  stateName: Maybe<Scalars['String']['output']>;
  type: GQLLocaleType;
};

export enum GQLLocaleType {
  city = 'city',
  country = 'country',
  county = 'county',
  state = 'state'
}

export type GQLMLSListingAgent = {
  __typename?: 'MLSListingAgent';
  brokerage: Maybe<GQLMLSListingAgentBrokerage>;
  cellPhone: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  licenseNumber: Maybe<Scalars['String']['output']>;
};

export type GQLMLSListingAgentBrokerage = {
  __typename?: 'MLSListingAgentBrokerage';
  city: Maybe<Scalars['String']['output']>;
  licenseNumber: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  phone: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  street1: Maybe<Scalars['String']['output']>;
  street2: Maybe<Scalars['String']['output']>;
  zip: Maybe<Scalars['String']['output']>;
};

export type GQLMLSVendorInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  vendor?: InputMaybe<Scalars['String']['input']>;
};

export type GQLMlsProperty = {
  __typename?: 'MlsProperty';
  assessorParcelNumber: Maybe<Scalars['String']['output']>;
  bathrooms: Maybe<Scalars['Float']['output']>;
  bedrooms: Maybe<Scalars['Int']['output']>;
  buildingArea: Maybe<Scalars['Float']['output']>;
  city: Maybe<Scalars['String']['output']>;
  county: Maybe<Scalars['String']['output']>;
  latitude: Maybe<Scalars['Float']['output']>;
  legalDescription: Maybe<Scalars['String']['output']>;
  longitude: Maybe<Scalars['Float']['output']>;
  lotSize: Maybe<Scalars['Float']['output']>;
  state: Maybe<Scalars['String']['output']>;
  street1: Maybe<Scalars['String']['output']>;
  street2: Maybe<Scalars['String']['output']>;
  transactionType: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
  zip: Maybe<Scalars['String']['output']>;
};

export type GQLMlsResult = {
  __typename?: 'MlsResult';
  coListingAgent: Maybe<GQLMLSListingAgent>;
  description: Maybe<Scalars['String']['output']>;
  listingAgent: Maybe<GQLMLSListingAgent>;
  photos: Maybe<Array<Scalars['String']['output']>>;
  property: Maybe<GQLMlsProperty>;
  tourUrl: Maybe<Scalars['String']['output']>;
};

export type GQLMlsSearchInput = {
  compareState?: InputMaybe<Scalars['String']['input']>;
  number: Scalars['String']['input'];
  vendor: Scalars['String']['input'];
};

export type GQLMlsVendor = {
  __typename?: 'MlsVendor';
  displayName: Scalars['String']['output'];
  hintText: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  locales: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name: Scalars['String']['output'];
  vendor: Scalars['String']['output'];
};

export type GQLMoveToNewCompanyIdInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type GQLMoveToNewCompanyInput = {
  company: GQLMoveToNewCompanyIdInput;
  contact: GQLSettlementContactV2UpdateInput;
};

export type GQLMutation = {
  __typename?: 'Mutation';
  audit: GQLAuditMutations;
  audits: GQLAuditsMutations;
  checklistItemTemplateV2: GQLChecklistItemTemplateV2Mutations;
  checklistItemTemplateV2Create: GQLChecklistItemTemplateV2Result;
  checklistTemplateV2: GQLChecklistTemplateV2Mutations;
  checklistTemplateV2Create: GQLChecklistTemplateV2Result;
  coverSheet: GQLCoverSheetMutations;
  createIdentityAddress: Maybe<GQLIdentityCreateAddressPayload>;
  createIdentityBrokerage: GQLIdentityBrokerageMutationPayload;
  delegateGroup: GQLDelegateGroupMutations;
  docTemplate: GQLDocTemplateMutations;
  expandedCreateIdentityBrokerage: GQLIdentityBrokerageMutationPayload;
  identityBrokerage: GQLIdentityBrokerageMutations;
  identityTeam: GQLIdentityTeamMutations;
  identityUser: GQLIdentityUserMutations;
  installment: GQLInstallmentMutations;
  /** Namespace for mutations affecting a single interaction */
  interaction: GQLInteractionMutations;
  /** Namespace for mutations affecting multiple interactions or creation */
  interactions: GQLInteractionsMutations;
  /** Namespace for all mutations affecting a single listing */
  listing: Maybe<GQLListingMutations>;
  me: GQLIdentityUserMutations;
  nhdReports: GQLNHDReportsMutations;
  outsideBrokerage: GQLOutsideBrokerageMutations;
  paymentTeam: GQLPaymentTeamMutations;
  paymentTeamMember: GQLPaymentTeamMemberMutations;
  /** Namespace for mutations affecting a single referral */
  referral: GQLReferralMutations;
  runners: GQLRunnerMutations;
  settlementCompany: GQLSettlementCompanyMutations;
  settlementContact: GQLSettlementContactMutations;
  templateCategoryV2: GQLTemplateCategoryV2Mutations;
  templateCategoryV2Create: GQLTemplateCategoryV2Result;
  templateRuleV2: GQLTemplateRuleV2Mutations;
  templateRuleV2Create: GQLTemplateRuleV2Result;
  transaction: GQLTransactionMutations;
};


export type GQLMutationauditArgs = {
  id: Scalars['ID']['input'];
};


export type GQLMutationchecklistItemTemplateV2Args = {
  id: Scalars['ID']['input'];
};


export type GQLMutationchecklistItemTemplateV2CreateArgs = {
  input: GQLCreateChecklistItemTemplateV2Input;
};


export type GQLMutationchecklistTemplateV2Args = {
  id: Scalars['ID']['input'];
};


export type GQLMutationchecklistTemplateV2CreateArgs = {
  input: GQLCreateChecklistTemplateV2Input;
};


export type GQLMutationcreateIdentityAddressArgs = {
  input: GQLIdentityCreateAddressInput;
};


export type GQLMutationcreateIdentityBrokerageArgs = {
  input: GQLCreateIdentityBrokerageInput;
};


export type GQLMutationdocTemplateArgs = {
  templateId: Scalars['ID']['input'];
};


export type GQLMutationexpandedCreateIdentityBrokerageArgs = {
  input: GQLCreateIdentityBrokerageInput;
};


export type GQLMutationidentityBrokerageArgs = {
  id: Scalars['ID']['input'];
};


export type GQLMutationidentityTeamArgs = {
  id: Scalars['ID']['input'];
};


export type GQLMutationidentityUserArgs = {
  id: Scalars['ID']['input'];
};


export type GQLMutationinteractionArgs = {
  input: GQLInteractionMutationInput;
};


export type GQLMutationinteractionsArgs = {
  input: GQLInteractionsMutationInput;
};


export type GQLMutationlistingArgs = {
  input: GQLListingMutationInput;
};


export type GQLMutationnhdReportsArgs = {
  auditId: Scalars['ID']['input'];
};


export type GQLMutationreferralArgs = {
  id: Scalars['ID']['input'];
};


export type GQLMutationtemplateCategoryV2Args = {
  id: Scalars['ID']['input'];
};


export type GQLMutationtemplateCategoryV2CreateArgs = {
  input: GQLCreateTemplateCategoryV2Input;
};


export type GQLMutationtemplateRuleV2Args = {
  id: Scalars['ID']['input'];
};


export type GQLMutationtemplateRuleV2CreateArgs = {
  input: GQLCreateTemplateRuleV2Input;
};


export type GQLMutationtransactionArgs = {
  input: GQLTransactionMutationInput;
};

/** A standardized mutation payload. */
export type GQLMutationPayload = {
  /** Any errors associated with the mutation */
  errors: Maybe<Array<GQLMutationProblem>>;
  /**
   * A generic query field that can be used to re-query
   * any resource without an additional round trip
   */
  query: Maybe<GQLQuery>;
  /** The status of the mutation. */
  status: Maybe<GQLMutationStatus>;
};

export type GQLMutationProblem = {
  message: Scalars['String']['output'];
};

export type GQLMutationStatus = {
  __typename?: 'MutationStatus';
  message: Maybe<Scalars['String']['output']>;
};

export type GQLNHDReport = {
  __typename?: 'NHDReport';
  createdAt: Scalars['String']['output'];
  createdByIdentityUser: Maybe<GQLIdentityUser>;
  escrowInfoNeeded: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  orderId: Maybe<Scalars['ID']['output']>;
  reportType: GQLNHDReportType;
  status: GQLNHDReportStatus;
  updatedAt: Scalars['String']['output'];
  updatedByIdentityUser: Maybe<GQLIdentityUser>;
};

export enum GQLNHDReportStatus {
  COMPLETED = 'COMPLETED',
  CREATED = 'CREATED',
  PLACED = 'PLACED',
  PROCESSING = 'PROCESSING',
  REJECTED = 'REJECTED'
}

export enum GQLNHDReportType {
  COMMERCIAL = 'COMMERCIAL',
  OWN = 'OWN',
  RENTAL = 'RENTAL',
  RESIDENTIAL = 'RESIDENTIAL'
}

export type GQLNHDReportsMutations = {
  __typename?: 'NHDReportsMutations';
  order: GQLNHDReport;
};


export type GQLNHDReportsMutationsorderArgs = {
  input: GQLOrderNHDReportInput;
};

export type GQLNeedsAttentionItem = {
  /** Number of interactions requiring attention for a category */
  interactionCount: Scalars['PositiveInt']['output'];
};

export type GQLNeedsAttentionSection = {
  __typename?: 'NeedsAttentionSection';
  buyerAgreements: Maybe<GQLBuyerAgreementsAttentionItem>;
  commissionForm: Maybe<GQLCommissionFormAttentionItem>;
  complianceReview: Maybe<GQLComplianceReviewAttentionItem>;
  envelopes: Maybe<GQLEnvelopesAttentionItem>;
  id: Scalars['String']['output'];
  listingAgreements: Maybe<GQLListingAgreementsAttentionItem>;
};

export type GQLNode = {
  id: Maybe<Scalars['ID']['output']>;
};

export type GQLNodeErrorPayload = {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  status: Scalars['Int']['output'];
};

export type GQLNodeResult = {
  errors: Maybe<Array<GQLNodeErrorPayload>>;
  node: Maybe<GQLNode>;
};

export type GQLNote = {
  __typename?: 'Note';
  content: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  createdByIdentityUser: Maybe<GQLIdentityUser>;
  documentId: Maybe<Scalars['ID']['output']>;
  documentStatus: Maybe<GQLAuditDocumentStatus>;
  documentVersionId: Maybe<Scalars['ID']['output']>;
  draft: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  itemId: Maybe<Scalars['ID']['output']>;
};

export type GQLOffer = GQLInteraction & GQLNode & {
  __typename?: 'Offer';
  acceptedOfferId: Maybe<Scalars['String']['output']>;
  autoGenerated: Maybe<Scalars['Boolean']['output']>;
  basicContacts: Maybe<Array<GQLBasicInteractionContactResponse>>;
  bindingAgreementDate: Maybe<Scalars['String']['output']>;
  canViewOfferDocuments: Scalars['Boolean']['output'];
  clientGroup: Maybe<GQLClientGroup>;
  closingDate: Maybe<Scalars['String']['output']>;
  commissionAdditionalAmount: Maybe<Scalars['Float']['output']>;
  commissionType: Maybe<GQLCommissionType>;
  commissionValue: Maybe<Scalars['Float']['output']>;
  contactSuggestion: GQLContactSuggestion;
  /** A paginated list of contacts associated with the Offer. */
  contacts: Maybe<Array<Maybe<GQLInteractionContact>>>;
  contingencies: Maybe<Array<Maybe<GQLOfferContingency>>>;
  contractDate: Maybe<Scalars['String']['output']>;
  coverPhotoFileId: Maybe<Scalars['String']['output']>;
  coverPhotoUrl: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  /** If the user is unable to generate an offer, it returns the reason why. Otherwise, it returns null. */
  disableGenerateOfferReason: Maybe<Scalars['String']['output']>;
  displayPrice: Maybe<Scalars['Float']['output']>;
  displayStatus: GQLInteractionStatus;
  document: Maybe<GQLInteractionDocument>;
  documentPreview: GQLInteractionDocument;
  /**
   * The list of documents for the Offer
   * with optional filters by status
   */
  documents: Maybe<GQLInteractionDocumentsConnection>;
  downPaymentAmount: Maybe<Scalars['Float']['output']>;
  downPaymentPercentage: Maybe<Scalars['Float']['output']>;
  emdAmount: Maybe<Scalars['Float']['output']>;
  /** Get an Envelope for an Interaction */
  envelope: Maybe<GQLEnvelope>;
  /** Get a list of Envelopes for an Interaction */
  envelopes: Maybe<Array<Maybe<GQLEnvelope>>>;
  expirationDate: Maybe<Scalars['String']['output']>;
  financingType: Maybe<GQLFinancingType>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  isIntermediary: Scalars['Boolean']['output'];
  isOfferOnListing: Maybe<Scalars['Boolean']['output']>;
  lenderName: Maybe<Scalars['String']['output']>;
  listingEndDate: Maybe<Scalars['String']['output']>;
  listingStartDate: Maybe<Scalars['String']['output']>;
  mlsNumber: Maybe<Scalars['String']['output']>;
  mortgageRatePercentage: Maybe<Scalars['Float']['output']>;
  nextStatuses: Maybe<Array<GQLOfferStatus>>;
  notes: Maybe<Scalars['String']['output']>;
  offerPrice: Maybe<Scalars['Float']['output']>;
  onMarketDate: Maybe<Scalars['String']['output']>;
  owner: Scalars['String']['output'];
  packages: Maybe<Array<Maybe<GQLOfferPackage>>>;
  property: Maybe<GQLPropertyAddress>;
  proposedClosingTimeframe: Maybe<Scalars['Int']['output']>;
  referral: Maybe<GQLReferral>;
  releaseOfEarnestMoney: Maybe<GQLReleaseOfEarnestMoney>;
  sellerPaidClosingCostsAmount: Maybe<Scalars['Float']['output']>;
  sellerPaidClosingCostsPercentage: Maybe<Scalars['Float']['output']>;
  /** Get a list of Envelopes in a Sent state (with status `partiallySigned`, `notFinalized`, `voided`, `completed`, `created`, `sent`, or `sending`) */
  sentEnvelopes: Maybe<Array<Maybe<GQLEnvelope>>>;
  sidebarUi: GQLInteractionSidebarItemsConnection;
  status: Maybe<GQLOfferStatus>;
  /** The account preference contact for syncing */
  syncContact: Maybe<GQLInteractionDefaultContact>;
  teamId: Maybe<Scalars['String']['output']>;
  terminationFee: Maybe<Scalars['Float']['output']>;
  transactions: Array<GQLTransaction>;
};


export type GQLOffercontactSuggestionArgs = {
  input: GQLInteractionContactSuggestionInput;
};


export type GQLOffercontactsArgs = {
  input: InputMaybe<GQLInteractionContactsInput>;
};


export type GQLOfferdocumentArgs = {
  id: Scalars['ID']['input'];
};


export type GQLOfferdocumentPreviewArgs = {
  documentVersionId: Scalars['ID']['input'];
};


export type GQLOfferdocumentsArgs = {
  input: InputMaybe<GQLInteractionDocumentsInput>;
};


export type GQLOfferenvelopeArgs = {
  input: GQLGetEnvelopeInput;
};


export type GQLOfferenvelopesArgs = {
  input: InputMaybe<GQLGetEnvelopesInput>;
};


export type GQLOfferpackagesArgs = {
  input: InputMaybe<GQLOfferPackagesQueryInput>;
};


export type GQLOffersentEnvelopesArgs = {
  input: InputMaybe<GQLGetEnvelopesInput>;
};


export type GQLOffersyncContactArgs = {
  input: GQLInteractionSyncContactInput;
};

export enum GQLOfferCancellationReason {
  accidentallyAccepted = 'accidentallyAccepted',
  buyerCancelled = 'buyerCancelled',
  duplicate = 'duplicate',
  other = 'other',
  sellerCancelled = 'sellerCancelled'
}

export type GQLOfferContingency = {
  __typename?: 'OfferContingency';
  description: Maybe<Scalars['String']['output']>;
  numberOfDays: Maybe<Scalars['Int']['output']>;
  type: GQLOfferContingencyType;
};

export type GQLOfferContingencyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  numberOfDays?: InputMaybe<Scalars['Int']['input']>;
  type: GQLOfferContingencyType;
};

export enum GQLOfferContingencyType {
  appraisal = 'appraisal',
  buyerHomeSale = 'buyerHomeSale',
  commonInterestDisclosures = 'commonInterestDisclosures',
  financing = 'financing',
  inspection = 'inspection',
  other = 'other',
  preliminaryTitleReport = 'preliminaryTitleReport',
  reviewOfLeasedOrLienedItems = 'reviewOfLeasedOrLienedItems',
  reviewOfSellerDocuments = 'reviewOfSellerDocuments',
  sellerReplacementProperty = 'sellerReplacementProperty',
  woodInfestationReport = 'woodInfestationReport'
}

export enum GQLOfferExperience {
  coversheet = 'coversheet',
  featureFlag = 'featureFlag',
  lom = 'lom'
}

export type GQLOfferMutationPayload = {
  __typename?: 'OfferMutationPayload';
  errors: Maybe<Array<GQLMutationProblem>>;
  record: Maybe<GQLOffer>;
  status: Maybe<GQLMutationStatus>;
};

export type GQLOfferOnListingCancellationDetails = {
  comments?: InputMaybe<Scalars['String']['input']>;
  reason: GQLOfferCancellationReason;
};

export type GQLOfferOnListingContractUpload = {
  __typename?: 'OfferOnListingContractUpload';
  document: GQLInteractionDocument;
  offerId: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type GQLOfferOnListingContractUploadPayload = GQLMutationPayload & {
  __typename?: 'OfferOnListingContractUploadPayload';
  errors: Maybe<Array<GQLMutationProblem>>;
  query: Maybe<GQLQuery>;
  record: Maybe<GQLOfferOnListingContractUpload>;
  status: Maybe<GQLMutationStatus>;
};

export type GQLOfferPackage = {
  __typename?: 'OfferPackage';
  combinedShortUrl: GQLShortUrlData;
  coverLetterShortUrl: Maybe<GQLShortUrlData>;
  createdAt: Scalars['String']['output'];
  disclosuresShortUrl: Maybe<GQLShortUrlData>;
  hasUnsignedDocuments: Scalars['Boolean']['output'];
  offerDocsShortUrl: GQLShortUrlData;
  preQualShortUrl: Maybe<GQLShortUrlData>;
  proofOfFundsShortUrl: Maybe<GQLShortUrlData>;
  runnerId: Maybe<Scalars['ID']['output']>;
};

export type GQLOfferPackagesQueryInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type GQLOfferQueryInput = {
  id: Scalars['ID']['input'];
};

export enum GQLOfferStatus {
  acceptancePending = 'acceptancePending',
  accepted = 'accepted',
  accepting = 'accepting',
  active = 'active',
  activeCont = 'activeCont',
  backUp = 'backUp',
  buyerCountered = 'buyerCountered',
  cancellationPending = 'cancellationPending',
  cancelled = 'cancelled',
  closed = 'closed',
  counterOfferSent = 'counterOfferSent',
  countering = 'countering',
  handshake = 'handshake',
  noStatus = 'noStatus',
  pending = 'pending',
  ratified = 'ratified',
  rejected = 'rejected',
  sellerCountered = 'sellerCountered',
  underReview = 'underReview'
}

export type GQLOfferWithDocumentStatus = {
  __typename?: 'OfferWithDocumentStatus';
  contacts: Maybe<Array<Maybe<GQLBasicInteractionContactResponse>>>;
  id: Scalars['ID']['output'];
  offerPrice: Maybe<Scalars['Float']['output']>;
  status: Maybe<GQLOfferStatus>;
  totalActiveDocuments: Maybe<Scalars['Int']['output']>;
  totalSentEnvelopes: Maybe<Scalars['Int']['output']>;
};

export type GQLOffersPaginationResult = GQLPaginationResponse & {
  __typename?: 'OffersPaginationResult';
  items: Array<GQLOffer>;
  pageInfo: GQLPaginationPageInfo;
};

export type GQLOrderNHDReportInput = {
  reportType: GQLNHDReportType;
};

export type GQLOutsideBrokerage = GQLNode & {
  __typename?: 'OutsideBrokerage';
  accountingSupplierId: Maybe<Scalars['String']['output']>;
  address: Maybe<GQLFullAddress>;
  email: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  legacyExternalId: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  phone: Maybe<Scalars['String']['output']>;
};

export type GQLOutsideBrokerageCreatePayload = GQLMutationPayload & {
  __typename?: 'OutsideBrokerageCreatePayload';
  errors: Maybe<Array<GQLMutationProblem>>;
  query: GQLQuery;
  record: Maybe<GQLOutsideBrokerage>;
  status: GQLMutationStatus;
};

export type GQLOutsideBrokerageMutations = {
  __typename?: 'OutsideBrokerageMutations';
  create: GQLOutsideBrokerageCreatePayload;
  update: GQLOutsideBrokerageUpdatePayload;
};


export type GQLOutsideBrokerageMutationscreateArgs = {
  input: GQLCreateOutsideBrokerageInput;
};


export type GQLOutsideBrokerageMutationsupdateArgs = {
  id: Scalars['ID']['input'];
  input: GQLUpdateOutsideBrokerageInput;
};

export type GQLOutsideBrokeragePaginationResult = GQLPaginationResponse & {
  __typename?: 'OutsideBrokeragePaginationResult';
  items: Array<GQLOutsideBrokerage>;
  pageInfo: GQLPaginationPageInfo;
};

export type GQLOutsideBrokerageUpdatePayload = GQLMutationPayload & {
  __typename?: 'OutsideBrokerageUpdatePayload';
  errors: Maybe<Array<GQLMutationProblem>>;
  query: GQLQuery;
  record: Maybe<GQLOutsideBrokerage>;
  status: GQLMutationStatus;
};

export type GQLOwnershipEntity = {
  __typename?: 'OwnershipEntity';
  name: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
  titleOther: Maybe<Scalars['String']['output']>;
};

export type GQLOwnershipInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleOther?: InputMaybe<Scalars['String']['input']>;
};

export type GQLPage = {
  __typename?: 'Page';
  documentId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  inputs: Maybe<Array<GQLInput>>;
};

export type GQLPageInfo = {
  __typename?: 'PageInfo';
  endCursor: Scalars['String']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor: Scalars['String']['output'];
};

export type GQLPaginationInput = {
  facets?: InputMaybe<Array<Scalars['String']['input']>>;
  filters?: InputMaybe<Array<InputMaybe<GQLFacetFilter>>>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GQLDatagridSortModel>>>;
};

export type GQLPaginationPageInfo = {
  __typename?: 'PaginationPageInfo';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  page: Scalars['Int']['output'];
  perPage: Scalars['Int']['output'];
  totalItems: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type GQLPaginationResponse = {
  items: Array<GQLNode>;
  pageInfo: GQLPaginationPageInfo;
};

export type GQLPartyPermission = GQLNode & {
  __typename?: 'PartyPermission';
  createdAt: Maybe<Scalars['String']['output']>;
  createdBy: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  partyId: Scalars['ID']['output'];
  permissionType: Scalars['String']['output'];
  updatedAt: Maybe<Scalars['String']['output']>;
  updatedBy: Maybe<Scalars['String']['output']>;
};

export type GQLPayment = {
  __typename?: 'Payment';
  /** Get a list of commission lead sources */
  commissionLeadSources: Array<GQLCommissionLeadSourceProfiles>;
  /**
   * Get a list of settlement contacts
   * @deprecated use Query.settlementContactsV2
   */
  settlementContacts: Array<GQLSettlementContact>;
  /** Get a single team */
  team: Maybe<GQLTransactionTeam>;
  teamProfile: Maybe<GQLTransactionProfile>;
  /** Get a list of teams */
  teams: Array<GQLTransactionTeam>;
};


export type GQLPaymentcommissionLeadSourcesArgs = {
  input: GQLPaymentCommissionLeadSourcesQueryInput;
};


export type GQLPaymentsettlementContactsArgs = {
  input: GQLPaymentSettlementContactsQueryInput;
};


export type GQLPaymentteamArgs = {
  input: GQLPaymentTeamQueryInput;
};


export type GQLPaymentteamProfileArgs = {
  input: GQLPaymentTeamProfileQueryInput;
};


export type GQLPaymentteamsArgs = {
  input: GQLPaymentTeamsQueryInput;
};

export type GQLPaymentCalculationError = {
  __typename?: 'PaymentCalculationError';
  messages: Array<Scalars['String']['output']>;
  type: GQLPaymentCalculationErrorType;
};

export enum GQLPaymentCalculationErrorType {
  BAD_TRANSACTION_STATUS = 'BAD_TRANSACTION_STATUS',
  DATA_VALIDATION = 'DATA_VALIDATION',
  E_O_COLLECTION = 'E_O_COLLECTION',
  INVALID_SPLIT = 'INVALID_SPLIT',
  MISSING_DATA = 'MISSING_DATA',
  NEGATIVE_NET = 'NEGATIVE_NET',
  PRICING_PLAN = 'PRICING_PLAN',
  PRICING_PLAN_INTERNAL = 'PRICING_PLAN_INTERNAL',
  RERM_POLICY = 'RERM_POLICY',
  SALES_FORCE_CONNECTION = 'SALES_FORCE_CONNECTION',
  SALES_FORCE_MAPPING = 'SALES_FORCE_MAPPING'
}

export type GQLPaymentCommissionLeadSourcesQueryInput = {
  profileIds: Array<Scalars['String']['input']>;
};

export enum GQLPaymentPortalFlow {
  PORTAL = 'PORTAL',
  UPDATE_PAYMENT_METHOD = 'UPDATE_PAYMENT_METHOD'
}

export type GQLPaymentPortalUrlParams = {
  flow?: InputMaybe<GQLPaymentPortalFlow>;
  returnUrl: Scalars['String']['input'];
};

export type GQLPaymentSettlementContactsQueryInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  search: Scalars['String']['input'];
};

export enum GQLPaymentStatus {
  AWAITING_CERTIFICATION = 'AWAITING_CERTIFICATION',
  AWAITING_FORM = 'AWAITING_FORM',
  AWAITING_PAYMENT = 'AWAITING_PAYMENT',
  CLOSING_SOON = 'CLOSING_SOON',
  COMMISSION_FORM_NOT_YET_AVAILABLE = 'COMMISSION_FORM_NOT_YET_AVAILABLE',
  EXPECTED_X_DAYS = 'EXPECTED_X_DAYS',
  PAID = 'PAID',
  PAYMENT_INITIATED = 'PAYMENT_INITIATED',
  UNKNOWN = 'UNKNOWN'
}

export enum GQLPaymentStatusGroup {
  ALL = 'ALL',
  CLOSING_SOON = 'CLOSING_SOON',
  COMPLETE = 'COMPLETE',
  IN_PROGRESS = 'IN_PROGRESS',
  NEEDS_ATTENTION = 'NEEDS_ATTENTION'
}

export type GQLPaymentStatusGroupFacetEntry = {
  __typename?: 'PaymentStatusGroupFacetEntry';
  count: Scalars['Int']['output'];
  group: GQLPaymentStatusGroup;
};

/** An extension on the IdentityTeamMember type that includes the payments field */
export type GQLPaymentTeamMember = GQLNode & {
  __typename?: 'PaymentTeamMember';
  accountingSupplierId: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  history: GQLTeamMemberHistoryPaginationResult;
  id: Scalars['ID']['output'];
  identityUserId: Maybe<Scalars['ID']['output']>;
  isInstantPayEligible: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  legacyExternalId: Maybe<Scalars['String']['output']>;
  licenseTerminationDate: Maybe<Scalars['String']['output']>;
  permissions: Maybe<Array<GQLPartyPermission>>;
  role: Scalars['String']['output'];
  status: Scalars['String']['output'];
  team: Maybe<GQLIdentityTeam>;
  teamId: Scalars['ID']['output'];
  userLegacyExternalId: Maybe<Scalars['String']['output']>;
};


/** An extension on the IdentityTeamMember type that includes the payments field */
export type GQLPaymentTeamMemberhistoryArgs = {
  input: GQLPaginationInput;
};

export type GQLPaymentTeamMemberMutations = {
  __typename?: 'PaymentTeamMemberMutations';
  update: GQLPaymentTeamMemberPayload;
  updatePermissions: GQLPaymentTeamMemberPayload;
};


export type GQLPaymentTeamMemberMutationsupdateArgs = {
  id: Scalars['ID']['input'];
  input: GQLUpdatePaymentTeamMemberInput;
};


export type GQLPaymentTeamMemberMutationsupdatePermissionsArgs = {
  id: Scalars['ID']['input'];
  input: GQLUpdatePaymentTeamMemberPermissionsInput;
};

export type GQLPaymentTeamMemberPayload = GQLMutationPayload & {
  __typename?: 'PaymentTeamMemberPayload';
  errors: Maybe<Array<GQLMutationProblem>>;
  query: GQLQuery;
  record: Maybe<GQLPaymentTeamMember>;
  status: GQLMutationStatus;
};

export type GQLPaymentTeamMutations = {
  __typename?: 'PaymentTeamMutations';
  update: GQLTeamUpdatePayload;
};


export type GQLPaymentTeamMutationsupdateArgs = {
  id: Scalars['ID']['input'];
  input: GQLUpdatePaymentTeamInput;
};

export type GQLPaymentTeamProfileQueryInput = {
  profileId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
};

export type GQLPaymentTeamQueryInput = {
  id: Scalars['ID']['input'];
};

export type GQLPaymentTeamsQueryInput = {
  search: Scalars['String']['input'];
  subTypes?: InputMaybe<Array<GQLTransactionTeamSubType>>;
  types: Array<GQLTransactionTeamType>;
};

export type GQLPaymentTransactionStatement = {
  __typename?: 'PaymentTransactionStatement';
  allocationExternalId: Maybe<Scalars['ID']['output']>;
  fileName: Scalars['String']['output'];
  generatedAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isCurrent: Scalars['Boolean']['output'];
  sentAt: Maybe<Scalars['String']['output']>;
  signedUrl: Scalars['String']['output'];
  type: GQLPaymentTransactionStatementType;
};

export enum GQLPaymentTransactionStatementType {
  ASSOCIATE = 'ASSOCIATE',
  ESCROW = 'ESCROW',
  PARTNER = 'PARTNER',
  TEAM_LEAD = 'TEAM_LEAD'
}

export type GQLPaymentTransactionStatementsConnection = {
  __typename?: 'PaymentTransactionStatementsConnection';
  edges: Array<GQLPaymentTransactionStatementsEdge>;
  unauthorized: Maybe<Scalars['Boolean']['output']>;
};

export type GQLPaymentTransactionStatementsEdge = {
  __typename?: 'PaymentTransactionStatementsEdge';
  cursor: Scalars['String']['output'];
  node: GQLPaymentTransactionStatement;
};

export enum GQLPaymentTransactionType {
  COMMERCIAL = 'COMMERCIAL',
  CONDO_TOWNHOME_PUD = 'CONDO_TOWNHOME_PUD',
  CO_OP = 'CO_OP',
  FARM_AND_RANCH = 'FARM_AND_RANCH',
  MANUFACTURED_HOME_OR_MOBILE = 'MANUFACTURED_HOME_OR_MOBILE',
  MULTI_UNIT_1_4 = 'MULTI_UNIT_1_4',
  MULTI_UNIT_5_PLUS = 'MULTI_UNIT_5_PLUS',
  NEW_CONSTRUCTION = 'NEW_CONSTRUCTION',
  NOT_SPECIFIED = 'NOT_SPECIFIED',
  PRE_PAID_CAP_TRANSACTION = 'PRE_PAID_CAP_TRANSACTION',
  REFERRAL_EXTERNAL = 'REFERRAL_EXTERNAL',
  REFERRAL_INTERNAL = 'REFERRAL_INTERNAL',
  REFERRAL_IN_AND_EX = 'REFERRAL_IN_AND_EX',
  RENTAL_OR_LEASE = 'RENTAL_OR_LEASE',
  RESIDENTIAL = 'RESIDENTIAL',
  SALES = 'SALES',
  SINGLE_FAMILY_RESIDENCE = 'SINGLE_FAMILY_RESIDENCE',
  TENANCY_IN_COMMON = 'TENANCY_IN_COMMON',
  VACANT_LOT_OR_LAND = 'VACANT_LOT_OR_LAND'
}

export type GQLPaymentV2 = {
  __typename?: 'PaymentV2';
  team: Maybe<GQLIdentityTeam>;
  teamMember: GQLPaymentTeamMember;
  teamMembers: GQLTeamMembersV2PaginationResult;
  teams: GQLTeamsV2Response;
};


export type GQLPaymentV2teamArgs = {
  input: GQLTeamV2Input;
};


export type GQLPaymentV2teamMemberArgs = {
  input: GQLPaymentV2TeamMemberInput;
};


export type GQLPaymentV2teamMembersArgs = {
  input: GQLPaginationInput;
};


export type GQLPaymentV2teamsArgs = {
  input: GQLPaginationInput;
};

export type GQLPaymentV2TeamMemberInput = {
  id: Scalars['ID']['input'];
};

export type GQLPaymentValidationError = {
  __typename?: 'PaymentValidationError';
  checks: Array<GQLValidationCheck>;
  message: Scalars['String']['output'];
};

export enum GQLPermissionAction {
  ADD = 'ADD',
  DELETE = 'DELETE',
  UPDATE = 'UPDATE'
}

export type GQLPermissionChange = {
  __typename?: 'PermissionChange';
  action: GQLPermissionAction;
  permission: Scalars['String']['output'];
};

export type GQLPricingSplit = {
  __typename?: 'PricingSplit';
  agentPercent: Scalars['Float']['output'];
  amountOwedToSide: Maybe<Scalars['Float']['output']>;
  brokeragePercent: Scalars['Float']['output'];
  expectedBrokeragePercent: Maybe<Scalars['Float']['output']>;
  parentTeamPercent: Scalars['Float']['output'];
  teamPercent: Scalars['Float']['output'];
};

export type GQLPricingStrategy = {
  __typename?: 'PricingStrategy';
  externalId: Scalars['ID']['output'];
  id: Maybe<Scalars['ID']['output']>;
  isForPersonalTransaction: Scalars['Boolean']['output'];
  leadSource: Maybe<Scalars['String']['output']>;
  profileId: Maybe<Scalars['ID']['output']>;
  propertyType: Maybe<Scalars['String']['output']>;
  representing: Maybe<GQLRepresenting>;
  splits: GQLPricingSplit;
};

export type GQLPricingStrategyInput = {
  isPersonalTransaction: Scalars['Boolean']['input'];
  leadSource?: InputMaybe<Scalars['String']['input']>;
  profileId: Scalars['ID']['input'];
  propertyType?: InputMaybe<Scalars['String']['input']>;
  representing: GQLRepresenting;
};

export type GQLProperty = {
  __typename?: 'Property';
  address: GQLAddress;
  assessorParcelNumber: Maybe<Scalars['String']['output']>;
  escrowNumber: Maybe<Scalars['String']['output']>;
  hasHOA: Maybe<Scalars['Boolean']['output']>;
  hasPool: Maybe<Scalars['Boolean']['output']>;
  hasPropane: Maybe<Scalars['Boolean']['output']>;
  hasSepticTank: Maybe<Scalars['Boolean']['output']>;
  hasSolar: Maybe<Scalars['Boolean']['output']>;
  hasWell: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  mlsNumber: Maybe<Scalars['String']['output']>;
  tenantOccupied: Maybe<Scalars['Boolean']['output']>;
  titleNumber: Maybe<Scalars['String']['output']>;
  yearBuilt: Maybe<Scalars['Int']['output']>;
};

export type GQLPropertyAddress = {
  __typename?: 'PropertyAddress';
  assessorParcelNumber: Maybe<Scalars['String']['output']>;
  city: Maybe<Scalars['String']['output']>;
  county: Maybe<Scalars['String']['output']>;
  legalDescription: Maybe<Scalars['String']['output']>;
  locales: Maybe<GQLInteractionLocales>;
  mlsNumber: Maybe<Scalars['String']['output']>;
  mlsServiceId: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  street1: Maybe<Scalars['String']['output']>;
  street2: Maybe<Scalars['String']['output']>;
  zip: Maybe<Scalars['String']['output']>;
};

export type GQLPropertyInfo = {
  __typename?: 'PropertyInfo';
  assessorParcelNumber: Maybe<Scalars['String']['output']>;
  bathrooms: Maybe<Scalars['Float']['output']>;
  bedrooms: Maybe<Scalars['Int']['output']>;
  block: Maybe<Scalars['String']['output']>;
  buildingArea: Maybe<Scalars['Float']['output']>;
  city: Maybe<Scalars['String']['output']>;
  county: Maybe<Scalars['String']['output']>;
  hasHOA: Maybe<Scalars['Boolean']['output']>;
  hasPool: Maybe<Scalars['Boolean']['output']>;
  hasPropane: Maybe<Scalars['Boolean']['output']>;
  hasSepticTank: Maybe<Scalars['Boolean']['output']>;
  hasSolar: Maybe<Scalars['Boolean']['output']>;
  hasWell: Maybe<Scalars['Boolean']['output']>;
  id: Maybe<Scalars['String']['output']>;
  insideListingDescription: Maybe<Scalars['String']['output']>;
  isTenantOccupied: Maybe<Scalars['Boolean']['output']>;
  legalDescription: Maybe<Scalars['String']['output']>;
  lot: Maybe<Scalars['String']['output']>;
  lotSize: Maybe<Scalars['Float']['output']>;
  mlsFee: Maybe<Scalars['String']['output']>;
  mlsNumber: Maybe<Scalars['String']['output']>;
  mlsServiceId: Maybe<Scalars['String']['output']>;
  pages: Maybe<Scalars['String']['output']>;
  platbook: Maybe<Scalars['String']['output']>;
  section: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  street1: Maybe<Scalars['String']['output']>;
  street2: Maybe<Scalars['String']['output']>;
  subdivision: Maybe<Scalars['String']['output']>;
  taxIdNumber: Maybe<Scalars['String']['output']>;
  yearBuilt: Maybe<Scalars['Int']['output']>;
  zip: Maybe<Scalars['String']['output']>;
};

export enum GQLPropertyOptionGroupInteractionType {
  client_group = 'client_group',
  lease_dual = 'lease_dual',
  lease_landlord = 'lease_landlord',
  lease_landlord_tenant = 'lease_landlord_tenant',
  lease_tenant = 'lease_tenant',
  listing = 'listing',
  listing_offer = 'listing_offer',
  offer = 'offer',
  referral = 'referral'
}

export type GQLPropertyOptionGroupOnTemplate = {
  __typename?: 'PropertyOptionGroupOnTemplate';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  pogInteractionType: GQLPropertyOptionGroupInteractionType;
};

export enum GQLPropertyRestrictionType {
  NO_RESTRICTION = 'NO_RESTRICTION',
  SPECIFIC_LOCATION = 'SPECIFIC_LOCATION',
  SPECIFIC_PROPERTIES = 'SPECIFIC_PROPERTIES'
}

export enum GQLPropertyType {
  COMMERCIAL = 'COMMERCIAL',
  CONDO_TOWNHOME_PUD = 'CONDO_TOWNHOME_PUD',
  CO_OP = 'CO_OP',
  MANUFACTURED_HOME_MOBILE = 'MANUFACTURED_HOME_MOBILE',
  MULTI_UNIT_1_4_UNITS = 'MULTI_UNIT_1_4_UNITS',
  MULTI_UNIT_5_PLUS = 'MULTI_UNIT_5_PLUS',
  NEW_CONSTRUCTION = 'NEW_CONSTRUCTION',
  NOT_SPECIFIED = 'NOT_SPECIFIED',
  REFERRAL = 'REFERRAL',
  RENTAL_LEASE = 'RENTAL_LEASE',
  SINGLE_FAMILY_RESIDENCE = 'SINGLE_FAMILY_RESIDENCE',
  TIC = 'TIC',
  VACANT_LAND_LOT = 'VACANT_LAND_LOT'
}

export type GQLQuery = {
  __typename?: 'Query';
  audit: GQLAudit;
  auditByInteractionId: Maybe<GQLAuditMetadata>;
  auditHistoryDownload: GQLAuditHistoryFile;
  auditViewers: Array<GQLViewer>;
  audits: GQLAuditsListConnection;
  brokerageById: Maybe<GQLIdentityBrokeragePayload>;
  brokerages: Maybe<GQLIdentityBrokeragesPayload>;
  checklistItemTemplateV2: GQLChecklistItemTemplateV2Result;
  checklistItemTemplateV2List: GQLChecklistItemTemplateListV2Result;
  checklistTemplateV2: GQLChecklistTemplateV2Result;
  checklistTemplateV2List: GQLChecklistTemplateListV2Result;
  commissionNotifications: GQLCommissionNotificationsPaginationResult;
  commissions: GQLCommissionsPaginationResult;
  /** Get a single Cover Sheet */
  coverSheet: Maybe<GQLCoverSheet>;
  delegateGroup: Maybe<GQLDelegateGroup>;
  delegateGroups: GQLDelegateGroupPaginationResult;
  docTemplate: GQLDocTemplate;
  /** Export interaction CSV file */
  exportInteractionCsv: GQLInteractionCSVFileResponse;
  featureFlagEvaluation: GQLFeatureFlagEvaluationResult;
  health: GQLHCResponse;
  homePage: GQLHomePage;
  identityTeamMember: Maybe<GQLIdentityTeamMemberPayload>;
  identityTeamMembers: Maybe<GQLIdentityTeamMemberConnection>;
  /** Get a single interaction */
  interaction: Maybe<GQLInteraction>;
  /** Get a paginated set of generic interactions */
  interactions: GQLInteractionsPaginationResult;
  /** Get a single listing */
  listing: Maybe<GQLListing>;
  lobAutocomplete: Maybe<GQLLobAutocompleteResponse>;
  me: GQLIdentityMePayload;
  mlsSearch: Maybe<GQLMlsResult>;
  mlsVendor: Maybe<GQLMlsVendor>;
  mlsVendors: Array<GQLMlsVendor>;
  nhdReports: Array<GQLNHDReport>;
  /** Get a single offer */
  offer: Maybe<GQLOffer>;
  /** Get a paginated set of offers */
  offers: GQLOffersPaginationResult;
  outsideBrokerages: GQLOutsideBrokeragePaginationResult;
  payment: GQLPayment;
  paymentV2: GQLPaymentV2;
  runners: Array<Maybe<GQLRunner>>;
  settlementCompanies: GQLSettlementCompaniesPaginationResult;
  settlementContacts: GQLSettlementContactsPaginationResult;
  tcRiskLevel: Maybe<GQLTCRiskLevelEntity>;
  teamById: Maybe<GQLIdentityTeamPayload>;
  teamLocations: GQLIdentityTeamLocationsConnection;
  teams: GQLIdentityTeamsPayload;
  templateCategoryV2: GQLTemplateCategoryV2Result;
  templateCategoryV2List: GQLTemplateCategoryListV2Result;
  templateRuleV2: GQLTemplateRuleV2Result;
  transaction: Maybe<GQLTransaction>;
  /** Get a single user by ID */
  userById: Maybe<GQLIdentityUserPayload>;
  users: GQLIdentityUserConnection;
};


export type GQLQueryauditArgs = {
  id: Scalars['ID']['input'];
};


export type GQLQueryauditByInteractionIdArgs = {
  input: GQLAuditByInteractionIdInput;
};


export type GQLQueryauditHistoryDownloadArgs = {
  id: Scalars['ID']['input'];
  input: GQLAuditHistoryDownloadParams;
};


export type GQLQueryauditViewersArgs = {
  auditId: Scalars['ID']['input'];
};


export type GQLQueryauditsArgs = {
  input: GQLAuditsListParams;
};


export type GQLQuerybrokerageByIdArgs = {
  id: Scalars['ID']['input'];
};


export type GQLQuerybrokeragesArgs = {
  input: GQLCursorPaginationInput;
};


export type GQLQuerychecklistItemTemplateV2Args = {
  id: Scalars['ID']['input'];
};


export type GQLQuerychecklistItemTemplateV2ListArgs = {
  input: GQLChecklistItemTemplateListV2Params;
};


export type GQLQuerychecklistTemplateV2Args = {
  id: Scalars['ID']['input'];
};


export type GQLQuerychecklistTemplateV2ListArgs = {
  input: GQLChecklistTemplateListV2Params;
};


export type GQLQuerycommissionNotificationsArgs = {
  input: GQLCommissionNotificationsInput;
};


export type GQLQuerycommissionsArgs = {
  input: GQLPaginationInput;
};


export type GQLQuerycoverSheetArgs = {
  input: GQLCoverSheetConfigQueryInput;
};


export type GQLQuerydelegateGroupArgs = {
  input: GQLDelegateGroupInput;
};


export type GQLQuerydelegateGroupsArgs = {
  input: GQLDelegateGroupsInput;
};


export type GQLQuerydocTemplateArgs = {
  input: GQLDocTemplateInput;
};


export type GQLQueryexportInteractionCsvArgs = {
  interactionId: Scalars['String']['input'];
};


export type GQLQueryfeatureFlagEvaluationArgs = {
  input: GQLFeatureFlagEvaluationInput;
};


export type GQLQueryidentityTeamMemberArgs = {
  input: GQLIdentityTeamMemberInput;
};


export type GQLQueryidentityTeamMembersArgs = {
  input: GQLTeamMembersCursorPaginationInput;
};


export type GQLQueryinteractionArgs = {
  input: GQLInteractionQueryInput;
};


export type GQLQueryinteractionsArgs = {
  input: GQLInteractionsInput;
};


export type GQLQuerylistingArgs = {
  input: GQLListingQueryInput;
};


export type GQLQuerylobAutocompleteArgs = {
  input: GQLLobAutocompleteInput;
};


export type GQLQuerymlsSearchArgs = {
  input: GQLMlsSearchInput;
};


export type GQLQuerymlsVendorArgs = {
  input: GQLMLSVendorInput;
};


export type GQLQuerynhdReportsArgs = {
  auditId: Scalars['ID']['input'];
};


export type GQLQueryofferArgs = {
  input: GQLOfferQueryInput;
};


export type GQLQueryoffersArgs = {
  input: InputMaybe<GQLPaginationInput>;
};


export type GQLQueryoutsideBrokeragesArgs = {
  input: GQLPaginationInput;
};


export type GQLQueryrunnersArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type GQLQuerysettlementCompaniesArgs = {
  input: GQLPaginationInput;
};


export type GQLQuerysettlementContactsArgs = {
  input: GQLPaginationInput;
};


export type GQLQuerytcRiskLevelArgs = {
  locale: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};


export type GQLQueryteamByIdArgs = {
  teamId: Scalars['ID']['input'];
};


export type GQLQueryteamLocationsArgs = {
  input: GQLCursorPaginationInput;
};


export type GQLQueryteamsArgs = {
  input: GQLCursorPaginationInput;
};


export type GQLQuerytemplateCategoryV2Args = {
  id: Scalars['ID']['input'];
};


export type GQLQuerytemplateCategoryV2ListArgs = {
  input: GQLTemplateCategoryListV2Params;
};


export type GQLQuerytemplateRuleV2Args = {
  id: Scalars['ID']['input'];
};


export type GQLQuerytransactionArgs = {
  input: GQLTransactionQueryInput;
};


export type GQLQueryuserByIdArgs = {
  userId: Scalars['ID']['input'];
};


export type GQLQueryusersArgs = {
  input: GQLBatchCursorPaginationInput;
};

export type GQLRecipient = {
  __typename?: 'Recipient';
  createdAt: Maybe<Scalars['String']['output']>;
  createdBy: Maybe<Scalars['String']['output']>;
  docusignRecipientId: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  externalId: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['String']['output']>;
  updatedBy: Maybe<Scalars['String']['output']>;
};

export enum GQLReconciledBy {
  AUTO_CLOSED = 'AUTO_CLOSED',
  INSTANT_PAID = 'INSTANT_PAID',
  MANUALLY_CLOSED = 'MANUALLY_CLOSED'
}

export type GQLReferral = GQLInteraction & GQLNode & {
  __typename?: 'Referral';
  acceptedOfferId: Maybe<Scalars['String']['output']>;
  agents: Array<GQLInteractionContactAgent>;
  agreementStatus: GQLReferralAgreementStatus;
  basicContacts: Maybe<Array<GQLBasicInteractionContactResponse>>;
  bindingAgreementDate: Maybe<Scalars['String']['output']>;
  client: GQLInteractionContactOther;
  closingDate: Maybe<Scalars['String']['output']>;
  commissionType: Maybe<GQLReferralCommissionType>;
  commissionValue: Maybe<Scalars['Float']['output']>;
  contactSuggestion: GQLContactSuggestion;
  /** A paginated list of contacts associated with the referral. */
  contacts: Maybe<Array<Maybe<GQLInteractionContact>>>;
  contractDate: Maybe<Scalars['String']['output']>;
  coverPhotoFileId: Maybe<Scalars['String']['output']>;
  coverPhotoUrl: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  displayPrice: Maybe<Scalars['Float']['output']>;
  displayStatus: GQLInteractionStatus;
  document: Maybe<GQLInteractionDocument>;
  documentPreview: GQLInteractionDocument;
  /**
   * The list of documents for the Referral
   * with optional filters by status
   */
  documents: Maybe<GQLInteractionDocumentsConnection>;
  endDate: Maybe<Scalars['DateTime']['output']>;
  /** Get an Envelope for a Referral */
  envelope: Maybe<GQLEnvelope>;
  /** Get a list of Envelopes for a Referral */
  envelopes: Maybe<Array<Maybe<GQLEnvelope>>>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  isIntermediary: Scalars['Boolean']['output'];
  listingEndDate: Maybe<Scalars['String']['output']>;
  listingStartDate: Maybe<Scalars['String']['output']>;
  newestInteraction: Maybe<GQLInteractionOnReferral>;
  notes: Maybe<Scalars['String']['output']>;
  onMarketDate: Maybe<Scalars['String']['output']>;
  owner: Scalars['String']['output'];
  property: Maybe<GQLPropertyAddress>;
  referralType: GQLReferralType;
  referringAgent: GQLReferralAgent;
  /** Get a list of Envelopes in a Sent state (with status `partiallySigned`, `voided`, `completed`, `created`, `sent`, or `sending`) */
  sentEnvelopes: Maybe<Array<Maybe<GQLEnvelope>>>;
  sidebarUi: GQLInteractionSidebarItemsConnection;
  startDate: Maybe<Scalars['DateTime']['output']>;
  /** The account preference contact for syncing */
  syncContact: Maybe<GQLInteractionDefaultContact>;
  teamId: Maybe<Scalars['String']['output']>;
  transactingAgent: GQLReferralAgent;
  transactions: Array<GQLTransaction>;
};


export type GQLReferralcontactSuggestionArgs = {
  input: GQLInteractionContactSuggestionInput;
};


export type GQLReferralcontactsArgs = {
  input: InputMaybe<GQLInteractionContactsInput>;
};


export type GQLReferraldocumentArgs = {
  id: Scalars['ID']['input'];
};


export type GQLReferraldocumentPreviewArgs = {
  documentVersionId: Scalars['ID']['input'];
};


export type GQLReferraldocumentsArgs = {
  input: InputMaybe<GQLInteractionDocumentsInput>;
};


export type GQLReferralenvelopeArgs = {
  input: GQLGetEnvelopeInput;
};


export type GQLReferralenvelopesArgs = {
  input: InputMaybe<GQLGetEnvelopesInput>;
};


export type GQLReferralsentEnvelopesArgs = {
  input: InputMaybe<GQLGetEnvelopesInput>;
};


export type GQLReferralsyncContactArgs = {
  input: GQLInteractionSyncContactInput;
};

export type GQLReferralAgent = {
  __typename?: 'ReferralAgent';
  broker: Maybe<GQLInteractionContactGeneralInfo>;
  brokerage: Maybe<GQLBrokerage>;
  cellPhone: Maybe<Scalars['String']['output']>;
  companyName: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  email: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  googleContactId: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isSideAgent: Scalars['Boolean']['output'];
  lastName: Maybe<Scalars['String']['output']>;
  licenseNumber: Maybe<Scalars['String']['output']>;
  licenseState: Maybe<Scalars['String']['output']>;
  officeManager: Maybe<GQLInteractionContactGeneralInfo>;
  state: Maybe<Scalars['String']['output']>;
  supervisingBroker: Maybe<GQLInteractionContactGeneralInfo>;
  teamId: Maybe<Scalars['String']['output']>;
  teamIdentityId: Maybe<Scalars['String']['output']>;
  teamName: Maybe<Scalars['String']['output']>;
  type: Maybe<GQLInteractionContactType>;
  userId: Maybe<Scalars['String']['output']>;
  userIdentityId: Maybe<Scalars['String']['output']>;
};

export enum GQLReferralAgreementStatus {
  completed = 'completed',
  notSent = 'notSent',
  partiallySigned = 'partiallySigned',
  sent = 'sent'
}

export enum GQLReferralClientType {
  buyer = 'buyer',
  landlord = 'landlord',
  seller = 'seller',
  tenant = 'tenant'
}

export type GQLReferralClientTypes = {
  __typename?: 'ReferralClientTypes';
  referralBuyer: Maybe<Scalars['Boolean']['output']>;
  referralLandlord: Maybe<Scalars['Boolean']['output']>;
  referralSeller: Maybe<Scalars['Boolean']['output']>;
  referralTenant: Maybe<Scalars['Boolean']['output']>;
};

export enum GQLReferralCommissionType {
  AMOUNT = 'AMOUNT',
  PERCENTAGE_ALL_COMMISSIONS = 'PERCENTAGE_ALL_COMMISSIONS',
  PERCENTAGE_LISTING_COMMISSION = 'PERCENTAGE_LISTING_COMMISSION',
  PERCENTAGE_PURCHASE_COMMISSION = 'PERCENTAGE_PURCHASE_COMMISSION'
}

export type GQLReferralMutations = {
  __typename?: 'ReferralMutations';
  /** Update/patch the referral */
  update: GQLInteractionMutationPayload;
};


export type GQLReferralMutationsupdateArgs = {
  input: GQLUpdateReferralInput;
};

export enum GQLReferralType {
  receiving = 'receiving',
  sending = 'sending'
}

export type GQLRegenerateStatementsPayload = GQLMutationPayload & {
  __typename?: 'RegenerateStatementsPayload';
  errors: Maybe<Array<GQLMutationProblem>>;
  query: GQLQuery;
  record: GQLPaymentTransactionStatementsConnection;
  status: GQLMutationStatus;
};

export type GQLRejectDocumentInput = {
  comment: Scalars['String']['input'];
  documentId: Scalars['ID']['input'];
};

export type GQLReleaseOfEarnestMoney = {
  __typename?: 'ReleaseOfEarnestMoney';
  details: Maybe<Scalars['String']['output']>;
  numberOfDays: Maybe<Scalars['Int']['output']>;
};

export type GQLReleaseOfEarnestMoneyInput = {
  details?: InputMaybe<Scalars['String']['input']>;
  numberOfDays?: InputMaybe<Scalars['Int']['input']>;
};

export type GQLRemoveDocumentInput = {
  documentId: Scalars['ID']['input'];
};

export enum GQLRepresenting {
  BUYER = 'BUYER',
  LANDLORD = 'LANDLORD',
  SELLER = 'SELLER',
  TENANT = 'TENANT'
}

export type GQLRequestCancelationInput = {
  transaction?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GQLRetryableErrorPayload = {
  critical: Scalars['Boolean']['output'];
  error: Maybe<GQLErrorData>;
  message: Scalars['String']['output'];
  retryable: Scalars['Boolean']['output'];
};

export type GQLReviewDocumentInput = {
  documentId: Scalars['ID']['input'];
  reviewStatus: GQLAuditDocumentReviewStatus;
};

export enum GQLReviewPriority {
  P1 = 'P1'
}

export enum GQLRiskLevel {
  HIGH = 'HIGH',
  LOW = 'LOW',
  NORMAL = 'NORMAL',
  TC_HIGH = 'TC_HIGH',
  TC_LOW = 'TC_LOW',
  TC_MEDIUM = 'TC_MEDIUM'
}

export type GQLRuleDefinition = {
  __typename?: 'RuleDefinition';
  conditions: Maybe<Scalars['JSONObject']['output']>;
  event: GQLDefinitionEvent;
  name: Maybe<Scalars['String']['output']>;
  priority: Maybe<Scalars['Int']['output']>;
};

export type GQLRuleDefinitionInput = {
  conditions: GQLTopLevelDefinitionConditionInput;
  event: GQLDefinitionEventInput;
  name?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['PositiveInt']['input']>;
};

export type GQLRuleDefinitionUpdateInput = {
  conditions: GQLTopLevelDefinitionConditionInput;
  event: GQLDefinitionEventUpdateInput;
  name?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['PositiveInt']['input']>;
};

export enum GQLRuleDocumentProcessor {
  FORM = 'FORM',
  OCR = 'OCR'
}

export enum GQLRuleType {
  EXTRACTION = 'EXTRACTION',
  INCLUSION = 'INCLUSION',
  VALIDATION = 'VALIDATION'
}

export type GQLRunner = {
  __typename?: 'Runner';
  id: Scalars['ID']['output'];
  progress: Maybe<Scalars['Int']['output']>;
  runnerResponse: Maybe<GQLRunnerResponse>;
  runnerType: Maybe<GQLRunnerType>;
  status: Maybe<GQLRunnerStatus>;
};

export type GQLRunnerMutations = {
  __typename?: 'RunnerMutations';
  createAndSendEnvelope: Maybe<GQLCreateEnvelopeMutationPayload>;
  createEnvelope: Maybe<GQLCreateEnvelopeMutationPayload>;
  createOfferFromUploadedDocument: Maybe<GQLCreateOfferFromUploadedPayload>;
  downloadDocuments: Maybe<GQLDownloadDocumentsMutationPayload>;
  downloadEnvelope: Maybe<GQLDownloadEnvelopeMutationPayload>;
  downloadPreviewDocument: Maybe<GQLDownloadPreviewDocumentMutationPayload>;
  forwardDocumentById: Maybe<GQLForwardDocumentByIdMutationPayload>;
  forwardDocuments: Maybe<GQLForwardDocumentsMutationPayload>;
  forwardEnvelope: Maybe<GQLForwardEnvelopeMutationPayload>;
  generateOffer: Maybe<GQLGenerateOfferMutationPayload>;
};


export type GQLRunnerMutationscreateAndSendEnvelopeArgs = {
  ccRecipientEmails: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  envelopeName: Scalars['String']['input'];
  envelopeRecipients: Array<GQLEnvelopeRecipient>;
  interactionId: Scalars['String']['input'];
};


export type GQLRunnerMutationscreateEnvelopeArgs = {
  interactionId: Scalars['String']['input'];
};


export type GQLRunnerMutationscreateOfferFromUploadedDocumentArgs = {
  interactionDocumentId: Scalars['String']['input'];
  interactionId: Scalars['String']['input'];
};


export type GQLRunnerMutationsdownloadDocumentsArgs = {
  documentId: InputMaybe<Scalars['String']['input']>;
  interactionId: Scalars['String']['input'];
  status: InputMaybe<GQLInteractionDocumentStatus>;
};


export type GQLRunnerMutationsdownloadEnvelopeArgs = {
  docusignEnvelopeId: Scalars['String']['input'];
  envelopeName: Scalars['String']['input'];
  interactionId: Scalars['String']['input'];
  interactionType: Scalars['String']['input'];
};


export type GQLRunnerMutationsdownloadPreviewDocumentArgs = {
  interactionId: Scalars['String']['input'];
  versionId: Scalars['String']['input'];
};


export type GQLRunnerMutationsforwardDocumentByIdArgs = {
  bccRecipientEmails: InputMaybe<Array<Scalars['String']['input']>>;
  ccRecipientEmails: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  emailBody: Scalars['String']['input'];
  emailSubject: Scalars['String']['input'];
  interactionDocumentId: Scalars['String']['input'];
  interactionId: Scalars['String']['input'];
  recipientEmails: Array<InputMaybe<Scalars['String']['input']>>;
};


export type GQLRunnerMutationsforwardDocumentsArgs = {
  ccRecipientEmails: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  emailBody: Scalars['String']['input'];
  emailSubject: Scalars['String']['input'];
  interactionId: Scalars['String']['input'];
  recipientEmails: Array<InputMaybe<Scalars['String']['input']>>;
};


export type GQLRunnerMutationsforwardEnvelopeArgs = {
  ccRecipientEmails: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  emailBody: Scalars['String']['input'];
  emailSubject: Scalars['String']['input'];
  envelopeId: Scalars['String']['input'];
  interactionId: Scalars['String']['input'];
  recipientEmails: Array<InputMaybe<Scalars['String']['input']>>;
};


export type GQLRunnerMutationsgenerateOfferArgs = {
  documentIds: Array<Scalars['String']['input']>;
  interactionId: Scalars['String']['input'];
};

export type GQLRunnerResponse = GQLCreateRunnerResponseData | GQLDownloadRunnerResponseData;

export enum GQLRunnerStatus {
  created = 'created',
  failed = 'failed',
  retrying = 'retrying',
  succeeded = 'succeeded'
}

export enum GQLRunnerType {
  CREATE_DOCUSIGN_ENVELOPE = 'CREATE_DOCUSIGN_ENVELOPE',
  CREATE_OFFER_FROM_UPLOADED_DOCUMENT = 'CREATE_OFFER_FROM_UPLOADED_DOCUMENT',
  DOWNLOAD_ALL_DOCUMENTS_BY_STATUS = 'DOWNLOAD_ALL_DOCUMENTS_BY_STATUS',
  DOWNLOAD_DOCUMENT = 'DOWNLOAD_DOCUMENT',
  DOWNLOAD_DOCUSIGN_ENVELOPE = 'DOWNLOAD_DOCUSIGN_ENVELOPE',
  DOWNLOAD_PREVIEW_DOCUMENT = 'DOWNLOAD_PREVIEW_DOCUMENT',
  FORWARD_ALL_DOCUMENTS_BY_STATUS = 'FORWARD_ALL_DOCUMENTS_BY_STATUS',
  FORWARD_DOCUMENT = 'FORWARD_DOCUMENT',
  FORWARD_ENVELOPE = 'FORWARD_ENVELOPE',
  GENERATE_OFFER = 'GENERATE_OFFER'
}

export type GQLSendAuditUpdateInput = {
  attachmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  message: Scalars['String']['input'];
  recipients: Array<Scalars['String']['input']>;
};

export type GQLSetAuditsOwnersInput = {
  auditIds: Array<Scalars['String']['input']>;
  ownerEmails: Array<Scalars['String']['input']>;
};

export type GQLSettlementCompaniesPaginationResult = GQLPaginationResponse & {
  __typename?: 'SettlementCompaniesPaginationResult';
  items: Array<GQLSettlementCompany>;
  pageInfo: GQLPaginationPageInfo;
};

export type GQLSettlementCompany = GQLNode & {
  __typename?: 'SettlementCompany';
  accountingCustomerId: Maybe<Scalars['String']['output']>;
  accountingSupplierId: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  legacyExternalId: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  status: Maybe<GQLSettlementCompanyStatus>;
};

export type GQLSettlementCompanyMutations = {
  __typename?: 'SettlementCompanyMutations';
  update: GQLSettlementCompanyUpdatePayload;
};


export type GQLSettlementCompanyMutationsupdateArgs = {
  id: Scalars['ID']['input'];
  input: GQLSettlementCompanyUpdateInput;
};

export enum GQLSettlementCompanyStatus {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED'
}

export type GQLSettlementCompanyUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<GQLSettlementCompanyStatus>;
};

export type GQLSettlementCompanyUpdatePayload = GQLMutationPayload & {
  __typename?: 'SettlementCompanyUpdatePayload';
  errors: Maybe<Array<GQLMutationProblem>>;
  query: GQLQuery;
  record: Maybe<GQLSettlementCompany>;
  status: GQLMutationStatus;
};

export type GQLSettlementContact = {
  __typename?: 'SettlementContact';
  company: GQLSettlementContactCompany;
  email: Maybe<Scalars['String']['output']>;
  externalId: Scalars['ID']['output'];
  fileNumber: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  phoneNumber: Maybe<Scalars['String']['output']>;
};

export type GQLSettlementContactCompany = {
  __typename?: 'SettlementContactCompany';
  externalId: Scalars['ID']['output'];
  id: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
};

export type GQLSettlementContactInput = {
  externalId: Scalars['ID']['input'];
  fileNumber?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type GQLSettlementContactMutationInput = {
  companyName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type GQLSettlementContactMutationPayload = GQLMutationPayload & {
  __typename?: 'SettlementContactMutationPayload';
  errors: Maybe<Array<GQLMutationProblem>>;
  query: GQLQuery;
  record: Maybe<GQLSettlementContact>;
  status: GQLMutationStatus;
};

export type GQLSettlementContactMutations = {
  __typename?: 'SettlementContactMutations';
  approveCompany: GQLSettlementContactUpdatePayload;
  changeCompanyName: GQLSettlementContactUpdatePayload;
  moveToNewCompany: GQLSettlementContactUpdatePayload;
  update: GQLSettlementContactUpdatePayload;
};


export type GQLSettlementContactMutationsapproveCompanyArgs = {
  id: Scalars['ID']['input'];
  input: GQLApproveCompanyInput;
};


export type GQLSettlementContactMutationschangeCompanyNameArgs = {
  id: Scalars['ID']['input'];
  input: GQLChangeCompanyNameInput;
};


export type GQLSettlementContactMutationsmoveToNewCompanyArgs = {
  id: Scalars['ID']['input'];
  input: GQLMoveToNewCompanyInput;
};


export type GQLSettlementContactMutationsupdateArgs = {
  id: Scalars['ID']['input'];
  input: GQLUpdateSettlementContactInput;
};

export type GQLSettlementContactUpdatePayload = GQLMutationPayload & {
  __typename?: 'SettlementContactUpdatePayload';
  errors: Maybe<Array<GQLMutationProblem>>;
  query: GQLQuery;
  record: Maybe<GQLSettlementContactV2>;
  status: GQLMutationStatus;
};

export type GQLSettlementContactV2 = GQLNode & {
  __typename?: 'SettlementContactV2';
  commission: Maybe<GQLSettlementContactV2Commission>;
  company: Maybe<GQLSettlementCompany>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  phoneNumber: Maybe<Scalars['String']['output']>;
};

export type GQLSettlementContactV2Commission = GQLNode & {
  __typename?: 'SettlementContactV2Commission';
  address: Maybe<GQLFullAddress>;
  closeDate: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  legacyExternalId: Maybe<Scalars['ID']['output']>;
};

export type GQLSettlementContactV2UpdateInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type GQLSettlementContactsPaginationResult = GQLPaginationResponse & {
  __typename?: 'SettlementContactsPaginationResult';
  items: Array<GQLSettlementContactV2>;
  pageInfo: GQLPaginationPageInfo;
};

export type GQLShortUrlData = {
  __typename?: 'ShortUrlData';
  id: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
};

export type GQLSidebarItem = GQLSidebarLink;

export type GQLSidebarLink = {
  __typename?: 'SidebarLink';
  disabledWhenCoverSheetIncomplete: Scalars['Boolean']['output'];
  id: GQLSidebarLinkIds;
  label: Scalars['String']['output'];
  pathnameTemplate: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type GQLSidebarLinkBadge = {
  __typename?: 'SidebarLinkBadge';
  count: Maybe<Scalars['Int']['output']>;
  tooltip: Maybe<Scalars['String']['output']>;
};

export enum GQLSidebarLinkIds {
  commission_form = 'commission_form',
  cover_letter = 'cover_letter',
  cover_sheet = 'cover_sheet',
  disclosures = 'disclosures',
  distribution_request = 'distribution_request',
  docs = 'docs',
  documents = 'documents',
  home = 'home',
  listing = 'listing',
  offer = 'offer',
  offers = 'offers',
  open_house = 'open_house',
  pre_qual = 'pre_qual',
  proof_of_funds = 'proof_of_funds',
  timeline = 'timeline'
}

export type GQLSignedFileOptions = {
  contentDisposition?: InputMaybe<GQLContentDisposition>;
};

export enum GQLSortDirection {
  asc = 'asc',
  desc = 'desc'
}

export type GQLSplitDocumentInput = {
  documentId: Scalars['ID']['input'];
  splits: Array<GQLSplitItemInput>;
};

export type GQLSplitItemInput = {
  itemId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  pageFinish: Scalars['Int']['input'];
  pageStart: Scalars['Int']['input'];
};

export enum GQLSubmissionType {
  ADJUSTMENT = 'ADJUSTMENT',
  SUBMISSION = 'SUBMISSION'
}

export type GQLTCRiskLevelEntity = {
  __typename?: 'TCRiskLevelEntity';
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  email: Maybe<Scalars['String']['output']>;
  label: GQLRiskLevel;
  locale: Scalars['String']['output'];
  riskLevel: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
  updatedBy: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export enum GQLTargetTier {
  AUDIT = 'AUDIT',
  SYSTEM = 'SYSTEM',
  T1 = 'T1'
}

export type GQLTeamMemberHistory = GQLAuditable & GQLNode & {
  __typename?: 'TeamMemberHistory';
  createdAt: Maybe<Scalars['String']['output']>;
  createdBy: Maybe<Scalars['String']['output']>;
  fieldChanges: Array<GQLFieldChange>;
  id: Scalars['ID']['output'];
  permissionChanges: Array<GQLPermissionChange>;
  requestId: Maybe<Scalars['ID']['output']>;
  updatedAt: Maybe<Scalars['String']['output']>;
  updatedBy: Maybe<Scalars['String']['output']>;
};

export type GQLTeamMemberHistoryPaginationResult = GQLPaginationResponse & {
  __typename?: 'TeamMemberHistoryPaginationResult';
  items: Array<GQLTeamMemberHistory>;
  pageInfo: GQLPaginationPageInfo;
};

export type GQLTeamMembersByTeamInput = {
  includeParentTeamRecursively?: InputMaybe<Scalars['Boolean']['input']>;
  includeSideTCs?: InputMaybe<Scalars['Boolean']['input']>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<GQLDatagridSortModel>>;
};

export type GQLTeamMembersCursorPaginationInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<InputMaybe<GQLFacetFilter>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GQLDatagridSortModel>>>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type GQLTeamMembersV2PaginationResult = GQLPaginationResponse & {
  __typename?: 'TeamMembersV2PaginationResult';
  items: Array<GQLPaymentTeamMember>;
  pageInfo: GQLPaginationPageInfo;
};

export type GQLTeamUpdatePayload = GQLMutationPayload & {
  __typename?: 'TeamUpdatePayload';
  errors: Maybe<Array<GQLMutationProblem>>;
  query: GQLQuery;
  record: Maybe<GQLIdentityTeam>;
  status: GQLMutationStatus;
};

export type GQLTeamV2Input = {
  teamId: Scalars['ID']['input'];
};

export type GQLTeamsV2Response = GQLPaginationResponse & {
  __typename?: 'TeamsV2Response';
  items: Array<GQLIdentityTeam>;
  pageInfo: GQLPaginationPageInfo;
};

export type GQLTemplateCategoryListV2Error = GQLNodeErrorPayload & {
  __typename?: 'TemplateCategoryListV2Error';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  status: Scalars['Int']['output'];
};

export type GQLTemplateCategoryListV2Filter = {
  checklistType?: InputMaybe<GQLChecklistType>;
  locale?: InputMaybe<Scalars['String']['input']>;
  transactionPhase?: InputMaybe<GQLTransactionPhase>;
};

export type GQLTemplateCategoryListV2Params = {
  filter?: InputMaybe<GQLTemplateCategoryListV2Filter>;
};

export type GQLTemplateCategoryListV2Result = {
  __typename?: 'TemplateCategoryListV2Result';
  categories: Maybe<Array<GQLTemplateCategoryV2>>;
  errors: Maybe<Array<GQLTemplateCategoryListV2Error>>;
};

export type GQLTemplateCategoryV2 = GQLNode & {
  __typename?: 'TemplateCategoryV2';
  checklistType: GQLChecklistType;
  id: Scalars['ID']['output'];
  isSystem: Scalars['Boolean']['output'];
  locale: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  sortPriority: Scalars['Int']['output'];
  transactionPhase: GQLTransactionPhase;
};

export type GQLTemplateCategoryV2Error = GQLNodeErrorPayload & {
  __typename?: 'TemplateCategoryV2Error';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  status: Scalars['Int']['output'];
};

export type GQLTemplateCategoryV2Mutations = {
  __typename?: 'TemplateCategoryV2Mutations';
  delete: GQLTemplateCategoryV2Result;
  update: GQLTemplateCategoryV2Result;
};


export type GQLTemplateCategoryV2MutationsupdateArgs = {
  input: GQLUpdateTemplateCategoryV2Input;
};

export type GQLTemplateCategoryV2Result = GQLNodeResult & {
  __typename?: 'TemplateCategoryV2Result';
  errors: Maybe<Array<GQLTemplateCategoryV2Error>>;
  node: Maybe<GQLTemplateCategoryV2>;
};

export type GQLTemplateRuleListFilter = {
  type?: InputMaybe<Array<GQLRuleType>>;
};

export type GQLTemplateRuleListV2Params = {
  filter?: InputMaybe<GQLTemplateRuleListFilter>;
};

export type GQLTemplateRuleV2 = GQLNode & {
  __typename?: 'TemplateRuleV2';
  definition: GQLRuleDefinition;
  documentProcessor: Maybe<GQLRuleDocumentProcessor>;
  id: Scalars['ID']['output'];
  itemTemplateVersion: Maybe<GQLChecklistItemTemplateVersionV2>;
  itemTemplateVersionId: Maybe<Scalars['ID']['output']>;
  multiDocuments: Maybe<Scalars['Boolean']['output']>;
  name: Maybe<Scalars['String']['output']>;
  pagesRange: Maybe<Array<Scalars['PageRange']['output']>>;
  templateVersion: Maybe<GQLChecklistTemplateVersionV2>;
  templateVersionId: Maybe<Scalars['ID']['output']>;
  type: GQLRuleType;
};

export type GQLTemplateRuleV2Error = GQLNodeErrorPayload & {
  __typename?: 'TemplateRuleV2Error';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  status: Scalars['Int']['output'];
};

export type GQLTemplateRuleV2Mutations = {
  __typename?: 'TemplateRuleV2Mutations';
  delete: GQLTemplateRuleV2Result;
  update: GQLTemplateRuleV2Result;
};


export type GQLTemplateRuleV2MutationsupdateArgs = {
  input: GQLUpdateTemplateRuleV2Input;
};

export type GQLTemplateRuleV2Result = GQLNodeResult & {
  __typename?: 'TemplateRuleV2Result';
  errors: Maybe<Array<GQLTemplateRuleV2Error>>;
  node: Maybe<GQLTemplateRuleV2>;
};

export type GQLTemplateVersionCategoryV2 = {
  __typename?: 'TemplateVersionCategoryV2';
  id: Scalars['ID']['output'];
  isSystem: Scalars['Boolean']['output'];
  items: Array<GQLAssociatedChecklistItemTemplateVersionV2>;
  name: Scalars['String']['output'];
  sortPriority: Scalars['Int']['output'];
  transactionPhase: GQLTransactionPhase;
};

export type GQLTopLevelDefinitionConditionInput = {
  all?: InputMaybe<Array<GQLDefinitionConditionInput>>;
  any?: InputMaybe<Array<GQLDefinitionConditionInput>>;
};

export type GQLTransaction = {
  __typename?: 'Transaction';
  adjustedGrossCommission: Maybe<Scalars['Float']['output']>;
  allocations: Array<GQLTransactionAllocation>;
  city: Maybe<Scalars['String']['output']>;
  clients: Maybe<Scalars['String']['output']>;
  closeDate: Maybe<Scalars['String']['output']>;
  coBrokerageFees: Array<GQLTransactionFee>;
  commissionLeadSource: Maybe<GQLTransactionCommissionLeadSource>;
  commissionPercentage: Maybe<Scalars['Float']['output']>;
  commissionStatus: Maybe<GQLCommissionStatus>;
  commissionSummary: Maybe<GQLCommissionSummary>;
  commissionSystem: Maybe<GQLCommissionSystem>;
  demandTransaction: Maybe<GQLDemandTransaction>;
  escrowAmount: Maybe<Scalars['Float']['output']>;
  externalId: Scalars['ID']['output'];
  fees: Array<GQLTransactionFee>;
  fileStatuses: Array<GQLTransactionFeeFileStatus>;
  hasBeenSubmitted: Scalars['Boolean']['output'];
  id: Maybe<Scalars['ID']['output']>;
  interactionId: Maybe<Scalars['ID']['output']>;
  interactionType: Maybe<GQLInteractionType>;
  isCommissionFormReady: Scalars['Boolean']['output'];
  isFixedCommission: Scalars['Boolean']['output'];
  isInstantPayEligible: Scalars['Boolean']['output'];
  isSettlementInfoReady: Scalars['Boolean']['output'];
  me: GQLTransactionProfile;
  netCommission: Maybe<Scalars['Float']['output']>;
  payees: Array<GQLTransactionParty>;
  pricingStrategies: Array<GQLPricingStrategy>;
  referrals: Array<GQLTransactionReferral>;
  salePrice: Scalars['Float']['output'];
  settlementContact: Maybe<GQLSettlementContact>;
  sideTeam: GQLTransactionTeam;
  startingGrossCommission: Scalars['Float']['output'];
  state: Maybe<Scalars['String']['output']>;
  statements: GQLPaymentTransactionStatementsConnection;
  street: Maybe<Scalars['String']['output']>;
  team: GQLTransactionTeam;
  transactionSide: GQLTransactionSide;
  transactionStatus: GQLTransactionStatus;
  transactionType: GQLPaymentTransactionType;
  updatedAt: Maybe<Scalars['String']['output']>;
  updatedBy: Maybe<Scalars['String']['output']>;
  zip: Maybe<Scalars['String']['output']>;
};


export type GQLTransactioncommissionStatusArgs = {
  input: InputMaybe<GQLTransactionCommissionStatusInput>;
};


export type GQLTransactionpayeesArgs = {
  input: GQLTransactionTeamPayeesQueryInput;
};


export type GQLTransactionpricingStrategiesArgs = {
  input: GQLPricingStrategyInput;
};

export type GQLTransactionAddress = {
  __typename?: 'TransactionAddress';
  city: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  street: Maybe<Scalars['String']['output']>;
  zip: Maybe<Scalars['String']['output']>;
};

export type GQLTransactionAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type GQLTransactionAllocation = {
  __typename?: 'TransactionAllocation';
  agentNet: Maybe<Scalars['Float']['output']>;
  amount: Maybe<Scalars['Float']['output']>;
  externalId: Scalars['ID']['output'];
  gross: GQLAllocationGross;
  hasMetPersonalTransactionLimit: Maybe<Scalars['Boolean']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  isCapReached: Maybe<Scalars['Boolean']['output']>;
  isDeleted: Maybe<Scalars['Boolean']['output']>;
  isPercent: Scalars['Boolean']['output'];
  isPersonalTransaction: Scalars['Boolean']['output'];
  isRepresentingBothParties: Scalars['Boolean']['output'];
  postCapSavingsAmount: Maybe<Scalars['Float']['output']>;
  postCapSavingsRecipient: Maybe<Scalars['String']['output']>;
  profile: GQLTransactionProfile;
  splits: Maybe<GQLTransactionAllocationSplits>;
  tax: GQLAllocationTax;
  /** @deprecated field removed */
  yearToDate: Maybe<GQLYearToDate>;
};

export type GQLTransactionAllocationInput = {
  amount: Scalars['Float']['input'];
  externalId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isDeleted: Scalars['Boolean']['input'];
  isPercent: Scalars['Boolean']['input'];
  isPersonalTransaction: Scalars['Boolean']['input'];
  isRepresentingBothParties: Scalars['Boolean']['input'];
  profile: GQLTransactionAllocationProfileInput;
  splits?: InputMaybe<GQLTransactionAllocationSplitsInput>;
};

export type GQLTransactionAllocationProfileInput = {
  externalId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type GQLTransactionAllocationSplits = {
  __typename?: 'TransactionAllocationSplits';
  agentPercent: Maybe<Scalars['Float']['output']>;
  amountOwedToSide: Maybe<Scalars['Float']['output']>;
  brokeragePercent: Maybe<Scalars['Float']['output']>;
  expectedBrokeragePercent: Maybe<Scalars['Float']['output']>;
  parentTeamPercent: Maybe<Scalars['Float']['output']>;
  teamPercent: Maybe<Scalars['Float']['output']>;
};

export type GQLTransactionAllocationSplitsInput = {
  agentPercent: Scalars['Float']['input'];
  brokeragePercent: Scalars['Float']['input'];
  parentTeamPercent: Scalars['Float']['input'];
  teamPercent: Scalars['Float']['input'];
};

export type GQLTransactionAttachment = {
  __typename?: 'TransactionAttachment';
  externalId: Scalars['ID']['output'];
  file: GQLTransactionAttachmentFile;
  id: Maybe<Scalars['ID']['output']>;
  isDeleted: Maybe<Scalars['Boolean']['output']>;
};

export type GQLTransactionAttachmentFile = {
  __typename?: 'TransactionAttachmentFile';
  name: Scalars['String']['output'];
};

export type GQLTransactionAttachmentInput = {
  externalId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isDeleted: Scalars['Boolean']['input'];
};

export enum GQLTransactionCommissionLeadSource {
  AGENT_GENERATED = 'AGENT_GENERATED',
  BTSA = 'BTSA',
  DOOR_KNOCKING = 'DOOR_KNOCKING',
  MARKETING_CHANNEL = 'MARKETING_CHANNEL',
  OFFER_WRITING = 'OFFER_WRITING',
  ONLINE = 'ONLINE',
  OPEN_HOUSE = 'OPEN_HOUSE',
  PAID = 'PAID',
  PERFORMANCE = 'PERFORMANCE',
  PROVIDED_BY_TEAM_LEAD_TO_ASSOCIATE_AGENT = 'PROVIDED_BY_TEAM_LEAD_TO_ASSOCIATE_AGENT',
  PROVIDED_BY_TEAM_OR_PARTNER_TO_ASSOCIATE_AGENT = 'PROVIDED_BY_TEAM_OR_PARTNER_TO_ASSOCIATE_AGENT',
  SHOWING_LEAD = 'SHOWING_LEAD',
  TEAM_PROVIDED = 'TEAM_PROVIDED',
  TEAM_PROVIDED_COLD = 'TEAM_PROVIDED_COLD',
  TEAM_PROVIDED_WARM = 'TEAM_PROVIDED_WARM',
  TEAM_REFERRAL = 'TEAM_REFERRAL',
  ZILLOW = 'ZILLOW'
}

export type GQLTransactionCommissionStatusInput = {
  demandTransactionId: Scalars['ID']['input'];
};

export type GQLTransactionFee = {
  __typename?: 'TransactionFee';
  agentName: Maybe<Scalars['String']['output']>;
  amount: Scalars['Float']['output'];
  attachments: Maybe<Array<GQLTransactionAttachment>>;
  calculatedAmount: Maybe<Scalars['Float']['output']>;
  companyName: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  externalId: Scalars['ID']['output'];
  id: Maybe<Scalars['ID']['output']>;
  isDeleted: Maybe<Scalars['Boolean']['output']>;
  isPercent: Scalars['Boolean']['output'];
  isPre: Scalars['Boolean']['output'];
  payee: Maybe<GQLTransactionParty>;
  payer: Maybe<GQLTransactionParty>;
  type: GQLTransactionFeeType;
};

export type GQLTransactionFeeFile = {
  __typename?: 'TransactionFeeFile';
  bucket: Scalars['String']['output'];
  contentType: Maybe<Scalars['String']['output']>;
  downloadUrl: Maybe<Scalars['String']['output']>;
  filePath: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  uploadFailReason: Maybe<Scalars['String']['output']>;
  uploadStatus: Maybe<Scalars['String']['output']>;
  uploadUrl: Maybe<Scalars['String']['output']>;
};

export type GQLTransactionFeeFileStatus = {
  __typename?: 'TransactionFeeFileStatus';
  externalId: Maybe<Scalars['ID']['output']>;
  file: Maybe<GQLTransactionFeeFile>;
  id: Scalars['ID']['output'];
  status: Maybe<GQLTransactionFeeFileUploadStatus>;
};

export enum GQLTransactionFeeFileUploadStatus {
  COMPLETED = 'COMPLETED',
  CREATED = 'CREATED',
  FAILED = 'FAILED',
  PROCESSING = 'PROCESSING',
  UPLOADING = 'UPLOADING'
}

export type GQLTransactionFeeInput = {
  agentName?: InputMaybe<Scalars['String']['input']>;
  amount: Scalars['Float']['input'];
  attachments?: InputMaybe<Array<GQLTransactionAttachmentInput>>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isDeleted: Scalars['Boolean']['input'];
  isPercent: Scalars['Boolean']['input'];
  isPre: Scalars['Boolean']['input'];
  payee?: InputMaybe<GQLTransactionPartyInput>;
  payer?: InputMaybe<GQLTransactionPartyInput>;
  type: GQLTransactionFeeType;
};

export enum GQLTransactionFeeType {
  ADDITIONAL_COMMISSION = 'ADDITIONAL_COMMISSION',
  ADJUSTMENT = 'ADJUSTMENT',
  ADMIN = 'ADMIN',
  AGENT_REBATE = 'AGENT_REBATE',
  AGENT_TO_AGENT_SAME_TEAM = 'AGENT_TO_AGENT_SAME_TEAM',
  BRAND = 'BRAND',
  BROKERAGE = 'BROKERAGE',
  CHARITY = 'CHARITY',
  CHARITY_BY_TITLE = 'CHARITY_BY_TITLE',
  CLEANING = 'CLEANING',
  CLIENT_CREDIT = 'CLIENT_CREDIT',
  CLOSING_COST_CREDIT = 'CLOSING_COST_CREDIT',
  CO_BROKERAGE = 'CO_BROKERAGE',
  ECOMMISSION = 'ECOMMISSION',
  E_AND_O = 'E_AND_O',
  FLAT_BROKERAGE = 'FLAT_BROKERAGE',
  FMLS = 'FMLS',
  HOA_DOCUMENT = 'HOA_DOCUMENT',
  HOME_WARRANTY = 'HOME_WARRANTY',
  INSPECTION_REPORT = 'INSPECTION_REPORT',
  LISTING_MANAGEMENT = 'LISTING_MANAGEMENT',
  MARKETING = 'MARKETING',
  MISC_PAID_BY_TITLE = 'MISC_PAID_BY_TITLE',
  MLS_FEE_DEDUCTION = 'MLS_FEE_DEDUCTION',
  MLS_FEE_REIMBURSEMENT = 'MLS_FEE_REIMBURSEMENT',
  NATURAL_HAZARD = 'NATURAL_HAZARD',
  NOTARY = 'NOTARY',
  OTHER = 'OTHER',
  PHOTOGRAPHY = 'PHOTOGRAPHY',
  REFERRAL = 'REFERRAL',
  REPAIR = 'REPAIR',
  RERM = 'RERM',
  SALT_PAYABLE = 'SALT_PAYABLE',
  SHOWING = 'SHOWING',
  SIDE_PAID_TC = 'SIDE_PAID_TC',
  STAGING = 'STAGING',
  TC = 'TC',
  TC_BY_TITLE = 'TC_BY_TITLE',
  TEAM = 'TEAM',
  TEAM_RENTAL = 'TEAM_RENTAL',
  TEAM_SHARE = 'TEAM_SHARE',
  TRANSACTION = 'TRANSACTION',
  WIRE = 'WIRE'
}

export type GQLTransactionFileDetails = {
  __typename?: 'TransactionFileDetails';
  fileId: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Maybe<Scalars['String']['output']>;
  uploadUrl: Scalars['String']['output'];
};

export type GQLTransactionMutationInput = {
  id: Scalars['ID']['input'];
  interactionId?: InputMaybe<Scalars['ID']['input']>;
};

export type GQLTransactionMutationPayload = GQLMutationPayload & {
  __typename?: 'TransactionMutationPayload';
  calculationError: Maybe<GQLPaymentCalculationError>;
  errors: Maybe<Array<GQLMutationProblem>>;
  query: GQLQuery;
  record: Maybe<GQLTransaction>;
  status: GQLMutationStatus;
  validationError: Maybe<GQLPaymentValidationError>;
};

export type GQLTransactionMutations = {
  __typename?: 'TransactionMutations';
  calculatePreview: GQLTransactionMutationPayload;
  certify: GQLTransactionMutationPayload;
  /** Adds a settlement contact to a transaction */
  createSettlementContact: GQLSettlementContactMutationPayload;
  dispatchStatementsNotifications: GQLTransactionMutationPayload;
  /** finalize a transaction */
  finalize: GQLFinalizeTransactionPayload;
  /** upload files to commission form */
  generateFileUploadUrls: Maybe<GQLGenerateFileUploadUrlsPayload>;
  regenerateStatements: GQLRegenerateStatementsPayload;
  /** Update a transaction */
  update: GQLTransactionMutationPayload;
};


export type GQLTransactionMutationscalculatePreviewArgs = {
  input: GQLUpdateTransactionInput;
};


export type GQLTransactionMutationscertifyArgs = {
  input: GQLCertifyTransactionInput;
};


export type GQLTransactionMutationscreateSettlementContactArgs = {
  input: GQLSettlementContactMutationInput;
};


export type GQLTransactionMutationsdispatchStatementsNotificationsArgs = {
  input: GQLDispatchStatementsNotificationsInput;
};


export type GQLTransactionMutationsgenerateFileUploadUrlsArgs = {
  input: GQLGenerateFileUploadUrlsInput;
};


export type GQLTransactionMutationsupdateArgs = {
  input: GQLUpdateTransactionInput;
};

export type GQLTransactionParentTeam = GQLTransactionTeamInterface & {
  __typename?: 'TransactionParentTeam';
  externalId: Scalars['ID']['output'];
  id: Maybe<Scalars['ID']['output']>;
  isFlatFeeTeam: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  subType: Maybe<GQLTransactionTeamSubType>;
  type: GQLTransactionTeamType;
  useSideInstantPay: Scalars['Boolean']['output'];
};

export type GQLTransactionParty = {
  __typename?: 'TransactionParty';
  address: Maybe<GQLTransactionAddress>;
  brokerageName: Maybe<Scalars['String']['output']>;
  externalId: Maybe<Scalars['ID']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  status: Maybe<GQLTransactionProfileStatusType>;
  team: Maybe<GQLTransactionTeam>;
  type: GQLTransactionPartyType;
};

export type GQLTransactionPartyInput = {
  address?: InputMaybe<GQLTransactionAddressInput>;
  brokerageName?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  type: GQLTransactionPartyType;
};

export enum GQLTransactionPartyType {
  BROKERAGE = 'BROKERAGE',
  EXTERNAL_AGENT = 'EXTERNAL_AGENT',
  EXTERNAL_BROKERAGE = 'EXTERNAL_BROKERAGE',
  EXTERNAL_COMPANY = 'EXTERNAL_COMPANY',
  EXTERNAL_PERSON = 'EXTERNAL_PERSON',
  OUTSIDE_BROKERAGE = 'OUTSIDE_BROKERAGE',
  PROFILE = 'PROFILE',
  REAL_ESTATE_SERVICES = 'REAL_ESTATE_SERVICES',
  REFERRAL_COMPANY = 'REFERRAL_COMPANY',
  SETTLEMENT_COMPANY = 'SETTLEMENT_COMPANY',
  SETTLEMENT_CONTACT = 'SETTLEMENT_CONTACT',
  TEAM = 'TEAM',
  TEAM_MEMBER = 'TEAM_MEMBER'
}

export enum GQLTransactionPhase {
  LISTING = 'LISTING',
  TRANSACTION = 'TRANSACTION'
}

export type GQLTransactionProfile = {
  __typename?: 'TransactionProfile';
  additionalPermissions: Maybe<Array<Scalars['String']['output']>>;
  delegateFor: Maybe<Array<Scalars['String']['output']>>;
  externalId: Scalars['ID']['output'];
  hasMetPersonalTransactionLimit: Maybe<Scalars['Boolean']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  role: Maybe<GQLTransactionProfileRoleType>;
  status: GQLTransactionProfileStatusType;
  teamExternalId: Scalars['ID']['output'];
};

export enum GQLTransactionProfileRoleType {
  ADMINISTRATOR = 'ADMINISTRATOR',
  ASSOCIATE_AGENT = 'ASSOCIATE_AGENT',
  BROKER = 'BROKER',
  INTERNAL_USER = 'INTERNAL_USER',
  INTERNAL_USER_ASSOCIATE = 'INTERNAL_USER_ASSOCIATE',
  PARTNER_AGENT = 'PARTNER_AGENT',
  REFERRAL_AGENT = 'REFERRAL_AGENT',
  SUPERVISING_BROKER = 'SUPERVISING_BROKER',
  TEAM_LEAD = 'TEAM_LEAD',
  TRANSACTION_COORDINATOR = 'TRANSACTION_COORDINATOR'
}

export enum GQLTransactionProfileStatusType {
  ACTIVE = 'ACTIVE',
  OFFBOARDING = 'OFFBOARDING',
  ONBOARDING = 'ONBOARDING',
  PROSPECT = 'PROSPECT',
  TERMINATED = 'TERMINATED'
}

export type GQLTransactionQueryInput = {
  id: Scalars['ID']['input'];
  interactionId?: InputMaybe<Scalars['ID']['input']>;
};

export type GQLTransactionReferral = {
  __typename?: 'TransactionReferral';
  amount: Scalars['Float']['output'];
  calculatedAmount: Maybe<Scalars['Float']['output']>;
  description: Maybe<Scalars['String']['output']>;
  externalId: Scalars['ID']['output'];
  externalReferralId: Maybe<Scalars['ID']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  isDeleted: Maybe<Scalars['Boolean']['output']>;
  isPercent: Scalars['Boolean']['output'];
  payee: GQLTransactionParty;
};

export type GQLTransactionReferralInput = {
  amount: Scalars['Float']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['ID']['input']>;
  externalReferralId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isDeleted: Scalars['Boolean']['input'];
  isPercent: Scalars['Boolean']['input'];
  payee: GQLTransactionPartyInput;
};

export enum GQLTransactionSide {
  BUYER = 'BUYER',
  SELLER = 'SELLER'
}

export type GQLTransactionStatementsInput = {
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum GQLTransactionStatus {
  CANCELLED = 'CANCELLED',
  CLOSED = 'CLOSED',
  DELETED = 'DELETED',
  DEMANDS_SENT_TO_ESCROW = 'DEMANDS_SENT_TO_ESCROW',
  INCOMING_REFERRAL = 'INCOMING_REFERRAL',
  LEASE = 'LEASE',
  LISTING_OR_LISTING_SIGNED = 'LISTING_OR_LISTING_SIGNED',
  LISTING_SOLD = 'LISTING_SOLD',
  PENDING_OR_IN_ESCROW = 'PENDING_OR_IN_ESCROW',
  PRE_RESIDE = 'PRE_RESIDE'
}

export type GQLTransactionTeam = GQLTransactionTeamInterface & {
  __typename?: 'TransactionTeam';
  externalId: Scalars['ID']['output'];
  id: Maybe<Scalars['ID']['output']>;
  isFlatFeeTeam: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  parentTeam: Maybe<GQLTransactionParentTeam>;
  profiles: Maybe<Array<GQLTransactionProfile>>;
  subType: Maybe<GQLTransactionTeamSubType>;
  type: GQLTransactionTeamType;
  useSideInstantPay: Scalars['Boolean']['output'];
};


export type GQLTransactionTeamprofilesArgs = {
  input: InputMaybe<GQLTransactionTeamProfilesQueryInput>;
};

export type GQLTransactionTeamInterface = {
  externalId: Scalars['ID']['output'];
  id: Maybe<Scalars['ID']['output']>;
  isFlatFeeTeam: Scalars['Boolean']['output'];
  name: Maybe<Scalars['String']['output']>;
  subType: Maybe<GQLTransactionTeamSubType>;
  type: GQLTransactionTeamType;
  useSideInstantPay: Scalars['Boolean']['output'];
};

export type GQLTransactionTeamPayeesQueryInput = {
  search?: InputMaybe<Scalars['String']['input']>;
};

export type GQLTransactionTeamProfilesQueryInput = {
  includeParentTeam?: InputMaybe<Scalars['Boolean']['input']>;
  includeParentTeamRecursively?: InputMaybe<Scalars['Boolean']['input']>;
  includeSideTCs?: InputMaybe<Scalars['Boolean']['input']>;
  requireLicense?: InputMaybe<Scalars['Boolean']['input']>;
  roles?: InputMaybe<Array<GQLTransactionProfileRoleType>>;
  search: Scalars['String']['input'];
};

export enum GQLTransactionTeamSubType {
  ESCROW = 'ESCROW',
  EXPANSION_MARKET = 'EXPANSION_MARKET',
  EXTENDED_OFFER_CO_BRAND = 'EXTENDED_OFFER_CO_BRAND',
  EXTENDED_OFFER_STANDALONE = 'EXTENDED_OFFER_STANDALONE',
  EXTERNAL_BROKERAGE = 'EXTERNAL_BROKERAGE',
  REAL_ESTATE_SERVICES = 'REAL_ESTATE_SERVICES',
  REFERRAL_COMPANY = 'REFERRAL_COMPANY',
  TRADITIONAL = 'TRADITIONAL'
}

export enum GQLTransactionTeamType {
  BROKERAGE = 'BROKERAGE',
  CUSTOMER = 'CUSTOMER',
  CUSTOMER_LOST = 'CUSTOMER_LOST',
  IN_LAUNCH = 'IN_LAUNCH',
  LAUNCH_ATTRITION = 'LAUNCH_ATTRITION',
  PROSPECT = 'PROSPECT',
  SIDE = 'SIDE',
  VENDOR = 'VENDOR'
}

export type GQLTrsResponseError = {
  __typename?: 'TrsResponseError';
  code: Maybe<Scalars['String']['output']>;
};

export type GQLUpdateAnswerInput = {
  documentId: Scalars['ID']['input'];
  inputId: Scalars['ID']['input'];
  pageId: Scalars['ID']['input'];
  value: Scalars['String']['input'];
};

export type GQLUpdateAnswerPayload = GQLMutationPayload & {
  __typename?: 'UpdateAnswerPayload';
  document: GQLInteractionDocument;
  errors: Maybe<Array<GQLMutationProblem>>;
  input: GQLInput;
  query: Maybe<GQLQuery>;
  status: Maybe<GQLMutationStatus>;
};

export type GQLUpdateAuditInfoInput = {
  acceptanceDate?: InputMaybe<Scalars['String']['input']>;
  additionalBuyingCommissionAmount?: InputMaybe<Scalars['Float']['input']>;
  additionalListingCommissionAmount?: InputMaybe<Scalars['Float']['input']>;
  buyingCommissionAmount?: InputMaybe<Scalars['Float']['input']>;
  buyingCommissionPercentage?: InputMaybe<Scalars['Float']['input']>;
  dualAgency?: InputMaybe<Scalars['Boolean']['input']>;
  expeditedTransaction?: InputMaybe<Scalars['Boolean']['input']>;
  hasHOA?: InputMaybe<Scalars['Boolean']['input']>;
  hasPool?: InputMaybe<Scalars['Boolean']['input']>;
  hasPropane?: InputMaybe<Scalars['Boolean']['input']>;
  hasSepticTank?: InputMaybe<Scalars['Boolean']['input']>;
  hasSolar?: InputMaybe<Scalars['Boolean']['input']>;
  hasWell?: InputMaybe<Scalars['Boolean']['input']>;
  historicalDisclosuresFound?: InputMaybe<Scalars['Boolean']['input']>;
  historicalDisclosuresSent?: InputMaybe<Scalars['Boolean']['input']>;
  isPersonalDeal?: InputMaybe<Scalars['Boolean']['input']>;
  listingCommissionAmount?: InputMaybe<Scalars['Float']['input']>;
  listingCommissionPercentage?: InputMaybe<Scalars['Float']['input']>;
  listingReviewed?: InputMaybe<Scalars['Boolean']['input']>;
  offerReviewed?: InputMaybe<Scalars['Boolean']['input']>;
  tenantOccupied?: InputMaybe<Scalars['Boolean']['input']>;
  yearBuilt?: InputMaybe<Scalars['Int']['input']>;
};

export type GQLUpdateChecklistItemInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type GQLUpdateChecklistItemTemplateV2Input = {
  acceptWhenAutoAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  documentType?: InputMaybe<GQLChecklistItemDocumentType>;
  isTierOneEligible?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  shouldAutoAssign?: InputMaybe<Scalars['Boolean']['input']>;
  shouldValidateTemplate?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GQLUpdateChecklistItemTemplateVersionV2Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  riskLevel?: InputMaybe<GQLRiskLevel>;
};

export type GQLUpdateChecklistTemplateV2Input = {
  locale: Scalars['String']['input'];
};

export type GQLUpdateChecklistTemplateVersionV2Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type GQLUpdateCoverSheetFieldData = {
  name: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type GQLUpdateCoverSheetFieldsInput = {
  entity?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  fields: Array<GQLUpdateCoverSheetFieldData>;
  interactionId: Scalars['String']['input'];
  interactionType: GQLInteractionType;
  representationType?: InputMaybe<GQLLeaseRepresentation>;
};

export type GQLUpdateCoverSheetResponse = {
  __typename?: 'UpdateCoverSheetResponse';
  coverSheet: Maybe<GQLCoverSheet>;
  error: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type GQLUpdateCoversheetInput = {
  data: GQLUpdateCoversheetInputData;
  interactionId: Scalars['ID']['input'];
  interactionType: GQLAuditInteractionType;
};

export type GQLUpdateCoversheetInputData = {
  closingDate?: InputMaybe<Scalars['String']['input']>;
  leaseEndDate?: InputMaybe<Scalars['String']['input']>;
  leasePaymentDate?: InputMaybe<Scalars['String']['input']>;
  leaseStartDate?: InputMaybe<Scalars['String']['input']>;
  leaseTotalRentAmount?: InputMaybe<Scalars['Float']['input']>;
  listingPrice?: InputMaybe<Scalars['Float']['input']>;
  salesPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type GQLUpdateDelegateGroupInput = {
  delegatedToId: Array<Scalars['ID']['input']>;
  permissions: Array<Scalars['String']['input']>;
};

export type GQLUpdateDocTemplateInput = {
  appearsIn?: InputMaybe<Array<GQLDocTemplateAppearsIn>>;
  formLibrary?: InputMaybe<Scalars['String']['input']>;
  formName?: InputMaybe<Scalars['String']['input']>;
  formVersion?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isGlobal?: InputMaybe<Scalars['Boolean']['input']>;
  isReadyForReporting?: InputMaybe<Scalars['Boolean']['input']>;
  listingOrder?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  offerOrder?: InputMaybe<Scalars['Int']['input']>;
  revisionMonth?: InputMaybe<Scalars['Int']['input']>;
  revisionYear?: InputMaybe<Scalars['Int']['input']>;
};

export type GQLUpdateDocTemplateInputInput = {
  applyCommaSeparator?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  docusignXOffset?: InputMaybe<Scalars['Float']['input']>;
  docusignYOffset?: InputMaybe<Scalars['Float']['input']>;
  dropdownOptions?: InputMaybe<Scalars['String']['input']>;
  dropdownPlaceholder?: InputMaybe<Scalars['String']['input']>;
  fontSize?: InputMaybe<Scalars['Float']['input']>;
  formation?: InputMaybe<GQLInitialsGroupFormation>;
  formula?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Array<GQLDocTemplateInputGroupInput>>;
  height?: InputMaybe<Scalars['Float']['input']>;
  image?: InputMaybe<GQLDocTemplatePageInputImageType>;
  initialsGroup?: InputMaybe<Array<GQLInitialsGroupItemInput>>;
  left?: InputMaybe<Scalars['Float']['input']>;
  lineHeight?: InputMaybe<Scalars['Float']['input']>;
  maxLength?: InputMaybe<Scalars['String']['input']>;
  multiline?: InputMaybe<GQLDocTemplateInputGroupInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  optional?: InputMaybe<Scalars['Boolean']['input']>;
  optionalSide?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<GQLDocTemplateInputOptionInput>>;
  recipientId?: InputMaybe<Scalars['String']['input']>;
  reportingName?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  scale?: InputMaybe<Scalars['Float']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  suffix?: InputMaybe<Scalars['String']['input']>;
  tabIndex?: InputMaybe<Scalars['Int']['input']>;
  targetFieldNames?: InputMaybe<Scalars['JSONObject']['input']>;
  textAlign?: InputMaybe<Scalars['String']['input']>;
  textIndent?: InputMaybe<Scalars['Float']['input']>;
  top?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<GQLInputType>;
  typeFace?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type GQLUpdateDocumentInputInput = {
  documentId: Scalars['ID']['input'];
  input: GQLInputInput;
  inputId: Scalars['ID']['input'];
  pageId: Scalars['ID']['input'];
};

export type GQLUpdateDocumentInputPayload = GQLMutationPayload & {
  __typename?: 'UpdateDocumentInputPayload';
  errors: Maybe<Array<GQLMutationProblem>>;
  query: Maybe<GQLQuery>;
  record: Maybe<GQLInteractionDocumentInput>;
  status: Maybe<GQLMutationStatus>;
};

export type GQLUpdateDocumentStatusInput = {
  documentId: Scalars['ID']['input'];
  status: GQLInteractionDocumentStatus;
};

export type GQLUpdateDocumentStatusPayload = GQLMutationPayload & {
  __typename?: 'UpdateDocumentStatusPayload';
  errors: Maybe<Array<GQLMutationProblem>>;
  query: Maybe<GQLQuery>;
  record: GQLInteractionDocument;
  status: Maybe<GQLMutationStatus>;
};

export type GQLUpdateDocumentsEnvelopeOrderInput = {
  /** Document ids in the order in which they should be assigned envelope orders */
  documentIds: Array<Scalars['ID']['input']>;
};

export type GQLUpdateDocumentsEnvelopeOrderPayload = GQLMutationPayload & {
  __typename?: 'UpdateDocumentsEnvelopeOrderPayload';
  errors: Maybe<Array<GQLMutationProblem>>;
  query: Maybe<GQLQuery>;
  status: Maybe<GQLMutationStatus>;
};

export type GQLUpdateDocumentsStatusInput = {
  currentStatus: GQLInteractionDocumentStatus;
  updatedStatus: GQLInteractionDocumentStatus;
};

export type GQLUpdateDocumentsStatusPayload = GQLMutationPayload & {
  __typename?: 'UpdateDocumentsStatusPayload';
  errors: Maybe<Array<GQLMutationProblem>>;
  query: Maybe<GQLQuery>;
  status: Maybe<GQLMutationStatus>;
};

export type GQLUpdateEscrowInput = {
  closingDate: Scalars['String']['input'];
  interactionId: Scalars['ID']['input'];
  interactionType: GQLAuditInteractionType;
};

export type GQLUpdateGoogleContactInput = {
  contactPayload: GQLContactInput;
  interactionId: Scalars['String']['input'];
  interactionType?: InputMaybe<Scalars['String']['input']>;
};

export type GQLUpdateGoogleResponse = {
  __typename?: 'UpdateGoogleResponse';
  contactResponse: Maybe<GQLContactResponse>;
  error: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type GQLUpdateIdentityBrokerageInput = {
  address?: InputMaybe<GQLCreateIdentityUserAddressInput>;
  brokerEmail?: InputMaybe<Scalars['String']['input']>;
  brokerLicenseId?: InputMaybe<Scalars['ID']['input']>;
  brokerPhone?: InputMaybe<Scalars['String']['input']>;
  brokerUserId?: InputMaybe<Scalars['ID']['input']>;
  licenseExpiration?: InputMaybe<Scalars['String']['input']>;
  licenseNumber?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<GQLIdentitySupportedStateCode>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type GQLUpdateIdentityLicenseInput = {
  expiration?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<GQLIdentitySupportedStateCode>;
};

export type GQLUpdateIdentitySignatureInput = {
  file: Scalars['String']['input'];
};

export type GQLUpdateIdentityTeamMemberContactInput = {
  cellPhone?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street1?: InputMaybe<Scalars['String']['input']>;
  street2?: InputMaybe<Scalars['String']['input']>;
  titleNumber?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type GQLUpdateIdentityTeamMemberInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  licenseId?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<InputMaybe<GQLIdentityTeamMemberRoleCode>>>;
};

export type GQLUpdateIdentityTeamMemberPreferencesInput = {
  agentCommission?: InputMaybe<Scalars['String']['input']>;
  docusignCarbonCopy?: InputMaybe<Array<Scalars['String']['input']>>;
  listingPeriod?: InputMaybe<Scalars['String']['input']>;
  mlsServices?: InputMaybe<Array<GQLIdentityTeamMemberPreferenceMlsService>>;
  mlsSubscriptions?: InputMaybe<Array<Scalars['String']['input']>>;
  primaryMLS?: InputMaybe<Scalars['String']['input']>;
  sellingAgentCommission?: InputMaybe<Scalars['String']['input']>;
};

export type GQLUpdateIdentityTeamMutationInput = {
  brokerageId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  doingBusinessAs?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  legacyExternalId?: InputMaybe<Scalars['String']['input']>;
  logoHorizontalUri?: InputMaybe<Scalars['String']['input']>;
  logoHorizontalUriAlt?: InputMaybe<Scalars['String']['input']>;
  logoUri?: InputMaybe<Scalars['String']['input']>;
  logoUriAlt?: InputMaybe<Scalars['String']['input']>;
  mailingAddress?: InputMaybe<GQLCreateIdentityUserAddressInput>;
  mlsId?: InputMaybe<Scalars['String']['input']>;
  mlsOfficeEmail?: InputMaybe<Scalars['String']['input']>;
  nrdsId?: InputMaybe<Scalars['String']['input']>;
  officeManagerUserId?: InputMaybe<Scalars['String']['input']>;
  parentTeamId?: InputMaybe<Scalars['ID']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  registeredAddress?: InputMaybe<GQLCreateIdentityUserAddressInput>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type GQLUpdateIdentityTeamSupervisingBroker = {
  email: Scalars['String']['input'];
  licenseId: Scalars['ID']['input'];
  phone: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type GQLUpdateIdentityUserAccountInfoInput = {
  address?: InputMaybe<GQLCreateIdentityUserAddressInput>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  personalEmail?: InputMaybe<Scalars['String']['input']>;
  primaryPhone?: InputMaybe<Scalars['String']['input']>;
};

export type GQLUpdateIdentityUserAccountInfoPayload = {
  __typename?: 'UpdateIdentityUserAccountInfoPayload';
  error: Maybe<GQLIdentityUserError>;
  record: Maybe<GQLIdentityUser>;
};

export type GQLUpdateIdentityUserAvatarInput = {
  file?: InputMaybe<Scalars['String']['input']>;
  x?: InputMaybe<Scalars['Int']['input']>;
  y?: InputMaybe<Scalars['Int']['input']>;
};

export type GQLUpdateIdentityUserContactInput = {
  isPersonal?: InputMaybe<Scalars['Boolean']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type GQLUpdateIdentityUserInput = {
  address?: InputMaybe<GQLCreateIdentityUserAddressInput>;
  addressId?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  nrdsId?: InputMaybe<Scalars['String']['input']>;
  photoUrl?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<InputMaybe<GQLIdentityUserRoleCode>>>;
  status?: InputMaybe<GQLIdentityUserStatus>;
};

export type GQLUpdateIdentityUserPayload = GQLIdentityUser | GQLIdentityUserError | GQLIdentityUserNotFoundError;

export type GQLUpdateInteractionIsArchivedInput = {
  isArchived: Scalars['Boolean']['input'];
};

export type GQLUpdateInteractionStatusInput = {
  status: GQLInteractionStatus;
};

export type GQLUpdateListingPriceInput = {
  interactionId: Scalars['ID']['input'];
  interactionType: GQLAuditInteractionType;
  listingPrice: Scalars['Float']['input'];
};

export type GQLUpdateOfferOnListingStatusInput = {
  cancellationDetails?: InputMaybe<GQLOfferOnListingCancellationDetails>;
  offerId: Scalars['String']['input'];
  status: GQLOfferStatus;
};

export type GQLUpdateOutsideBrokerageInput = {
  accountingSupplierId?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<GQLFullAddressInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type GQLUpdatePaymentTeamInput = {
  isInstantPayEligible?: InputMaybe<Scalars['Boolean']['input']>;
  useAutoSendStatements?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GQLUpdatePaymentTeamMemberInput = {
  isInstantPayEligible?: InputMaybe<Scalars['Boolean']['input']>;
  licenseTerminationDate?: InputMaybe<Scalars['String']['input']>;
};

export type GQLUpdatePaymentTeamMemberPermissionsInput = {
  permissions?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GQLUpdateReferralAgentInput = {
  broker?: InputMaybe<GQLInteractionContactGeneralInput>;
  brokerage?: InputMaybe<GQLBrokerageInput>;
  cellPhone?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  googleContactId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  licenseNumber?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  supervisingBroker?: InputMaybe<GQLInteractionContactGeneralInput>;
  teamId?: InputMaybe<Scalars['String']['input']>;
  teamName?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type GQLUpdateReferralClientInput = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  cellPhone?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  clientTypes?: InputMaybe<Array<GQLReferralClientType>>;
  contactSource?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  entity?: InputMaybe<GQLOwnershipInput>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  googleContactId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street1?: InputMaybe<Scalars['String']['input']>;
  street2?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type GQLUpdateReferralInput = {
  client?: InputMaybe<GQLUpdateReferralClientInput>;
  commissionType?: InputMaybe<GQLReferralCommissionType>;
  commissionValue?: InputMaybe<Scalars['Float']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  primaryAgent?: InputMaybe<GQLUpdateReferralPrimaryAgentInput>;
  secondaryAgent?: InputMaybe<GQLUpdateReferralSecondaryAgentInput>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  teamId?: InputMaybe<Scalars['String']['input']>;
};

export type GQLUpdateReferralPrimaryAgentInput = {
  id: Scalars['ID']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  teamId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type GQLUpdateReferralSecondaryAgentInput = {
  broker?: InputMaybe<GQLInteractionContactGeneralInput>;
  brokerage?: InputMaybe<GQLBrokerageInput>;
  cellPhone?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  googleContactId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  licenseNumber?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  supervisingBroker?: InputMaybe<GQLInteractionContactGeneralInput>;
  teamId?: InputMaybe<Scalars['String']['input']>;
  teamName?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type GQLUpdateSalesPriceInput = {
  interactionId: Scalars['ID']['input'];
  interactionType: GQLAuditInteractionType;
  salesPrice: Scalars['Float']['input'];
};

export type GQLUpdateSettlementContactInput = {
  contact: GQLSettlementContactV2UpdateInput;
};

export type GQLUpdateTemplateCategoryV2Input = {
  isSystem?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sortPriority?: InputMaybe<Scalars['Int']['input']>;
  transactionPhase?: InputMaybe<GQLTransactionPhase>;
};

export type GQLUpdateTemplateRuleV2Input = {
  definition?: InputMaybe<GQLRuleDefinitionUpdateInput>;
  documentProcessor?: InputMaybe<GQLRuleDocumentProcessor>;
  itemVersionId?: InputMaybe<Scalars['ID']['input']>;
  multiDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pagesRange?: InputMaybe<Array<Scalars['PageRange']['input']>>;
  templateVersionId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<GQLRuleType>;
};

export type GQLUpdateTransactionInput = {
  allocations: Array<GQLTransactionAllocationInput>;
  coBrokerageFees: Array<GQLTransactionFeeInput>;
  commissionLeadSource?: InputMaybe<GQLTransactionCommissionLeadSource>;
  fees: Array<GQLTransactionFeeInput>;
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  referrals: Array<GQLTransactionReferralInput>;
  settlementContact?: InputMaybe<GQLSettlementContactInput>;
  submissionType: GQLSubmissionType;
};

/**
 * Transaction permissions are relative to the user at the root of the mutation
 * CORE POST user-settings/:rootUserId/permissions [:targetUserId]
 * CORE POST user-settings/:rootUserId/permissions [:targetUserId]
 */
export type GQLUpdateTransactionPermissionsUserInput = {
  submitAs?: InputMaybe<Scalars['Boolean']['input']>;
  transactionSharing?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GQLUploadDocTemplateVersionFilePayload = {
  __typename?: 'UploadDocTemplateVersionFilePayload';
  file: GQLDocTemplateVersionFile;
  uploadUrl: Scalars['String']['output'];
};

export type GQLUploadOfferOnListingContractInput = {
  name: Scalars['String']['input'];
};

export enum GQLUploadStatus {
  completed = 'completed',
  created = 'created',
  failed = 'failed',
  processing = 'processing',
  uploading = 'uploading'
}

export enum GQLUserPaymentStatus {
  COMPLETE = 'COMPLETE',
  INCOMPLETE = 'INCOMPLETE',
  NOT_REQUIRED = 'NOT_REQUIRED'
}

export type GQLUserTemplate = GQLInteraction & GQLNode & {
  __typename?: 'UserTemplate';
  /** @deprecated Not implemented */
  acceptedOfferId: Maybe<Scalars['String']['output']>;
  /** @deprecated Not implemented */
  basicContacts: Maybe<Array<GQLBasicInteractionContactResponse>>;
  /** @deprecated Not implemented */
  bindingAgreementDate: Maybe<Scalars['String']['output']>;
  /** @deprecated Not implemented */
  closingDate: Maybe<Scalars['String']['output']>;
  /** @deprecated Not implemented */
  contactSuggestion: GQLContactSuggestion;
  /**
   * A paginated list of contacts associated with the template.
   * @deprecated Not implemented
   */
  contacts: Maybe<Array<Maybe<GQLInteractionContact>>>;
  /** @deprecated Not implemented */
  contractDate: Maybe<Scalars['String']['output']>;
  /** @deprecated Not implemented */
  coverPhotoFileId: Maybe<Scalars['String']['output']>;
  /** @deprecated Not implemented */
  coverPhotoUrl: Maybe<Scalars['String']['output']>;
  /** @deprecated Not implemented */
  displayPrice: Maybe<Scalars['Float']['output']>;
  /** @deprecated Not implemented */
  displayStatus: GQLInteractionStatus;
  document: Maybe<GQLInteractionDocument>;
  /** @deprecated Not implemented */
  documentPreview: GQLInteractionDocument;
  /**
   * The list of documents for the UserTemplate
   * with optional filters by status
   */
  documents: Maybe<GQLInteractionDocumentsConnection>;
  /**
   * Get an Envelope for a UserTemplate
   * @deprecated Not implemented
   */
  envelope: Maybe<GQLEnvelope>;
  /**
   * Get a list of Envelopes for a UserTemplate
   * @deprecated Not implemented
   */
  envelopes: Maybe<Array<Maybe<GQLEnvelope>>>;
  id: Scalars['ID']['output'];
  /** @deprecated Not implemented */
  isArchived: Scalars['Boolean']['output'];
  /** @deprecated Not implemented */
  isIntermediary: Scalars['Boolean']['output'];
  /** @deprecated Not implemented */
  listingEndDate: Maybe<Scalars['String']['output']>;
  /** @deprecated Not implemented */
  listingStartDate: Maybe<Scalars['String']['output']>;
  /** @deprecated Not implemented */
  onMarketDate: Maybe<Scalars['String']['output']>;
  /** @deprecated Not implemented */
  owner: Scalars['String']['output'];
  /** @deprecated Not implemented */
  property: Maybe<GQLPropertyAddress>;
  /**
   * Get a list of Envelopes in a Sent state (with status `partiallySigned`, `voided`, `completed`, `created`, `sent`, or `sending`)
   * @deprecated Not implemented
   */
  sentEnvelopes: Maybe<Array<Maybe<GQLEnvelope>>>;
  /** @deprecated Not implemented */
  sidebarUi: GQLInteractionSidebarItemsConnection;
  /**
   * The account preference contact for syncing
   * @deprecated Not implemented
   */
  syncContact: Maybe<GQLInteractionDefaultContact>;
  /** @deprecated Not implemented */
  teamId: Maybe<Scalars['String']['output']>;
  /** @deprecated Not implemented */
  transactions: Array<GQLTransaction>;
};


export type GQLUserTemplatecontactSuggestionArgs = {
  input: GQLInteractionContactSuggestionInput;
};


export type GQLUserTemplatecontactsArgs = {
  input: InputMaybe<GQLInteractionContactsInput>;
};


export type GQLUserTemplatedocumentArgs = {
  id: Scalars['ID']['input'];
};


export type GQLUserTemplatedocumentPreviewArgs = {
  documentVersionId: Scalars['ID']['input'];
};


export type GQLUserTemplatedocumentsArgs = {
  input: InputMaybe<GQLInteractionDocumentsInput>;
};


export type GQLUserTemplateenvelopeArgs = {
  input: GQLGetEnvelopeInput;
};


export type GQLUserTemplateenvelopesArgs = {
  input: InputMaybe<GQLGetEnvelopesInput>;
};


export type GQLUserTemplatesentEnvelopesArgs = {
  input: InputMaybe<GQLGetEnvelopesInput>;
};


export type GQLUserTemplatesyncContactArgs = {
  input: GQLInteractionSyncContactInput;
};

export type GQLValidationCheck = {
  __typename?: 'ValidationCheck';
  isValid: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
  value: Maybe<Scalars['String']['output']>;
};

export enum GQLVersionStatus {
  draft = 'draft',
  published = 'published'
}

export type GQLViewer = {
  __typename?: 'Viewer';
  displayName: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

export type GQLYearToDate = {
  __typename?: 'YearToDate';
  gross: Scalars['Float']['output'];
  net: Maybe<Scalars['Float']['output']>;
  salesVolume: Scalars['Float']['output'];
};


      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "AuditJob": [
      "DownloadAuditDocumentsJob"
    ],
    "Auditable": [
      "CommissionNotification",
      "CommissionNotificationRecipient",
      "DelegateGroup",
      "DelegateGroupHistory",
      "DelegateGroupPermission",
      "DelegateGroupRelation",
      "History",
      "TeamMemberHistory"
    ],
    "CommissionParty": [
      "CommissionTeam",
      "CommissionTeamMember"
    ],
    "Connection": [
      "ChecklistItemTemplateV2Connection",
      "ChecklistTemplateV2Connection",
      "ChecklistTemplatesDraftsV2Connection",
      "EnvelopeDocumentsConnection",
      "InteractionDocumentsConnection"
    ],
    "ConnectionResult": [
      "ChecklistItemTemplateListV2Result",
      "ChecklistTemplateListV2Result",
      "ChecklistTemplatesDraftsV2Result"
    ],
    "CursorPaginationResponse": [
      "InteractionPermissionSubmitAsTeamMembersResponse",
      "InteractionPermissionSubmitAsUserResponse",
      "InteractionPermissionTransactionSharingTeamMembersResponse",
      "InteractionPermissionTransactionSharingUsersResponse"
    ],
    "Edge": [
      "ChecklistItemTemplateV2Edge",
      "ChecklistTemplateDraftsV2Edge",
      "ChecklistTemplateV2Edge",
      "EnvelopeDocumentsEdge",
      "InteractionDocumentsEdge"
    ],
    "ErrorPayload": [
      "IdentityAddressNotFoundError",
      "IdentityLicenseDuplicateError",
      "IdentityLicenseExpiredError",
      "IdentityLicenseIsAssociatedError",
      "IdentityLicenseNotFoundError",
      "IdentityLicenseUnsupportedStateError",
      "IdentityOrganizationError",
      "IdentityTeamMemberNotFoundError",
      "IdentityTeamNotFoundError",
      "IdentityUserContactDeletePrimaryError",
      "IdentityUserContactNotFoundError",
      "IdentityUserNotFoundError"
    ],
    "IdentityBrokerageTeamDeleteError": [
      "IdentityBrokerageError"
    ],
    "IdentityCreateTeamMemberError": [
      "IdentityTeamMemberError"
    ],
    "IdentityCreateUserContactError": [
      "IdentityContactError"
    ],
    "IdentityLicensePayload": [
      "IdentityLicense",
      "IdentityLicenseError",
      "IdentityLicenseNotFoundError"
    ],
    "IdentityOrganizationPayload": [
      "IdentityOrganization",
      "IdentityOrganizationError"
    ],
    "IdentityTeamMemberDeleteErrorPayload": [
      "IdentityTeamMemberDeleteError",
      "IdentityTeamMemberNotFoundError"
    ],
    "IdentityTeamPayload": [
      "IdentityTeam",
      "IdentityTeamError",
      "IdentityTeamNotFoundError"
    ],
    "IdentityUpdateTeamMemberPayloadError": [
      "IdentityTeamMemberNotFoundError",
      "IdentityTeamMemberUpdateError"
    ],
    "IdentityUpdateUserContactError": [
      "IdentityContactError"
    ],
    "IdentityUserContactDeleteErrorPayload": [
      "IdentityUserContactDeleteError",
      "IdentityUserContactDeletePrimaryError",
      "IdentityUserContactNotFoundError"
    ],
    "IdentityUserLicenseAddNewErrorPayload": [
      "IdentityLicenseDuplicateError",
      "IdentityLicenseError"
    ],
    "IdentityUserLicenseDeleteErrorPayload": [
      "IdentityLicenseDeleteError",
      "IdentityLicenseIsAssociatedError",
      "IdentityLicenseNotFoundError",
      "IdentityUserNotFoundError"
    ],
    "IdentityUserLicenseUpdateErrorPayload": [
      "IdentityLicenseDuplicateError",
      "IdentityLicenseError",
      "IdentityLicenseExpiredError",
      "IdentityLicenseIsAssociatedError",
      "IdentityLicenseNotFoundError"
    ],
    "IdentityUserPayload": [
      "IdentityUser",
      "IdentityUserError",
      "IdentityUserNotFoundError"
    ],
    "Interaction": [
      "ClientGroup",
      "Lease",
      "Listing",
      "Offer",
      "Referral",
      "UserTemplate"
    ],
    "InteractionContact": [
      "InteractionContactAgent",
      "InteractionContactOther"
    ],
    "InteractionContactBase": [
      "InteractionContactAgent",
      "InteractionContactOther"
    ],
    "MutationPayload": [
      "AddDocumentsForUploadToInteractionPayload",
      "AddDocumentsToInteractionPayload",
      "AddInputPayload",
      "AdjustmentMutationPayload",
      "CoListMutationPayload",
      "CreateEnvelopeMutationPayload",
      "CreateOfferFromUploadedPayload",
      "DelegateGroupPayload",
      "DeleteDocumentInputPayload",
      "DeleteDocumentPayload",
      "DeleteDocumentsByStatusPayload",
      "DownloadDocumentsMutationPayload",
      "DownloadEnvelopeMutationPayload",
      "DownloadPreviewDocumentMutationPayload",
      "DuplicateDocumentPayload",
      "FinalizeTransactionPayload",
      "ForwardDocumentByIdMutationPayload",
      "ForwardDocumentsMutationPayload",
      "ForwardEnvelopeMutationPayload",
      "GenerateFileUploadUrlsPayload",
      "GenerateOfferMutationPayload",
      "IdentityCreateAddressPayload",
      "IdentityUpdateUserSignaturePayload",
      "InstallmentMutationPayload",
      "OfferOnListingContractUploadPayload",
      "OutsideBrokerageCreatePayload",
      "OutsideBrokerageUpdatePayload",
      "PaymentTeamMemberPayload",
      "RegenerateStatementsPayload",
      "SettlementCompanyUpdatePayload",
      "SettlementContactMutationPayload",
      "SettlementContactUpdatePayload",
      "TeamUpdatePayload",
      "TransactionMutationPayload",
      "UpdateAnswerPayload",
      "UpdateDocumentInputPayload",
      "UpdateDocumentStatusPayload",
      "UpdateDocumentsEnvelopeOrderPayload",
      "UpdateDocumentsStatusPayload"
    ],
    "MutationProblem": [
      "GenericProblem",
      "IdentityCreateAddressError",
      "IdentitySignatureError"
    ],
    "NeedsAttentionItem": [
      "BuyerAgreementsAttentionItem",
      "CommissionFormAttentionItem",
      "ComplianceReviewAttentionItem",
      "EnvelopesAttentionItem",
      "ListingAgreementsAttentionItem"
    ],
    "Node": [
      "Adjustment",
      "AdminTransaction",
      "ChecklistItemTemplateV2",
      "ChecklistItemTemplateVersionV2",
      "ChecklistTemplateDraft",
      "ChecklistTemplateV2",
      "ChecklistTemplateVersionV2",
      "ClientGroup",
      "Commission",
      "CommissionAllocation",
      "CommissionNotification",
      "CommissionNotificationRecipient",
      "CommissionTeam",
      "CommissionTeamMember",
      "DelegateGroup",
      "DelegateGroupHistory",
      "DelegateGroupPermission",
      "DelegateGroupRelation",
      "History",
      "IdentityAddress",
      "IdentityBroker",
      "IdentityBrokerage",
      "IdentityContact",
      "IdentityLicense",
      "IdentityLogin",
      "IdentityTeam",
      "IdentityTeamLocation",
      "IdentityTeamMember",
      "IdentityUser",
      "InteractionDocument",
      "InteractionEnvelope",
      "Lease",
      "Listing",
      "Offer",
      "OutsideBrokerage",
      "PartyPermission",
      "PaymentTeamMember",
      "Referral",
      "SettlementCompany",
      "SettlementContactV2",
      "SettlementContactV2Commission",
      "TeamMemberHistory",
      "TemplateCategoryV2",
      "TemplateRuleV2",
      "UserTemplate"
    ],
    "NodeErrorPayload": [
      "ChecklistItemTemplateListV2Error",
      "ChecklistItemTemplateV2Error",
      "ChecklistItemTemplateVersionV2Error",
      "ChecklistTemplateListV2Error",
      "ChecklistTemplateV2Error",
      "ChecklistTemplateVersionV2Error",
      "ChecklistTemplatesDraftsV2Error",
      "FeatureFlagEvaluationError",
      "TemplateCategoryListV2Error",
      "TemplateCategoryV2Error",
      "TemplateRuleV2Error"
    ],
    "NodeResult": [
      "ChecklistItemTemplateV2Result",
      "ChecklistItemTemplateVersionV2Result",
      "ChecklistTemplateV2Result",
      "ChecklistTemplateVersionV2Result",
      "DeleteChecklistTemplateVersionV2Result",
      "TemplateCategoryV2Result",
      "TemplateRuleV2Result"
    ],
    "PaginationResponse": [
      "AdminTransactionsPaginationResult",
      "CommissionNotificationsPaginationResult",
      "CommissionsPaginationResult",
      "DelegateGroupHistoryPaginationResult",
      "DelegateGroupPaginationResult",
      "HistoryPaginationResult",
      "InteractionsPaginationResult",
      "ListingsPaginationResult",
      "OffersPaginationResult",
      "OutsideBrokeragePaginationResult",
      "SettlementCompaniesPaginationResult",
      "SettlementContactsPaginationResult",
      "TeamMemberHistoryPaginationResult",
      "TeamMembersV2PaginationResult",
      "TeamsV2Response"
    ],
    "RetryableErrorPayload": [
      "IdentityAddTeamMemberContactError",
      "IdentityAddressError",
      "IdentityAssociatedTeamMembersError",
      "IdentityBrokerageError",
      "IdentityContactError",
      "IdentityLicenseDeleteError",
      "IdentityLicenseError",
      "IdentityMeError",
      "IdentityTeamError",
      "IdentityTeamMemberDeleteError",
      "IdentityTeamMemberError",
      "IdentityTeamMemberUpdateError",
      "IdentityTeamMembersError",
      "IdentityTeamSupervisingBrokerError",
      "IdentityUpdateTeamMemberContactError",
      "IdentityUpdateTeamMemberPreferencesError",
      "IdentityUserContactDeleteError",
      "IdentityUserError",
      "IdentityUserTeamMembersError",
      "LobAutocompleteError"
    ],
    "RunnerResponse": [
      "CreateRunnerResponseData",
      "DownloadRunnerResponseData"
    ],
    "SidebarItem": [
      "SidebarLink"
    ],
    "TransactionTeamInterface": [
      "TransactionParentTeam",
      "TransactionTeam"
    ],
    "UpdateIdentityUserPayload": [
      "IdentityUser",
      "IdentityUserError",
      "IdentityUserNotFoundError"
    ]
  }
};
      export default result;
    